var _defs, _style, _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g2, _path20, _path21, _path22, _g3, _g4, _g5, _g6, _g7, _path23, _path24, _path25, _g8, _g9, _g10, _g11, _g12, _path26, _path27, _g13, _g14, _g15, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _g88, _g89, _path61, _path62, _path63, _path64, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134, _g135, _g136, _g137, _g138, _g139, _g140, _g141, _g142, _g143, _g144, _g145, _g146, _g147, _g148, _g149, _g150, _g151, _g152, _g153, _g154, _g155, _g156, _g157, _g158, _g159, _g160, _g161, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _g162, _g163, _g164, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _g165, _path98, _g166, _g167, _path99, _path100, _g168, _path101, _path102, _path103, _path104, _g169, _g170, _path105, _path106, _g171, _g172, _path107, _path108, _g173, _path109, _path110, _g174, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _g175, _g176, _path130, _path131, _path132, _path133, _g177, _g178, _g179, _path134, _g180, _path135, _path136, _path137, _path138, _g181, _g182, _path139, _g183, _g184, _path140, _path141, _g185, _g186, _path142, _path143, _g187, _path144, _path145, _g188, _path146, _g189, _g190, _path147, _g191, _path148, _path149, _g192, _g193, _path150, _path151, _path152, _path153, _path154, _path155, _g194, _g195, _path156, _path157, _path158, _path159, _g196, _g197, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _g198, _path167, _g199, _path168, _g200, _path169, _path170, _path171, _path172, _g201, _path173, _g202, _path174, _path175, _g203, _path176, _path177, _g204, _path178, _path179, _path180, _g205, _path181, _path182, _g206, _path183, _path184, _g207, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _g208, _path201, _path202, _g209, _g210, _path203, _path204, _g211, _g212, _g213, _path205, _g214, _g215, _g216, _g217, _g218, _g219, _g220, _g221, _path206, _path207, _g222, _g223, _g224, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _g225, _path220, _path221, _g226, _g227, _g228, _g229, _path222, _path223, _path224, _g230, _g231, _path225, _path226, _g232, _path227, _path228, _g233, _path229, _path230, _path231, _g234, _g235, _path232, _path233, _g236, _g237, _g238, _path234, _path235, _path236, _g239, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _g240, _g241, _g242, _g243, _g244, _path244, _path245, _g245, _path246, _path247, _path248, _path249, _g246, _path250, _path251, _g247, _g248, _g249, _path252, _path253, _path254, _path255, _g250, _g251, _g252, _g253, _g254, _g255, _path256, _path257, _g256, _g257, _g258, _g259, _g260, _path258, _path259, _path260, _g261, _g262, _g263, _g264, _g265;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftBike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 386 283",
    width: 386,
    height: 283,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-752-2555h1366v3181h-1366z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m321.7 41.66h16.14v15.38h-16.14z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m237.04 189h74.93v50.77h-74.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m129.19 111.13h1.21v6.76h-1.21z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m130.23 112.21h0.15v0.98h-0.15z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m132.04 110.1h3.81v8.48h-3.81z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m133.81 105.53h13.64v13.14h-13.64z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m130.09 111.33h2.7v7.2h-2.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m145.34 100.01h21.69v5.51h-21.69z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m169.28 74.32h7.14v27.23h-7.14z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m145.75 73.82h38.38v38.83h-38.38z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m146.51 111.5h1.71v1.04h-1.71z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m148.24 73.82h35.89v38.83h-35.89z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m205.45 97.78h43.89v45.94h-43.89z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m204.76 86.01h60.91v59.83h-60.91z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m205.2 85.46h60.47v11.03h-60.47z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m71.98 210.28l6.87-11.73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g1",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.615,8.911,-8.911,-17.615,58.588,196.515)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m71.72 210.12l0.52 0.31 6.87-11.73-0.52-0.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g2",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.63,8.918,-8.918,-17.63,58.279,196.073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m78.21 210.33l-6.66-11.85z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g3",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.582,8.894,-8.894,-17.582,57.921,196.222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m71.28 198.63l6.66 11.85 0.53-0.3-6.66-11.85z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g4",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.65,8.928,-8.928,-17.65,57.143,196.134)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m75.07 209.65l10.47-8.66z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g5",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.398,8.8,-8.8,-17.398,68.384,200.552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m74.87 209.41l10.49-8.65 0.38 0.47-10.49 8.64z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g6",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.565,8.885,-8.885,-17.565,67.382,200.399)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m80.91 211.84l-2.21-13.42z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g7",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.662,8.934,-8.934,-17.662,69.789,197.889)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m78.4 198.47l0.59-0.1 2.22 13.42-0.6 0.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g8",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.606,8.906,-8.906,-17.606,69.346,197.756)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m78.19 210.12l12.8-4.56z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g9",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.5,8.852,-8.852,-17.5,77.938,210.491)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m78.08 209.84l0.21 0.57 12.8-4.57-0.2-0.56z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g10",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.569,8.887,-8.887,-17.569,77.327,209.158)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m82.92 214.18l2.51-13.37z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g11",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.582,8.894,-8.894,-17.582,78.086,202.388)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m82.63 214.12l0.59 0.11 2.51-13.36-0.59-0.11z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g12",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.617,8.911,-8.911,-17.617,76.927,202.254)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m94.54 211.72l-13.59-0.08z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g13",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.416,8.81,-8.81,-17.416,88.432,228.011)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m80.95 211.94l13.59 0.09v-0.6l-13.59-0.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g14",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.602,8.904,-8.904,-17.602,86.936,226.019)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m84.02 217.06l6.93-11.69z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g15",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.642,8.924,-8.924,-17.642,81.835,209.355)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m83.76 216.91l0.52 0.3 6.93-11.7-0.52-0.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g16",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.686,8.946,-8.946,-17.686,81.092,209.254)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m95.78 218.74l-12.75-4.74z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g17",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.642,8.924,-8.924,-17.642,86.342,225.598)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m82.93 214.29l12.75 4.73 0.21-0.57-12.75-4.73z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g18",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.594,8.9,-8.9,-17.594,85.641,225.198)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m84.06 220.15l10.52-8.62z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g19",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.689,8.948,-8.948,-17.689,84.319,221.169)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m83.87 219.91l0.38 0.47 10.52-8.62-0.39-0.47z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g20",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.64,8.923,-8.923,-17.64,83.57,220.037)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m94.54 225.74l-10.36-8.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g21",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.675,8.941,-8.941,-17.675,84.316,230.765)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m83.99 217.17l10.36 8.8 0.39-0.45-10.36-8.81z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g22",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.623,8.915,-8.915,-17.623,83.465,230.293)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m83.05 223.06l12.82-4.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g23",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.741,8.974,-8.974,-17.741,86.315,234.785)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m82.95 222.78l12.83-4.5 0.2 0.57-12.83 4.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g24",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.793,9,-9,-17.793,85.561,233.22)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.98 231.91l-6.72-11.82z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g25",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.629,8.918,-8.918,-17.629,79.93,238.16)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m84 220.24l0.52-0.3 6.72 11.81-0.52 0.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g26",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.655,8.931,-8.931,-17.655,80.051,236.792)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m94.69 225.61l-13.6-0.16z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g27",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.381,8.792,-8.792,-17.381,88.805,249.945)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m81.09 225.76l13.59 0.16 0.01-0.61-13.59-0.16z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g28",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.586,8.896,-8.896,-17.586,88.039,248.282)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m85.53 236.48l-2.28-13.4z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g29",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.625,8.915,-8.915,-17.625,72.209,246.186)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m82.96 223.13l0.59-0.1 2.27 13.4-0.59 0.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g30",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.614,8.91,-8.91,-17.614,72.054,245.602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m91.16 231.83l-12.71-4.79z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g31",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.604,8.905,-8.905,-17.604,78.478,248.946)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m78.34 227.32l12.72 4.79 0.22-0.56-12.73-4.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g32",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.606,8.906,-8.906,-17.606,77.804,247.29)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m78.84 238.91l2.44-13.38z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g33",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.586,8.896,-8.896,-17.586,61.935,251.164)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m78.54 238.86l0.6 0.1 2.45-13.37-0.6-0.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g34",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.627,8.917,-8.917,-17.627,62.12,251.215)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m85.72 236.47l-10.31-8.86z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g35",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.657,8.931,-8.931,-17.657,67.375,250.095)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m75.22 227.85l10.31 8.85 0.39-0.45-10.31-8.86z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g36",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.633,8.919,-8.919,-17.633,67.054,249.386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m71.72 238.91l6.87-11.73z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g37",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.622,8.914,-8.914,-17.622,53.929,251.254)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m71.48 238.77l6.83-11.75 0.53 0.3-6.84 11.75z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g38",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.616,8.911,-8.911,-17.616,54.434,250.023)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m79.02 238.97l-6.65-11.85z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g39",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.56,8.883,-8.883,-17.56,55.828,250.728)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m72.1 227.27l6.66 11.85 0.53-0.29-6.66-11.85z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g40",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.518,8.861,-8.861,-17.518,54.862,251.222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp57"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m65.03 236.47l10.47-8.67z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g41",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.587,8.896,-8.896,-17.587,48.943,248.951)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.84 236.23l0.38 0.47 10.48-8.67-0.39-0.46z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g42",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.609,8.907,-8.907,-17.609,48.251,248.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m71.88 239.03l-2.21-13.41z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g43",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.596,8.901,-8.901,-17.596,41.588,252.845)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m69.37 225.67l2.21 13.41 0.59-0.09-2.2-13.42z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g44",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.593,8.899,-8.899,-17.593,42.082,251.58)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m59.58 231.89l12.81-4.56z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g45",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.633,8.919,-8.919,-17.633,47.071,246.202)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m59.49 231.61l0.2 0.57 12.8-4.57-0.2-0.56z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g46",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.619,8.912,-8.912,-17.619,46.449,245.457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m65.14 236.64l2.51-13.36z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g47",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.618,8.912,-8.912,-17.618,33.31,247.802)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.84 236.59l0.6 0.11 2.51-13.36-0.6-0.11z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g48",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.598,8.902,-8.902,-17.598,33.255,247.159)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m69.62 225.82l-13.59-0.09z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g49",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.618,8.912,-8.912,-17.618,51.533,244.133)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m56.03 226.03l13.59 0.09 0.01-0.6-13.6-0.09z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g50",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.615,8.911,-8.911,-17.615,49.68,243.086)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m59.62 232.08l6.93-11.68z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g51",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.612,8.909,-8.909,-17.612,31.219,238.006)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m59.36 231.93l0.52 0.32 6.94-11.7-0.52-0.31z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g52",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.634,8.92,-8.92,-17.634,30.644,238.002)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m67.54 223.45l-12.75-4.73z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g53",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.622,8.914,-8.914,-17.622,39.116,229.824)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m54.69 219l12.74 4.74 0.21-0.57-12.74-4.73z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g54",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.619,8.912,-8.912,-17.619,37.636,229.523)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m56 225.92l10.51-8.61z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g55",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.613,8.909,-8.909,-17.613,33.605,228.679)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m55.81 225.7l0.38 0.46 10.51-8.62-0.38-0.47z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g56",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.617,8.912,-8.912,-17.617,32.04,228.865)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m66.39 220.52l-10.36-8.81z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g57",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.6,8.903,-8.903,-17.6,32.507,218.865)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m55.84 211.94l0.39-0.46 10.36 8.81-0.4 0.46z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g58",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.621,8.914,-8.914,-17.621,31.735,218.214)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m54.7 218.9l12.83-4.51z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g59",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.593,8.899,-8.899,-17.593,39.213,222.43)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp76"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m54.59 218.58l12.85-4.44 0.19 0.57-12.85 4.44z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g60",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.613,8.91,-8.91,-17.613,37.936,221.491)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp77"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m66.32 217.37l-6.73-11.82z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g61",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.358,8.781,-8.781,-17.358,33.706,209.508)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m59.33 205.7l6.72 11.82 0.53-0.3-6.72-11.82z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g62",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.669,8.938,-8.938,-17.669,33.055,208.579)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m69.48 212l-13.6-0.16z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g63",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.683,8.945,-8.945,-17.683,50.279,221.854)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m55.88 212.15v-0.61l13.6 0.16-0.01 0.6z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g64",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.618,8.912,-8.912,-17.618,49.007,219.958)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp81"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m67.32 214.38l-2.27-13.4z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g65",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.66,8.933,-8.933,-17.66,39.132,203.937)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.75 201.03l2.27 13.4 0.6-0.1-2.28-13.4z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g66",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.616,8.911,-8.911,-17.616,38.546,204.065)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m72.13 210.42l-12.72-4.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g67",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.592,8.899,-8.899,-17.592,46.017,208.126)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp84"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m59.3 205.9l12.72 4.8 0.21-0.57-12.71-4.79z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g68",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.605,8.905,-8.905,-17.605,45.11,207.149)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp85"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m69.29 211.92l2.44-13.38z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g69",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.618,8.912,-8.912,-17.618,50.067,198.391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m68.99 211.86l0.6 0.11 2.44-13.37-0.59-0.11z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g70",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.637,8.922,-8.922,-17.637,49.402,198.107)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m75.16 209.84l-10.31-8.86z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g71",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.603,8.904,-8.904,-17.603,49.546,200.07)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.65 201.21l10.31 8.86 0.4-0.46-10.31-8.86z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g72",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.602,8.904,-8.904,-17.602,48.627,198.595)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp89"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49.7 192.7h44.94v44.62h-44.94z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m77.21 194.18c6.75 0.06 12.87 2.71 17.43 7-4.67-5.15-11.39-8.42-18.89-8.48-14.26-0.13-25.92 11.32-26.04 25.57-0.07 7.51 3.07 14.29 8.14 19.05-4.2-4.64-6.74-10.81-6.68-17.56 0.13-14.25 11.78-25.71 26.04-25.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g73",
    x2: 1,
    href: "#P",
    gradientTransform: "matrix(.422,-0.528,.529,.423,102.435,270.079)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#99999a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp91"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m54.53 191.46h48.06v35.54h-48.06z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m234.19 211.74l6.87-11.73z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g74",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.613,8.91,-8.91,-17.613,192.993,211.811)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m233.93 211.58l0.52 0.31 6.87-11.73-0.52-0.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g75",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.624,8.915,-8.915,-17.624,194.289,210.566)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m240.42 211.8l-6.66-11.85z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g76",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.598,8.902,-8.902,-17.598,191.812,211.763)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m233.5 200.09l6.66 11.86 0.52-0.31-6.66-11.84z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g77",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.64,8.923,-8.923,-17.64,192.685,210.858)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m237.28 211.12l10.47-8.67z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g78",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.39,8.796,-8.796,-17.39,209.306,212.529)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m237.1 210.9l10.45-8.69 0.39 0.46-10.46 8.69z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g79",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.561,8.883,-8.883,-17.561,209.108,211.98)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp98"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m243.12 213.3l-2.21-13.42z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g80",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.663,8.935,-8.935,-17.663,184.734,223.008)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m240.61 199.94l2.21 13.41 0.6-0.1-2.21-13.41z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g81",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.61,8.908,-8.908,-17.61,188.585,220.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m240.4 211.59l12.8-4.56z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g82",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.489,8.847,-8.847,-17.489,221.437,221.097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp101"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m240.29 211.31l0.21 0.57 12.8-4.57-0.2-0.57z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g83",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.568,8.887,-8.887,-17.568,221.218,219.576)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp102"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m245.14 215.64l2.51-13.36z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g84",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.578,8.892,-8.892,-17.578,195.065,226.485)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m244.84 215.58l2.52-13.35 0.59 0.11-2.52 13.35z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g85",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.62,8.913,-8.913,-17.62,197.885,224.339)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256.75 213.19l-13.58-0.09z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g86",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.418,8.811,-8.811,-17.418,232.457,238.148)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m243.16 213.4l0.01-0.6 13.59 0.09-0.01 0.6z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g87",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.602,8.904,-8.904,-17.602,231,236.172)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp106"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m246.23 218.53l6.94-11.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g88",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.642,8.924,-8.924,-17.642,216.393,224.569)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp107"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m245.97 218.37l0.52 0.31 6.93-11.7-0.52-0.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g89",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.685,8.946,-8.946,-17.685,217.221,223.68)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp108"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m257.99 220.2l-12.74-4.73z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g90",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.642,8.924,-8.924,-17.642,229.797,236.224)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp109"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m245.14 215.75l0.21-0.57 12.75 4.74-0.21 0.57z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g91",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.594,8.9,-8.9,-17.594,229.489,235.644)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp110"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m246.28 221.61l10.51-8.61z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g92",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.69,8.949,-8.949,-17.69,225.304,233.113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp111"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m246.08 221.38l0.39 0.47 10.51-8.62-0.38-0.47z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g93",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.64,8.923,-8.923,-17.64,225.355,231.586)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp112"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256.76 227.21l-10.36-8.81z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g94",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.675,8.94,-8.94,-17.675,225.086,242.814)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp113"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m246.2 218.63l0.39-0.46 10.36 8.81-0.39 0.46z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g95",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.624,8.915,-8.915,-17.624,225.055,241.939)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp114"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m245.26 224.53l12.82-4.51z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g96",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.736,8.971,-8.971,-17.736,229.829,245.367)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp115"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m245.16 224.24l0.2 0.57 12.83-4.5-0.2-0.57z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g97",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.795,9.002,-9.002,-17.795,229.468,243.626)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp116"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m253.19 233.37l-6.72-11.82z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g98",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.632,8.919,-8.919,-17.632,213.986,253.626)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp117"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m246.21 221.7l6.72 11.82 0.53-0.3-6.72-11.82z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g99",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.659,8.933,-8.933,-17.659,215.751,251.434)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp118"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256.9 227.08l-13.59-0.16z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g100",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.379,8.791,-8.791,-17.379,232.84,260.082)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp119"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m243.3 227.22l13.6 0.16v-0.6l-13.59-0.16z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g101",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.585,8.895,-8.895,-17.585,232.118,258.433)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp120"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m247.74 237.95l-2.28-13.41z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g102",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.626,8.916,-8.916,-17.626,187.643,271.059)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m245.17 224.59l2.27 13.4 0.6-0.1-2.27-13.4z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g103",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.614,8.91,-8.91,-17.614,191.648,268.378)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp122"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m253.38 233.3l-12.72-4.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g104",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.606,8.906,-8.906,-17.606,221.901,259.588)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m240.55 228.78l0.22-0.56 12.72 4.8-0.22 0.56z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g105",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.606,8.906,-8.906,-17.606,221.637,257.741)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp124"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m241.05 240.38l2.45-13.38z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g106",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.587,8.896,-8.896,-17.587,178.498,275.472)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m240.78 240.33l2.4-13.38 0.6 0.1-2.4 13.38z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g107",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.628,8.917,-8.917,-17.628,182.74,273.48)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m247.93 237.94l-10.3-8.86z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g108",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.655,8.931,-8.931,-17.655,208.076,262.181)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp127"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m237.44 229.31l10.3 8.86 0.4-0.46-10.32-8.86z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g109",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.632,8.919,-8.919,-17.632,208.584,261.065)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp128"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m233.94 240.38l6.87-11.74z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g110",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.623,8.915,-8.915,-17.623,188.329,266.548)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp129"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m233.68 240.23l6.86-11.74 0.52 0.3-6.86 11.74z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g111",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.616,8.911,-8.911,-17.616,190.436,264.514)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp130"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m241.24 240.44l-6.66-11.85z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g112",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.561,8.883,-8.883,-17.561,189.714,266.28)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m234.32 228.74l6.65 11.85 0.54-0.3-6.67-11.85z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g113",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.519,8.862,-8.862,-17.519,190.423,265.941)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp132"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m227.25 237.94l10.46-8.67z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g114",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.586,8.896,-8.896,-17.586,189.864,260.923)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp133"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m227.05 237.7l0.39 0.47 10.47-8.67-0.38-0.47z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g115",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.611,8.908,-8.908,-17.611,189.977,260.138)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp134"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m234.09 240.5l-2.21-13.42z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g116",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.596,8.901,-8.901,-17.596,156.497,277.986)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp135"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m231.59 227.13l2.2 13.41 0.6-0.09-2.21-13.41z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g117",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.59,8.898,-8.898,-17.59,161.291,274.551)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m221.79 233.36l12.81-4.57z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g118",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.635,8.92,-8.92,-17.635,190.58,256.796)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp137"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m221.7 233.07l0.2 0.58 12.8-4.57-0.2-0.57z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g119",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.617,8.912,-8.912,-17.617,190.342,255.881)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp138"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m227.35 238.11l2.52-13.36z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g120",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.619,8.912,-8.912,-17.619,150.328,271.877)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp139"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m227.05 238.05l0.6 0.12 2.51-13.37-0.59-0.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g121",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.598,8.902,-8.902,-17.598,154.224,269.245)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m231.83 227.29l-13.59-0.09z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g122",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.618,8.912,-8.912,-17.618,195.567,254.268)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m218.24 227.5l0.01-0.61 13.59 0.09-0.01 0.61z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g123",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.616,8.911,-8.911,-17.616,193.752,253.24)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp142"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m221.84 233.55l6.93-11.69z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g124",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.615,8.91,-8.91,-17.615,165.755,253.224)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp143"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m221.58 233.4l0.52 0.31 6.93-11.7-0.52-0.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g125",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.635,8.92,-8.92,-17.635,166.783,252.423)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp144"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m229.75 224.92l-12.74-4.74z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g126",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.62,8.913,-8.913,-17.62,182.57,240.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp145"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m216.9 220.47l12.74 4.73 0.22-0.56-12.75-4.73z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g127",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.619,8.912,-8.912,-17.619,181.485,239.97)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp146"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m218.21 227.39l10.52-8.62z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g128",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.612,8.909,-8.909,-17.612,174.586,240.617)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp147"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m218.02 227.16l0.39 0.47 10.5-8.62-0.38-0.47z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g129",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.619,8.912,-8.912,-17.619,173.805,240.416)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp148"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m228.6 221.98l-10.36-8.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g130",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.602,8.904,-8.904,-17.602,173.28,230.916)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp149"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m218.05 213.41l0.4-0.46 10.35 8.8-0.39 0.47z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g131",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.615,8.91,-8.91,-17.615,173.333,229.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp150"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m216.91 220.36l12.83-4.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g132",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.592,8.899,-8.899,-17.592,182.736,233.017)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp151"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m216.81 220.07l0.2 0.58 12.83-4.51-0.2-0.57z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g133",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.612,8.909,-8.909,-17.612,181.838,231.906)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp152"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m228.53 218.84l-6.72-11.82z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g134",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.377,8.79,-8.79,-17.377,167.738,224.989)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp153"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m221.55 207.17l6.71 11.82 0.53-0.31-6.72-11.81z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g135",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.666,8.936,-8.936,-17.666,168.732,223.234)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp154"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m231.69 213.46l-13.6-0.15z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g136",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.683,8.945,-8.945,-17.683,194.316,231.994)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp155"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m218.09 213.61l0.01-0.6 13.59 0.15-0.01 0.61z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g137",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.618,8.912,-8.912,-17.618,193.096,230.117)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp156"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m229.54 215.85l-2.28-13.41z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g138",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.657,8.931,-8.931,-17.657,154.566,228.803)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp157"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m226.96 202.49l2.27 13.4 0.6-0.1-2.27-13.4z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g139",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.617,8.911,-8.911,-17.617,158.17,226.83)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp158"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m234.34 211.88l-12.72-4.79z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g140",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.592,8.899,-8.899,-17.592,189.457,218.762)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m221.51 207.37l12.72 4.8 0.22-0.58-12.72-4.79z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g141",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.606,8.906,-8.906,-17.606,188.935,217.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp160"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m231.5 213.39l2.45-13.38z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g142",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.621,8.913,-8.913,-17.621,166.612,222.7)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp161"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m231.2 213.33l0.6 0.11 2.45-13.37-0.6-0.11z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g143",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.639,8.923,-8.923,-17.639,170.021,220.362)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp162"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m237.37 211.3l-10.31-8.85z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g144",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.603,8.904,-8.904,-17.603,190.259,212.148)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp163"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m226.86 202.68l0.4-0.46 10.31 8.85-0.4 0.46z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g145",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(-17.598,8.902,-8.902,-17.598,190.167,210.275)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8f9394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp164"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m211.92 194.16h44.94v44.63h-44.94z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp165"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m239.42 195.65c6.75 0.06 12.87 2.71 17.44 7-4.67-5.16-11.4-8.42-18.9-8.49-14.25-0.13-25.91 11.33-26.04 25.58-0.07 7.5 3.07 14.28 8.14 19.05-4.2-4.64-6.74-10.81-6.68-17.56 0.13-14.26 11.78-25.71 26.04-25.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g146",
    x2: 1,
    href: "#P",
    gradientTransform: "matrix(.422,-0.528,.529,.423,162.227,397.343)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#99999a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp166"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m236.81 219.31c0 0.65 0.52 1.18 1.17 1.18 0.64 0.01 1.17-0.51 1.18-1.16 0-0.65-0.51-1.18-1.16-1.18h-0.01c-0.65 0-1.17 0.51-1.18 1.16z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g147",
    cx: 0,
    cy: 0,
    r: 1,
    href: "#P",
    gradientTransform: "matrix(1.17,.011,-0.011,1.17,339.7,322.937)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171718"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp167"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m210.2 192.92h49.79v34.97h-49.79z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m203.99 197.44h30.26v30.44h-30.26z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp169"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m219.75 193.62h25.3v23.34h-25.3z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp170"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m242.01 208.5h4.8v8.77h-4.8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp171"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m219.75 191.27h6.97v6.68h-6.97z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp172"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m226.97 209.79h12.42v6.36h-12.42z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp173"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m226.97 214.23l2.19 1.92c0 0 3.68-6.9 10.23-5.24 0 0-6.21-4.07-12.42 3.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g148",
    x2: 1,
    href: "#P",
    gradientTransform: "matrix(.564,-0.374,.353,.532,112.82,365.086)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#99999a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp174"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m226.44 195.58h17.14v12.55h-17.14z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp175"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m226.97 195.58l13.08 8.41c0 0 2.93 2.36 3.53 4.14 0 0-2.73-3.11-7.32-5.78-4.58-2.67-9.82-5.95-9.82-5.95z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g149",
    x2: 1,
    href: "#P",
    gradientTransform: "matrix(.564,-0.374,.351,.529,118.473,364.524)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#99999a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp176"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m55.69 178.4h52.06v42.72h-52.06z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp177"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m69.8 178.4h37.95v42.72h-37.95z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp178"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m88.6 121.7h186.58v98.3h-186.58z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp179"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m103.76 173.88h2.63v11.92h-2.63z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp180"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m164.84 158.79h7v14.36h-7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp181"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m147.71 201.04h16.82v5.39h-16.82z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp182"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m215.66 145.03h29.17v15.24h-29.17z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp183"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m159.35 147.06h65.99v19.87h-65.99z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp184"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m160.32 144.77h81.53v25.66h-81.53z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp185"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m191.31 175.45h70.4v29.54h-70.4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp186"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m106.14 99.25h9.82v18.8h-9.82z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp187"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m106.31 112.46h6.31v9.79h-6.31z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp188"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m95.46 114.48h20.05v8.77h-20.05z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp189"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m95.36 101.57h20.57v9.17h-20.57z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp190"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m111.75 103.66h18.13v16.26h-18.13z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m113.13 102.69h14.8v17.23h-14.8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp192"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m122.57 114.51h22.22v9.44h-22.22z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp193"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m132.7 111.37h5.46v6.33h-5.46z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp194"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m133.29 112.93h11.47v1.1h-11.47z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp195"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m133.43 115.85h11.43v1.74h-11.43z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp196"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m120.9 112.51h8.55v10.93h-8.55z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp197"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m69.36 121.23h138.91v111.26h-138.91z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp198"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m95.84 186.81h112.43v45.68h-112.43z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp199"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m108.54 120.4h8.84v3.87h-8.84z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp200"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m108.49 114.71h9.08v4.04h-9.08z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp201"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m108.58 96.77h12.19v5.3h-12.19z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp202"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m107.64 92.27h9.11v16.13h-9.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp203"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m235.02 183.24h17.5v11.28h-17.5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp204"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m71.5 148.99h14.19v26.17h-14.19z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp205"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m156.59 144.77h89v25.69h-89z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp206"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m159.98 148.07h61.86v11.02h-61.86z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp207"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m216.41 145.35h47.51v18.7h-47.51z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp208"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m231.29 83.09h5.53v62.82h-5.53z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp209"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m232.28 82.03h4.1v11.97h-4.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp210"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m122.92 197.79h11.05v7.71h-11.05z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp211"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m132.3 189.26h27.67v16.22h-27.67z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp212"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m129.35 126.8h65.45v63.26h-65.45z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp213"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m124.41 201.81h11.05v7.74h-11.05z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp214"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m133.8 201.68h5.87v7.85h-5.87z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp215"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m142.8 193.31h18.66v13.14h-18.66z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m136.46 156.2h1.77v11.76h-1.77z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp217"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m144.08 162h1.7v23.74h-1.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp218"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m130.35 131.02h35.57v22.11h-35.57z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp219"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m133.5 126.23h61.85v67.43h-61.85z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp220"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m164.07 129.75h1.93v0.92h-1.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp221"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m141.48 145.25h5.96v4.57h-5.96z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp222"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m137.83 145.03h9.1v5.06h-9.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp223"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m135.59 146.19h16.15v36.95h-16.15z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp224"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m149.22 187.08h8.26v5.47h-8.26z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp225"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m138.75 151.23h3.93v9.53h-3.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m146.96 126.23h48.39v22.04h-48.39z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp227"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m142.54 191.84h6.32v4.27h-6.32z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp228"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m147.89 189.07h11.45v6.99h-11.45z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp229"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m130.37 140.8h10.24v12.06h-10.24z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp230"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m169.34 55.34h12.74v16.99h-12.74z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp231"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m154.84 39.95h23.83v28.95h-23.83z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp232"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m161.85 63.7h3.22v2.05h-3.22z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp233"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m160.16 62.44h4.1v1.24h-4.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp234"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m155.76 55.04h5.62v6.51h-5.62z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp235"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m179.29 60.55h1v4.43h-1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp236"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m152.67 24.78h42.54v41.34h-42.54z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp237"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m172.86 52.31h11.91v9.16h-11.91z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp238"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m169.8 46.12h4.32v21.49h-4.32z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp239"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m152 22.55h47.13v36.37h-47.13z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp240"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m152.02 28.13h47.11v30.79h-47.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp241"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m148.14 37.81h6.52v8.2h-6.52z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp242"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m148.16 37.8h26.56v10.49h-26.56z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp243"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m162.83 41.43h11.89v6.86h-11.89z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp244"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m152.57 21.88h19.79v13.28h-19.79z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp245"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m159.25 53.97h1.41v1.94h-1.41z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp246"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m145.64 39.92h29.34v21.56h-29.34z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp247"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m159.81 40.41h15.17v18.86h-15.17z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m146.74 41.35h13.06v13.96h-13.06z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp249"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m147.24 56.69h2.76v2.1h-2.76z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp250"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m171.99 43.73h0.7v0.71h-0.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp251"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m164.37 125.53h30.71v10.47h-30.71z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp252"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m169.93 69.09h1.38v7.27h-1.38z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp253"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m171.19 63.91h14.74v12.45h-14.74z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp254"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m175.15 63.91h10.78v10.37h-10.78z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp255"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m164 74.92h8.61v52.36h-8.61z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m164 68.64h32.49v64.82h-32.49z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp257"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m171.17 68.64h25.32v64.82h-25.32z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp258"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m172.62 99.07h2.15v2.75h-2.15z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp259"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m177.9 103.02h4.01v2.69h-4.01z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp260"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m175.85 101.29h1.71v1.96h-1.71z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp261"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m133.33 110.9h1.2v6.75h-1.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp262"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m134.36 111.98h0.15v0.97h-0.15z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp263"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m136.17 109.86h3.82v8.48h-3.82z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp264"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m137.94 105.29h13.65v13.14h-13.65z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp265"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m134.22 111.1h2.71v7.19h-2.71z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp266"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m149.48 99.78h21.68v5.51h-21.68z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp267"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m173.41 74.08h7.15v27.24h-7.15z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp268"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m149.88 73.58h38.38v38.83h-38.38z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp269"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m150.65 111.27h1.7v1.04h-1.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp270"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m152.37 73.58h35.89v38.83h-35.89z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#5363fd}.b{fill:#464645}.c{fill:#343434}.d{fill:#c9caa8}.e{fill:#f5ffdf}.f{fill:#fff}.g{fill:#d2ff8f}.h{fill:#323232}.i{fill:#111}.j{fill:#252525}.k{fill:#737373}.l{fill:#d4c4a9}.m{fill:#d38d61}.n{fill:#785026}.o{fill:#ae5f09}.p{fill:#fad6be}.q{fill:#14366c}.r{fill:#fbac2c}.s{fill:#076faf}.t{fill:#52a64d}.u{fill:#11521d}.v{fill:#92c146}.w{fill:#de1b23}.x{fill:#620906}.y{fill:#b31e23}.z{fill:#121212}.A{fill:#1a1718}.B{fill:url(#g1)}.C{fill:url(#g2)}.D{fill:url(#g3)}.E{fill:url(#g4)}.F{fill:url(#g5)}.G{fill:url(#g6)}.H{fill:url(#g7)}.I{fill:url(#g8)}.J{fill:url(#g9)}.K{fill:url(#g10)}.L{fill:url(#g11)}.M{fill:url(#g12)}.N{fill:url(#g13)}.O{fill:url(#g14)}.P{fill:url(#g15)}.Q{fill:url(#g16)}.R{fill:url(#g17)}.S{fill:url(#g18)}.T{fill:url(#g19)}.U{fill:url(#g20)}.V{fill:url(#g21)}.W{fill:url(#g22)}.X{fill:url(#g23)}.Y{fill:url(#g24)}.Z{fill:url(#g25)}.a0{fill:url(#g26)}.a1{fill:url(#g27)}.a2{fill:url(#g28)}.a3{fill:url(#g29)}.a4{fill:url(#g30)}.a5{fill:url(#g31)}.a6{fill:url(#g32)}.a7{fill:url(#g33)}.a8{fill:url(#g34)}.a9{fill:url(#g35)}.aa{fill:url(#g36)}.ab{fill:url(#g37)}.ac{fill:url(#g38)}.ad{fill:url(#g39)}.ae{fill:url(#g40)}.af{fill:url(#g41)}.ag{fill:url(#g42)}.ah{fill:url(#g43)}.ai{fill:url(#g44)}.aj{fill:url(#g45)}.ak{fill:url(#g46)}.al{fill:url(#g47)}.am{fill:url(#g48)}.an{fill:url(#g49)}.ao{fill:url(#g50)}.ap{fill:url(#g51)}.aq{fill:url(#g52)}.ar{fill:url(#g53)}.as{fill:url(#g54)}.at{fill:url(#g55)}.au{fill:url(#g56)}.av{fill:url(#g57)}.aw{fill:url(#g58)}.ax{fill:url(#g59)}.ay{fill:url(#g60)}.az{fill:url(#g61)}.aA{fill:url(#g62)}.aB{fill:url(#g63)}.aC{fill:url(#g64)}.aD{fill:url(#g65)}.aE{fill:url(#g66)}.aF{fill:url(#g67)}.aG{fill:url(#g68)}.aH{fill:url(#g69)}.aI{fill:url(#g70)}.aJ{fill:url(#g71)}.aK{fill:url(#g72)}.aL{fill:#aeb8b9}.aM{fill:#ccd4d5}.aN{fill:#e8eaeb}.aO{fill:#8f9394}.aP{fill:#bbc1c2}.aQ{fill:#a3a6a8}.aR{fill:#1d1d1d}.aS{fill:#1e242d}.aT{fill:url(#g73)}.aU{fill:url(#g74)}.aV{fill:url(#g75)}.aW{fill:url(#g76)}.aX{fill:url(#g77)}.aY{fill:url(#g78)}.aZ{fill:url(#g79)}.b0{fill:url(#g80)}.b1{fill:url(#g81)}.b2{fill:url(#g82)}.b3{fill:url(#g83)}.b4{fill:url(#g84)}.b5{fill:url(#g85)}.b6{fill:url(#g86)}.b7{fill:url(#g87)}.b8{fill:url(#g88)}.b9{fill:url(#g89)}.ba{fill:url(#g90)}.bb{fill:url(#g91)}.bc{fill:url(#g92)}.bd{fill:url(#g93)}.be{fill:url(#g94)}.bf{fill:url(#g95)}.bg{fill:url(#g96)}.bh{fill:url(#g97)}.bi{fill:url(#g98)}.bj{fill:url(#g99)}.bk{fill:url(#g100)}.bl{fill:url(#g101)}.bm{fill:url(#g102)}.bn{fill:url(#g103)}.bo{fill:url(#g104)}.bp{fill:url(#g105)}.bq{fill:url(#g106)}.br{fill:url(#g107)}.bs{fill:url(#g108)}.bt{fill:url(#g109)}.bu{fill:url(#g110)}.bv{fill:url(#g111)}.bw{fill:url(#g112)}.bx{fill:url(#g113)}.by{fill:url(#g114)}.bz{fill:url(#g115)}.bA{fill:url(#g116)}.bB{fill:url(#g117)}.bC{fill:url(#g118)}.bD{fill:url(#g119)}.bE{fill:url(#g120)}.bF{fill:url(#g121)}.bG{fill:url(#g122)}.bH{fill:url(#g123)}.bI{fill:url(#g124)}.bJ{fill:url(#g125)}.bK{fill:url(#g126)}.bL{fill:url(#g127)}.bM{fill:url(#g128)}.bN{fill:url(#g129)}.bO{fill:url(#g130)}.bP{fill:url(#g131)}.bQ{fill:url(#g132)}.bR{fill:url(#g133)}.bS{fill:url(#g134)}.bT{fill:url(#g135)}.bU{fill:url(#g136)}.bV{fill:url(#g137)}.bW{fill:url(#g138)}.bX{fill:url(#g139)}.bY{fill:url(#g140)}.bZ{fill:url(#g141)}.c0{fill:url(#g142)}.c1{fill:url(#g143)}.c2{fill:url(#g144)}.c3{fill:url(#g145)}.c4{fill:url(#g146)}.c5{fill:url(#g147)}.c6{fill:#454a49}.c7{fill:#525756}.c8{fill:#424645}.c9{fill:#aeaeae}.ca{fill:#444}.cb{fill:#626161}.cc{fill:url(#g148)}.cd{fill:url(#g149)}.ce{fill:#8f141c}.cf{fill:#9b151e}.cg{fill:#8e6b4b}.ch{fill:#5d2c05}.ci{fill:#865b3c}.cj{fill:#fc1f24}.ck{fill:#fabc62}.cl{fill:#c4c4c4}.cm{fill:#919191}.cn{fill:#434746}.co{fill:#272929}.cp{fill:#292c2b}.cq{fill:#808686}.cr{fill:#606464}.cs{fill:#696e6e}.ct{fill:#272a28}.cu{fill:#0e110d}.cv{fill:#1d1d1b}.cw{fill:#414543}.cx{fill:#acacac}.cy{fill:#15373f}.cz{fill:#f4d082}.cA{fill:#5e0d12}.cB{fill:#898888}.cC{fill:#383838}.cD{fill:#a6a6a6}.cE{fill:#424242}.cF{fill:#2b2b2b}.cG{fill:#0e2b4c}.cH{fill:#dbdbdb}.cI{fill:#10508f}.cJ{fill:#2e404d}.cK{fill:#658ba6}.cL{fill:#40596a}.cM{fill:#8b9496}.cN{fill:#a5afb1}.cO{fill:#969696}.cP{fill:#63adc6}.cQ{fill:#505556}.cR{fill:#b36549}.cS{fill:#119ec5}.cT{fill:#3f260a}.cU{fill:#663d0b}.cV{fill:#191919}.cW{fill:#595959}.cX{fill:#101010}.cY{fill:#292929}.cZ{fill:#5e3627}.d0{fill:#281711}.d1{fill:#ccc}.d2{fill:#333}.d3{fill:#4f4f4f}.d4{fill:#202020}")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m385.2 250.2c0 17.8-86.1 32.3-192.4 32.3-106.3 0-192.4-14.5-192.4-32.3 0-17.9 86.1-32.3 192.4-32.3 106.3 0 192.4 14.4 192.4 32.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m337.5 47.4q0-0.2 0-0.3 0-0.1-0.1-0.2 0 0 0 0 0 0 0-0.1 0 0 0-0.1 0-0.1 0-0.2 0-0.1 0-0.2-0.1-0.1-0.1-0.1 0-0.1 0-0.1 0-0.1 0-0.2 0-0.1-0.1-0.2 0-0.1 0-0.1 0-0.1 0-0.1-0.1 0-0.1-0.1 0-0.1 0-0.2-0.1 0-0.1-0.1 0-0.1 0-0.2-0.1 0-0.1-0.1 0-0.1-0.1-0.1 0-0.1 0-0.2-0.1 0-0.1-0.1 0 0 0 0 0-0.1 0-0.1-0.1-0.1-0.2-0.2 0-0.1 0-0.1-0.1-0.1-0.2-0.2 0-0.1 0-0.1-0.1-0.1-0.2-0.3-0.1-0.1-0.1-0.1-0.1-0.1-0.2-0.2 0 0 0-0.1 0 0 0 0-0.1 0-0.1-0.1-0.1-0.1-0.2-0.1 0-0.1 0-0.1-0.1 0-0.1 0 0-0.1 0-0.1-0.1-0.1-0.2-0.2 0 0-0.1 0 0 0 0-0.1 0 0-0.1-0.1-0.1 0-0.2-0.1 0 0 0 0 0 0 0 0-0.1-0.1-0.2-0.2 0 0 0 0 0 0-0.1 0 0-0.1-0.1-0.1 0-0.1-0.1-0.1 0 0 0 0 0-0.1-0.1-0.1 0 0 0 0-0.1 0-0.1 0 0-0.1 0-0.1-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0-0.1-0.1-0.1l-33.2-19.1-19.6-11.3-17.5-10.1q0 0-0.1 0-0.1-0.1-0.1-0.1-0.1 0-0.1 0 0 0 0-0.1-0.1 0-0.1 0-0.1 0-0.2-0.1-0.1 0-0.2 0-0.1-0.1-0.1-0.1 0 0 0 0-0.1 0-0.2 0-0.1-0.1-0.2-0.1 0 0 0 0 0 0-0.1 0 0 0-0.1 0 0 0-0.1 0-0.1 0-0.2 0-0.1 0-0.2 0-0.1 0-0.1 0-0.1 0-0.1 0 0 0 0 0-0.1 0-0.2 0.1-0.1 0-0.2 0.1-6.4 3.7-12.7 7.4 0.2-0.1 0.3-0.2 0.1 0 0.1 0 0.2 0 0.4 0 0.2 0 0.4 0 0 0 0 0c0.4 0.1 0.8 0.2 1 0.4q0.1 0 0.1 0 0.1 0 0.2 0.1 0.1 0 0.1 0l17.4 10.1 19.7 11.3 33.2 19.2q0 0 0.1 0 0 0 0 0 0 0 0.1 0.1 0 0 0 0 0.1 0 0.2 0.1 0 0 0 0 0.1 0.1 0.2 0.2 0 0 0 0 0.2 0.1 0.3 0.2 0 0 0 0 0.1 0.1 0.3 0.2 0 0.1 0 0.1 0.2 0.1 0.3 0.3 0 0 0 0 0.2 0.2 0.3 0.3 0 0 0 0.1 0.2 0.1 0.4 0.3 0.1 0.2 0.2 0.4 0.1 0.1 0.1 0.2 0.1 0.2 0.3 0.4 0 0 0 0 0.1 0.3 0.2 0.5 0 0 0 0.1 0.1 0.2 0.2 0.5 0 0 0 0 0.1 0.3 0.2 0.7 0 0 0 0 0.1 0.3 0.1 0.7 0 0 0 0 0 0.3 0 0.7v32.3l-0.3 150.3q0 0.6-0.1 1 0 0 0 0 0 0.2-0.1 0.3 0 0.1 0 0.1 0 0.1-0.1 0.2 0 0.1 0 0.1 0 0.1-0.1 0.2 0 0 0 0.1-0.1 0-0.1 0-0.1 0.2-0.1 0.2-0.1 0.1-0.1 0.1-0.1 0.1-0.2 0.2l12.7-7.4q0.1-0.1 0.2-0.2 0.1 0 0.1-0.1 0.1-0.1 0.1-0.2 0.1 0 0.1 0 0 0 0 0 0-0.1 0-0.1 0.1-0.1 0.1-0.1 0-0.1 0-0.1 0 0 0.1-0.1 0 0 0 0 0-0.1 0.1-0.2 0-0.1 0-0.1 0 0 0-0.1 0-0.1 0-0.2 0.1-0.1 0.1-0.2 0-0.1 0-0.2v-0.1q0 0 0 0 0-0.1 0-0.2 0-0.1 0-0.2 0-0.1 0-0.1l0.3-150.3 0.1-32.3q0-0.1 0-0.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m323.5 240.4q-0.2 0-0.4-0.1c-0.1-0.2 0-0.4 0.2-0.5q0.1-0.1 0.1-0.2 0.2-0.1 0.2-0.2l0.1 0.1h0.1l-0.1-0.2q0-0.1 0.1-0.1c0-0.2 0-0.2 0.1-0.3q0-0.2 0-0.4 0.1-0.4 0.1-0.8l0.4-182.7q0-0.3-0.1-0.7 0-0.3-0.1-0.6 0-0.4-0.1-0.6-0.1-0.3-0.2-0.6-0.1-0.3-0.3-0.5-0.1-0.2-0.2-0.4 0-0.1-0.1-0.2-0.1-0.2-0.2-0.3-0.2-0.2-0.3-0.4-0.2-0.2-0.3-0.4-0.2-0.1-0.3-0.2-0.2-0.2-0.3-0.3-0.2-0.1-0.3-0.2l-0.6-0.4-70.3-40.5-0.3-0.2q-0.5-0.2-0.9-0.3-0.2 0-0.4 0-0.2 0-0.3 0-0.2 0-0.3 0.1c-0.2 0.1-0.4 0-0.5-0.1-0.1-0.2-0.1-0.4 0.1-0.5l12.7-7.4q0.2-0.1 0.3-0.2 0.1 0 0.2 0c0 0 0.1 0 0.1 0q0.1-0.1 0.2-0.1 0.1 0 0.2 0 0.1 0 0.2 0 0.1 0 0.2 0c0 0 0.1 0 0.1 0 0 0 0.1 0.1 0.1 0.1q0.1 0 0.2 0 0.1 0 0.2 0.1 0.1 0 0.2 0l0.1 0.1q0.1 0 0.1 0 0.1 0 0.1 0.1 0.1 0 0.1 0l0.4 0.2 70.3 40.5q0 0 0.1 0v0.1l-0.1 0.4 0.2-0.4c0 0 0.1 0.1 0.1 0.1l0.1 0.1c0 0 0.1 0 0.1 0l0.2 0.2q0.1 0.1 0.2 0.2 0.2 0.1 0.3 0.2l0.1 0.1 0.2 0.2-0.2 0.4 0.3-0.3c0 0 0.1 0.1 0.1 0.1l0.4 0.5q0.1 0.1 0.2 0.2 0.1 0.2 0.2 0.3c0 0 0 0 0 0.1l0.3 0.3q0 0.1 0.1 0.2c0 0 0 0.1 0 0.1l0.5 1.2c0 0 0 0.1 0 0.1l0.1 0.3q0.1 0.1 0.1 0.2l-0.4 0.2 0.4-0.1v0.1l0.1 0.6q0 0.2 0 0.3 0 0.1 0 0.3v0.2l-0.3 182.6q0 0.2 0 0.3 0 0.1 0 0.2 0 0.2-0.1 0.3 0 0.1 0 0.2 0 0.2 0 0.3l-0.1 0.2q0 0.1-0.1 0.2c0 0 0 0.1 0 0.1 0 0.1-0.1 0.1-0.1 0.1q0 0.1 0 0.1l-0.4-0.1 0.4 0.2c-0.1 0-0.1 0-0.1 0.1 0 0-0.1 0-0.1 0.1q0 0.1-0.2 0.2 0 0 0 0.1-0.2 0.1-0.3 0.2l-12.8 7.4q0 0-0.1 0zm-72.4-232.4l70.3 40.5c0 0 0.1 0.1 0.1 0.1l0.1 0.1c0 0 0 0 0 0q0.1 0 0.2 0.1l0.2 0.2q0.2 0.1 0.3 0.2 0.2 0.2 0.3 0.3c0.2 0.1 0.3 0.2 0.4 0.3q0.2 0.2 0.3 0.4 0.2 0.2 0.4 0.4 0.1 0.2 0.2 0.4 0.1 0.1 0.1 0.2 0.2 0.2 0.3 0.4 0.1 0.3 0.2 0.6 0.2 0.3 0.3 0.6 0.1 0.4 0.2 0.7 0 0.4 0.1 0.7 0 0.4 0 0.8l-0.3 182.7q0 0.5-0.1 0.9-0.1 0.2-0.1 0.4l11.4-6.7q0.1 0 0.2-0.1c0.1-0.1 0.1-0.1 0.1-0.2q0.1 0 0.1 0c0 0 0-0.1 0-0.1l0.4 0.1-0.3-0.2v-0.1q0.1-0.1 0.1-0.2h0.4l-0.4-0.1v-0.1q0.1-0.1 0.1-0.2 0-0.1 0-0.2 0-0.1 0-0.2v-0.2q0-0.1 0-0.2l0.4-182.7v-0.2q0-0.1 0-0.2 0-0.2 0-0.3l-0.1-0.5c0 0 0-0.2 0-0.2l-0.2-0.5 0.4-0.2-0.4 0.1-0.4-1 0.3-0.2-0.3 0.2c0 0-0.1-0.1-0.1-0.1q0-0.1-0.1-0.2c0 0-0.1-0.1-0.1-0.1l-0.1-0.2 0.3-0.3-0.3 0.2q-0.1-0.1-0.2-0.2-0.1-0.1-0.1-0.2l-0.2-0.2-0.3-0.4 0.2-0.3-0.3 0.3-0.2-0.2 0.2-0.4-0.2 0.3-0.1-0.1q-0.1-0.1-0.2-0.1-0.1-0.1-0.2-0.2l0.1-0.3-0.2 0.2-0.1-0.1h-0.1l0.2-0.3-0.2 0.3 0.1-0.4-0.2 0.3 0.1-0.3-0.2 0.3-0.1-0.1c0 0 0 0 0 0q0 0 0 0l-70.6-40.7h-0.1c0 0-0.1-0.1-0.1-0.1q0 0-0.1 0 0 0 0 0l-0.3-0.1q-0.1-0.1-0.1-0.1 0 0-0.1 0-0.1 0-0.2 0v-0.4 0.4q-0.2-0.1-0.2-0.1h-0.2q-0.1 0-0.1 0-0.1 0.1-0.2 0.1l-0.1-0.4 0.1 0.4q-0.1 0-0.1 0-0.1 0-0.2 0.1l-11.4 6.6q0.5 0.1 0.9 0.3c0 0 0.1 0.1 0.1 0.1q0.1 0 0.2 0.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m322.1 49.5q0.1 0.1 0.3 0.2 0 0.1 0 0.1 0.2 0.1 0.3 0.3 0 0 0 0 0.2 0.2 0.3 0.3 0 0 0 0.1 0.2 0.1 0.4 0.3 0.1 0.2 0.2 0.4 0.1 0.1 0.1 0.2 0.1 0.2 0.3 0.4 0 0 0 0 0.1 0.3 0.2 0.5 0 0 0 0.1 0.1 0.2 0.2 0.5 0 0 0 0 0.1 0.3 0.2 0.7 0 0 0 0 0.1 0.3 0.1 0.7 0 0 0 0 0 0.3 0 0.7v1.7q2.3-1.2 4.5-2.3 4.2-2.1 8.3-4.1v-2.7q0-0.1 0-0.2 0-0.2 0-0.3 0-0.1-0.1-0.2 0 0 0 0 0 0 0-0.1 0 0 0-0.1 0-0.1 0-0.2 0-0.1 0-0.2-0.1-0.1-0.1-0.1 0 0 0 0 0-0.1 0-0.1 0-0.1 0-0.2 0-0.1-0.1-0.2 0-0.1 0-0.1 0-0.1 0-0.1-0.1 0-0.1-0.1 0-0.1 0-0.2-0.1 0-0.1-0.1 0-0.1 0-0.2-0.1 0-0.1-0.1 0-0.1-0.1-0.1 0-0.1 0-0.2-0.1 0-0.1-0.1 0 0 0 0 0-0.1 0-0.1-0.1-0.1-0.2-0.2 0-0.1 0-0.1-0.1-0.1-0.2-0.2 0-0.1 0-0.1-0.1-0.1-0.2-0.3-0.1-0.1-0.1-0.2-0.1 0-0.2-0.1 0 0 0-0.1 0 0 0 0-0.1 0-0.1-0.1-0.1-0.1-0.2-0.1 0-0.1 0-0.1-0.1 0-0.1 0 0-0.1 0-0.1-0.1-0.1-0.2-0.2 0 0-0.1 0 0 0 0-0.1 0 0-0.1-0.1-0.1 0-0.2-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1-6.3 3.9-12.7 7.5 0 0 0 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m324.7 57q-0.1 0-0.1 0-0.2-0.1-0.2-0.3v-1.7q0-0.3-0.1-0.7 0-0.3-0.1-0.6 0-0.4-0.1-0.6-0.1-0.3-0.2-0.6-0.1-0.3-0.3-0.5-0.1-0.2-0.2-0.4 0-0.1-0.1-0.2-0.1-0.2-0.2-0.3-0.2-0.2-0.3-0.4-0.2-0.2-0.3-0.4-0.2-0.1-0.3-0.2-0.2-0.2-0.3-0.3c0 0-0.1 0-0.1 0q-0.1-0.2-0.1-0.4 0-0.1 0.2-0.2c4.1-2.3 8.2-4.7 12.7-7.5 0.1-0.1 0.3-0.1 0.4 0v0.1q0.2 0.1 0.3 0.2l0.1 0.1 0.2 0.2-0.2 0.4 0.3-0.3 0.1 0.1 0.4 0.5q0.1 0.1 0.2 0.2 0.1 0.2 0.2 0.3c0 0 0 0 0 0.1l0.3 0.3q0 0.1 0.1 0.2c0 0 0 0.1 0 0.1l0.5 1.2c0 0 0 0.1 0 0.1l0.1 0.3q0.1 0.1 0.1 0.2l-0.4 0.2 0.4-0.1v0.1l0.1 0.6q0 0.2 0 0.3 0 0.1 0 0.3v0.2 2.7c0 0.1 0 0.2-0.2 0.3q-3.1 1.5-6.1 3.1l-2.1 1c-1.3 0.6-2.7 1.3-4.5 2.3q-0.1 0-0.2 0zm-2-7.4q0.2 0.1 0.3 0.2 0.2 0.2 0.3 0.4 0.2 0.2 0.4 0.4 0.1 0.2 0.2 0.4 0.1 0.1 0.1 0.2 0.2 0.2 0.3 0.4 0.1 0.3 0.3 0.6 0.1 0.3 0.2 0.6 0.1 0.4 0.2 0.7 0 0.4 0.1 0.7 0 0.4 0 0.8v1.1c1.5-0.9 2.8-1.5 4-2.1l2-1q3-1.5 6-3v-2.4-0.2q0-0.1 0-0.2 0-0.2 0-0.3l-0.1-0.5c0 0 0-0.2 0-0.2l-0.2-0.5 0.4-0.2-0.4 0.1-0.4-1 0.3-0.2-0.3 0.2c0 0-0.1-0.1-0.1-0.1q0-0.1-0.1-0.2c0 0-0.1-0.1-0.1-0.1l-0.1-0.2 0.3-0.3-0.3 0.2q-0.1-0.1-0.2-0.2-0.1-0.1-0.1-0.2l-0.2-0.2-0.3-0.4 0.2-0.3-0.3 0.3-0.2-0.2 0.2-0.4-0.2 0.3-0.1-0.1q-0.1 0-0.1 0c-4.2 2.6-8.1 4.9-12 7.1z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m322.5 55.9l-0.3 165.7-73-42 0.4-165.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m261.9 166.3c-4.5-10.1-8.2-20.8-12.6-31.2l-0.1 44.5 25.4 14.6c-4.3-9.2-8.6-18.5-12.7-27.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m255.4 34.8c13.1 10.4 26.2 20.7 39.3 31q14 11.1 27.8 22.5v-32.4l-72.9-42.1-0.1 16.3q3 2.3 5.9 4.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m263.1 44.8q-6-4.8-12.1-9.7-0.7-0.6-1.5-1.2v25.6q6.8 9.3 13.6 18.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m298.5 72.7q-3.6-2.8-7.1-5.6-12.6-9.9-25.2-19.9v34.9c10.7 14.5 21.4 28.8 32.3 43.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m301.5 75.2v54q10.3 13.4 20.8 26.6l0.1-63.5q-10.3-8.6-20.9-17.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m265.2 86q0-0.1 0-0.1-7.9-10.6-15.7-21.2l-0.1 37.4c5-5.6 10.2-11 15.8-16.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m263.2 130.4c6.2-7.4 12.7-14.6 18.4-22.5q-7.3-9.7-14.5-19.5c-6.3 5.8-12.1 12-17.7 18.4l-0.1 20.7c2 4.3 3.8 8.7 5.6 13.2 2.7-3.5 5.4-6.9 8.3-10.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m283.5 110.5c-5.6 7.7-12 14.8-18.1 22.1-3.2 3.7-6.2 7.5-9.2 11.4 2.7 7 5.4 14 8.4 20.8 4.7 10.8 9.6 21.5 14.8 32.1l22.1 12.8v-74.8q0-0.3 0.1-0.6-9.1-11.8-18.1-23.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m304.6 138.2v73.3l17.6 10.1 0.1-60.9q-8.9-11.2-17.7-22.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "h",
    d: "m320.6 49.3c0.2 0.1 3.5 2.1 3.5 6.1l-0.1 31.9-0.3 148.5c0 4.1-3.3 2.2-3.4 2.1l-17.2-9.9-19.3-11.1-32.7-18.8c-0.1-0.1-3.5-2.1-3.5-6.1l0.2-61 0.1-63.2 0.1-31.6v-15.8l0.1-7.9c-0.1-1.3 0-2.6 0.8-3.1 0.8-0.5 1.8-0.3 2.9 0.3l16.1 9.3 15.8 9.1 31.7 18.2zm1.6 172.3l0.3-165.7-73-42.1-0.3 165.7zm-41-192.7c-0.3-0.2-0.5 0-0.5 0.3 0 0.3 0.2 0.8 0.5 0.9l9.8 5.7c0.3 0.1 0.5 0 0.5-0.3 0-0.4-0.2-0.8-0.5-1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "i",
    d: "m322 238.8c-0.8 0-1.7-0.4-1.9-0.6l-69.2-39.8c-0.3-0.2-3.6-2.3-3.6-6.4l0.1-61 0.3-118.5c-0.1-1.2 0-2.8 1-3.5 0.8-0.5 2-0.3 3.3 0.4l16.1 9.3 52.7 30.3c0.2 0.1 3.7 2.2 3.7 6.4l-0.4 180.4c0 2.6-1.3 3-2.1 3zm-72.2-229.3q-0.4 0-0.7 0.2-0.8 0.5-0.7 2.8l-0.4 179.5c0 3.8 3.2 5.7 3.3 5.7l69.1 39.9c0.2 0.1 0.9 0.5 1.6 0.5 0.3 0 1.4 0 1.4-2.3l0.3-180.4c0-3.8-3.1-5.7-3.3-5.8l-5.2-3-47.5-27.2-16.1-9.4c-0.6-0.3-1.3-0.5-1.8-0.5zm72.4 212.5q-0.1 0-0.2-0.1l-72.9-42q-0.2-0.1-0.2-0.3l0.3-165.8q0-0.2 0.2-0.3 0.2-0.1 0.3 0l73 42.1q0.2 0.1 0.2 0.3l-0.3 165.7q0 0.2-0.2 0.3-0.1 0.1-0.2 0.1zm-72.6-42.7l72.2 41.7 0.3-164.9-72.2-41.6zm41.6-143.2q-0.2 0-0.4-0.1l-9.8-5.7c-0.4-0.2-0.7-0.7-0.7-1.2 0-0.6 0.5-0.9 1.1-0.6l9.7 5.6c0.5 0.2 0.8 0.8 0.8 1.2 0 0.5-0.3 0.8-0.7 0.8zm-10.2-7c0.1 0.3 0.2 0.5 0.4 0.6l9.7 5.6c0-0.2-0.2-0.5-0.3-0.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "j",
    d: "m321.2 48.9c0.2 0 3.6 2 3.5 6.1v32.3l-0.3 150.4c0 4.1-3.4 2.1-3.6 2l-17.4-10-19.7-11.3-33.2-19.2c-0.1-0.1-3.5-2.1-3.5-6.1l0.3-168.6 0.1-14.1c0-4.1 3.3-2.2 3.5-2.1l17.4 10.1 19.7 11.3zm2.8 38.4l0.1-31.9c0-4-3.4-6-3.5-6l-5.2-3-31.7-18.4-15.9-9.2-15.8-9c-1.3-0.8-2.4-1.1-3.2-0.6-0.8 0.6-0.9 2-0.9 3.3v7.9 15.8l-0.1 31.6-0.1 63.3-0.1 60.9c0 4.1 3.4 6 3.5 6.1l32.7 18.8 19.3 11.2 17.1 9.9c0.2 0.1 3.5 2 3.5-2.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "i",
    d: "m322.6 240.6c-0.8 0-1.7-0.4-2-0.6l-70.3-40.5c-0.1-0.1-3.7-2.2-3.7-6.4l0.4-182.7c0-2.6 1.3-3 2.1-3 0.9 0 1.7 0.5 2 0.6l70.3 40.5c0.2 0.1 3.7 2.3 3.7 6.5l-0.3 182.7c-0.1 2.6-1.4 2.9-2.2 2.9zm-75.2-47.5c0 3.8 3.2 5.7 3.3 5.8l70.3 40.5c0.2 0.1 0.9 0.5 1.6 0.5 0.4 0 1.4 0 1.4-2.2v-0.8c-0.3 1.6-1.3 1.9-2 1.9-0.8 0-1.7-0.4-1.9-0.6l-69.2-39.8c-0.1-0.1-3-1.8-3.5-5.3zm2.4-183.8q-0.5 0-0.8 0.2c-0.5 0.4-0.7 1.3-0.7 2.9l-0.2 118.6-0.1 61c0 3.8 3.2 5.7 3.3 5.7l69.1 39.9c0.2 0.1 0.9 0.5 1.6 0.5 0.4 0 1.4 0 1.4-2.3l0.3-148.5v-31.9c0-3.8-3.1-5.7-3.3-5.8l-5.2-3-47.5-27.5-15.8-9.1q-1.3-0.7-2.1-0.7zm72.5 40.9c0.6 0.6 1.3 1.5 1.7 2.6-0.4-1.1-1.1-2-1.7-2.6zm-73.2-42c-0.3 0-1.4 0-1.4 2.2 0.2-0.6 0.4-1.2 0.9-1.5q0.9-0.6 2.3-0.1l-0.2-0.1c-0.1-0.1-0.9-0.5-1.6-0.5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m283.9 202.4c3 1.7 5.4 5.9 5.4 9.3 0 3.4-2.4 4.8-5.4 3.1-3-1.8-5.3-5.9-5.3-9.3 0-3.4 2.4-4.8 5.3-3.1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m312 216.1l-77.5 56.9-43.4-35.7 74.5-48.3z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m269.5 205.2c4.6 1.1 9.3 3.2 12 7.3 3.3 5 3.5 11.7 2.2 17.4-0.9 3.5-2.2 6.7-4 9.9l32.3-23.7-46.4-27.1-28.6 18.5c10.5-2.7 22-4.6 32.5-2.3z"
  })))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m312 216.1l-77.5 56.9 77.5-37.2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m147 106.6q-0.6-0.6-1.6-0.8c-1.1-0.2-2.1-0.3-3.2-0.4-1.8-0.3-3.6-0.4-5.5-0.5-1.9 0.3-3.6 0.9-5.3 2-0.8 0.5-1.5 1.3-2 2.2-0.6 0.9-0.7 1.9-0.7 3 0.1 1.3 0.2 2.6 0.2 3.9 0 1.2 0.6 1.8 1.6 2.3 0 0 0.1 0 0.1-0.1 0.6 0.6 1.6 1 2.4 0.3 0.8 0.5 2 0.5 2.9 0 1.1 0.4 2.3 1 2.8-0.4 0.3-0.6-0.1-1.2-0.5-1.6-0.3-0.3-0.6-0.6-0.9-0.9-0.3-0.2-0.5-0.3-0.7-0.4-0.3-0.2-0.3-0.5-0.2-0.7 0.7-0.9 1.5-1.7 2.6-1.8 1.2-0.1 2.5-0.1 3.7-0.1 1 0 3.4 0.3 4.2-0.7 1-0.6 0.8-2.2 0.7-3.2q-0.2-1.1-0.6-2.1z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m147.1 111.4q0 0 0 0 0 0.1-0.1 0.1-0.1 0.2-0.3 0.4 0 0 0 0c-0.8 0.5-2.5 0.3-3.2 0.4q-1.9 0-3.8 0c-0.8 0-1.5 0.1-2.2 0.7-0.8 0.6-1.4 1.6-1.9 2.4 0 0.1 0.1 0.1 0.1 0.1q0.2-0.3 0.4-0.6c0 0.3 0.1 0.5 0.5 0.7 0.6 0.5 1.2 0.9 1.7 1.6 0.5 0.7-0.2 1.7-1.1 1.4-0.4-0.1-0.8-0.3-1.1-0.5-0.8-0.4-1.9-0.3-2.1-1.3-0.1-0.7-0.2-1.5-0.2-2.2 0-1.1 0.8-1.9 1.3-2.7q0.7-1 1.1-2.1c0-0.1 0-0.1-0.1 0-0.5 0.9-1.1 1.8-1.7 2.7-0.4 0.6-0.9 1.3-0.9 2 0 0.8 0.1 1.8 0.3 2.7 0.1 0.7 0.9 0.9 1.5 1.1q0.2 0 0.4 0.1-0.2 0.1-0.5 0.1c-0.4 0.1-0.9 0-1.3 0-1.1-0.2-1.7-1-1.8-2-0.2-1.8 0.1-3.8 0.4-5.5q0-0.1-0.1-0.1c-0.1 0-0.1 0.1-0.1 0.1-0.1 0-0.5 3.3-0.5 3.6 0 0.8-0.2 1.8 0.1 2.6 0.1 0.5 0.5 0.9 0.9 1.2-0.9 0.4-1.9-0.2-2.3-0.9-0.3-0.6-0.3-1.5-0.4-2.1-0.1-0.9 0.1-1.8 0.2-2.6 0.1-0.7 0.3-1.4 0.3-2 0-0.1-0.1 0-0.1 0-0.1 1-0.5 2.1-0.6 3.1-0.1 1 0 2 0.1 3q0.1 0.5 0.4 1c-1.1-0.6-1.2-1.4-1.2-2.6 0-1-0.1-2.1-0.1-3.1-0.2-1.5 0.1-2.6 1-3.7 0.7-1 1.8-1.7 2.9-2.2 1.4-0.7 2.8-1 4.3-1.1 0.5 0 1.1 0.1 1.5 0.1 0.9 0.1 1.8 0.1 2.6 0.2q2.7 0.3 5.2 1 0.2 0.4 0.3 0.9c0.4 1.1 0.9 2.9 0.2 4z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m129.9 113.9c0.1-0.8 0.4-1.7 0.5-2.5q0-0.1 0-0.3c-0.3 0.5-0.5 1-0.6 1.5-0.1 0.6-0.2 1.2-0.3 1.7-0.1 0.2-0.2 0.6-0.3 0.9q0 0 0 0.1c0 1.2 0.1 2 1.2 2.6q-0.3-0.5-0.4-1c-0.1-1-0.2-2-0.1-3z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m130.2 113.2q0-0.1 0.1-0.2 0-0.4 0.1-0.8-0.1 0.3-0.1 0.6 0 0.2-0.1 0.4z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m133.8 117.2c-0.2-0.9-0.3-1.9-0.3-2.7 0-0.7 0.5-1.4 0.9-2q0.5-0.7 1-1.5 0.2-0.5 0.5-0.9-0.7 0.8-1.3 1.5c-1 1.1-1.1 2.2-1.6 3.5-0.1 0.2-0.4 0.2-0.4 0-0.3-0.9-0.3-1.7-0.4-2.6-0.1 1.3-0.2 2.7-0.1 4 0.1 1 0.7 1.8 1.8 2 0.4 0 0.9 0.1 1.3 0q0.3 0 0.5-0.1-0.2-0.1-0.4-0.1c-0.6-0.2-1.4-0.4-1.5-1.1z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m146.9 107.4q-0.1-0.5-0.3-0.9-2.5-0.7-5.2-1c0.6 0.3 1.2 0.6 1.6 1.2 0.7 1-0.7 2.7-1.5 3.2-0.6 0.4-1.3 0.6-2 0.8-0.8 0.3-2.2 0.5-2.8 1.2-1.1 1.2-1.2 3-2.3 4.3-0.1 0.1-0.3 0.1-0.3-0.1-0.2-1.1-0.1-2.1 0.4-3.1q0.1-0.3 0.2-0.5c-0.4 0.6-0.9 1.3-0.9 2.1 0 0.7 0.1 1.5 0.2 2.2 0.2 1 1.3 0.9 2.1 1.3 0.3 0.2 0.7 0.4 1.1 0.5 0.9 0.3 1.6-0.7 1.1-1.4-0.5-0.7-1.1-1.1-1.7-1.6-0.4-0.2-0.5-0.4-0.5-0.7q-0.2 0.3-0.4 0.6c0 0-0.1 0-0.1-0.1 0.5-0.8 1.1-1.8 1.9-2.4 0.7-0.6 1.4-0.7 2.2-0.7q1.9 0 3.8 0c0.7-0.1 2.4 0.1 3.2-0.4q0 0 0 0 0.2-0.2 0.3-0.4 0.1 0 0.1-0.1 0 0 0 0c0.7-1.1 0.2-2.9-0.2-4z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m131.9 117.2c-0.3-0.8-0.1-1.8-0.1-2.6 0-0.2 0.3-2.4 0.4-3.2v-0.1q-0.4 1.3-0.6 2.7c-0.1 0.4-0.1 1.3-0.5 1.5-0.6 0.2-0.9-0.5-1-0.9q0-0.1 0-0.1 0 0.4 0 0.9c0.1 0.6 0.1 1.5 0.4 2.1 0.4 0.7 1.4 1.3 2.3 0.9-0.4-0.3-0.8-0.7-0.9-1.2z"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m183.8 78.7c-0.6-2.2-2.5-5-4.9-5-2.3-0.7-5 1.5-5.9 3.6q-0.5 0.8-0.9 1.7c-0.3 0.8-0.4 1.8-0.6 2.8-0.2 1-0.4 2.1-0.6 3.2-0.3 2.3-0.4 4.7-0.5 7q0 1.6-0.2 3.1 0 0.8-0.1 1.6c0 0.3 0 0.9-0.1 1.3q-0.2 0-0.3 0.1c-0.2 0.1-0.5 0.1-0.6 0.4-0.1 0.2-0.1 0.4 0 0.6-0.2-0.1-0.5-0.2-0.8-0.1 0 0-0.1 0.1-0.1 0.2q0 0.1 0 0.2 0.1 0.1 0.3 0.3-0.2-0.1-0.3-0.1c-0.8-0.2-1.7 0.1-2.5 0.2-1.3 0.3-2.5 0.7-3.8 1-2.5 0.4-5 0.7-7.5 1-1.1 0.1-2.3 0.4-3.4 0.5-0.7 0-1.3-0.1-1.9-0.2q-0.2 0-0.4 0.1c-0.4-0.1-0.7-0.1-1 0.2-0.4 0.4-0.3 1.3-0.8 1.6q-0.2 0-0.4 0.1c-0.3 0-0.6 0.1-0.9 0.2-0.2 0.1-0.4 0.3-0.5 0.6-0.1 0.3 0 0.7 0 1.1q0.2 1.1 0.4 2.3c0.2 1.4 0.4 2.8 0.9 4.1 0.3 0.8 1.3 0.5 2 0.2q0.1 0.1 0.3 0.2c0.6 0.4 1.5 0 2.1-0.1 3.7-0.6 7.6 0.3 11.4 0.3 3.8 0 7.8 0.1 11.6-0.4 1.3-0.2 2.9-0.5 4-1.3 1-0.8 1.5-1.8 2-3 0.5-1 1-2.1 1.4-3.3 0.5-1.6 0.9-3.3 1.3-5 0.9-3.7 1.2-7.4 1.5-11.2 0.3-3.3 0.8-6.8-0.2-10.1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m183.5 90.3c-0.3 3.2-0.6 6.4-1.3 9.5-0.4 1.7-0.8 3.3-1.3 5-0.4 1.6-1.2 3-1.9 4.5q-0.1 0.1 0 0.2c-0.6 0.9-1.3 1.6-2.4 2-1.4 0.6-3.1 0.8-4.8 0.9-3.5 0.3-7 0.3-10.5 0.2-3.2 0-6.5-0.6-9.8-0.2-0.6 0.1-1.3 0.2-2 0.2-0.3 0-0.6 0-0.8-0.2q-0.3-0.1-0.3-0.4c-0.3-0.7-0.2-1.8-0.1-2.3 0-1 0-1.9-0.3-2.7q-0.2-0.4-0.4-0.7 0.3 0.9 0.4 2c0.1 0.9-0.1 1.9-0.1 2.8 0 0.5 0.1 0.9 0.3 1.3-0.6 0.2-1.3 0.3-1.6-0.4-0.4-1-0.5-2.2-0.7-3.2-0.1-1-0.2-1.9-0.4-2.8-0.2-0.6-0.4-1.4 0.6-1.6q0.3 0 0.7-0.2 0 0.1 0 0.1c0.3-0.1 0.5-0.2 0.7-0.5q0.1-0.3 0.1-0.7c0.1-0.4 0.4-0.5 0.6-0.5 0.5-0.2 0.9-0.1 1.4 0q0 0-0.1-0.1 0.5 0.2 1 0.2c1.1 0 2.3-0.4 3.5-0.5 2.3-0.3 4.7-0.5 7.1-0.9 1-0.2 2.1-0.4 3.2-0.7 1-0.2 2.3-0.7 3.3-0.6 1.3 0.1 1.7 1.3 2.2 2.3 0.3 0.7 0.7 1.3 1.2 1.9q0.3 0.1 0.5 0.2c-0.8-0.8-1.3-1.8-1.8-2.9-0.3-0.7-0.4-1.2-0.9-1.6q-0.1-0.2-0.2-0.3c-0.4-0.6 0.5-0.1 0.6 0 0.3 0.1 0.6 0.3 0.8 0.5 1.2 0.9 2.2 1.9 3.3 2.8 0.5 0.3 3.6 2.9 4.1 1.9q-0.1-0.1-0.1-0.2 0 0 0 0c-0.1 0.7-2.2-0.9-2.5-1-0.8-0.6-1.7-1.3-2.5-2-0.8-0.6-1.5-1.3-2.3-1.9q-0.2-0.2-0.5-0.4-0.1-0.2-0.1-0.3-0.1-0.2-0.1-0.3c-0.1-0.1 0.1-0.2 0.2-0.2 0.1-0.2 0.4-0.3 0.6-0.3 0.3-0.1 0.4-0.3 0.6-0.5q-0.1 0-0.1 0-0.2 0.1-0.4 0.2 0.1-0.4 0.1-0.7 0.2-1.6 0.3-3.1c0.2-2.2 0.2-4.4 0.3-6.5 0.1-2.3 0.7-4.4 1-6.5 0.2-2.1 1.1-3.9 2.4-5.4 1.2-1.2 2.9-1.9 4.7-1.9 1.1 0.2 2.1 1 2.9 1.8 1 1.3 1.6 3 1.9 4.5 0.7 3.3 0.1 6.9-0.3 10.2z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m183.5 90.3c-0.3 3.2-0.6 6.4-1.3 9.5-0.4 1.7-0.8 3.3-1.3 5-0.4 1.6-1.2 3-1.9 4.5q-0.1 0.1 0 0.2c-0.6 0.9-1.3 1.6-2.4 2-1.4 0.6-3.1 0.8-4.8 0.9-3.5 0.3-7 0.3-10.5 0.2-3.2 0-6.5-0.6-9.8-0.2-0.6 0.1-1.3 0.2-2 0.2-0.3 0-0.6 0-0.8-0.2q-0.3-0.1-0.3-0.4c-0.3-0.7-0.2-1.8-0.1-2.3 0-1 0-1.9-0.3-2.7q-0.2-0.4-0.4-0.7 0.3 0.9 0.4 2c0.1 0.9-0.1 1.9-0.1 2.8 0 0.5 0.1 0.9 0.3 1.3-0.6 0.2-1.3 0.3-1.6-0.4-0.4-1-0.5-2.2-0.7-3.2-0.1-1-0.2-1.9-0.4-2.8-0.2-0.6-0.4-1.4 0.6-1.6q0.3 0 0.7-0.2 0 0.1 0 0.1c0.3-0.1 0.5-0.2 0.7-0.5q0.1-0.3 0.1-0.7c0.1-0.4 0.4-0.5 0.6-0.5 0.5-0.2 0.9-0.1 1.4 0q0 0-0.1-0.1 0.5 0.2 1 0.2c1.1 0 2.3-0.4 3.5-0.5 2.3-0.3 4.7-0.5 7.1-0.9 1-0.2 2.1-0.4 3.2-0.7 1-0.2 2.3-0.7 3.3-0.6 1.3 0.1 1.7 1.3 2.2 2.3 0.3 0.7 0.7 1.3 1.2 1.9q0.3 0.1 0.5 0.2c-0.8-0.8-1.3-1.8-1.8-2.9-0.3-0.7-0.4-1.2-0.9-1.6q-0.1-0.2-0.2-0.3c-0.4-0.6 0.5-0.1 0.6 0 0.3 0.1 0.6 0.3 0.8 0.5 1.2 0.9 2.2 1.9 3.3 2.8 0.5 0.3 3.6 2.9 4.1 1.9q-0.1-0.1-0.1-0.2 0 0 0 0c-0.1 0.7-2.2-0.9-2.5-1-0.8-0.6-1.7-1.3-2.5-2-0.8-0.6-1.5-1.3-2.3-1.9q-0.2-0.2-0.5-0.4-0.1-0.2-0.1-0.3-0.1-0.2-0.1-0.3c-0.1-0.1 0.1-0.2 0.2-0.2 0.1-0.2 0.4-0.3 0.6-0.3 0.3-0.1 0.4-0.3 0.6-0.5q-0.1 0-0.1 0-0.2 0.1-0.4 0.2 0.1-0.4 0.1-0.7 0.2-1.6 0.3-3.1c0.2-2.2 0.2-4.4 0.3-6.5 0.1-2.3 0.7-4.4 1-6.5 0.2-2.1 1.1-3.9 2.4-5.4 1.2-1.2 2.9-1.9 4.7-1.9 1.1 0.2 2.1 1 2.9 1.8 1 1.3 1.6 3 1.9 4.5 0.7 3.3 0.1 6.9-0.3 10.2z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m148 104.1c0.2-0.3 0.6-1.1 1.1-1 0.5 0.1 0.9 0.4 1.4 0.3 0.6 0 1.3-0.2 1.9-0.3q4.2-0.9 8.5-1.7c1.9-0.4 4.3-0.5 6.1-1.4-0.9 0.1-1.9 0.4-2.7 0.6-1.1 0.3-2.2 0.5-3.2 0.7-2.4 0.4-4.8 0.6-7.1 0.9-1.2 0.1-2.4 0.5-3.5 0.5q-0.5 0-1-0.2 0.1 0.1 0.1 0.1c-0.5-0.1-0.9-0.2-1.4 0-0.2 0-0.5 0.1-0.6 0.5q0 0.4-0.1 0.7c-0.2 0.3-0.4 0.4-0.7 0.5q0 0 0-0.1-0.4 0.2-0.7 0.2c-0.7 0.2-0.8 0.6-0.7 1.1 0.1-0.5 0.6-0.7 1.1-0.9 0.6-0.1 1 0.2 1.2 0.7q0-0.6 0.3-1.2z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp10)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m169.4 99q0 0.1 0.1 0.3 0.3 0.2 0.5 0.4c0.8 0.5 1.5 1.2 2.2 1.9q-0.3-0.4-0.6-0.7c-0.5-0.5-1.1-0.9-1.4-1.5-0.1-0.2 0-0.3 0.1-0.4 0.2 0 1.9-0.4 1.5-0.8-0.3-0.2-0.6-0.5-0.8-0.8-0.1-0.2 0-0.6 0-0.8 0.1-0.8 0.2-1.7 0.2-2.5 0.2-3.1 0.6-6.1 0.8-9.2 0.1-2.5 0.2-5.3 1.6-7.5 0.7-1.2 1.7-2.2 2.8-3.1q-1.2 0.5-2.1 1.4c-1.3 1.5-2.2 3.3-2.4 5.4-0.3 2.1-0.9 4.2-1 6.5-0.1 2.1-0.1 4.3-0.3 6.5q-0.1 1.5-0.3 3.1 0 0.3-0.1 0.7 0.2-0.1 0.4-0.2 0 0 0.1 0c-0.2 0.2-0.3 0.4-0.6 0.5-0.2 0-0.5 0.1-0.6 0.3-0.1 0-0.3 0.1-0.2 0.2q0 0.1 0.1 0.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp11)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m183.8 80.1c-0.3-1.5-0.9-3.2-1.9-4.5-0.8-0.8-1.8-1.6-2.9-1.8q-1.4 0-2.6 0.6c1.6-0.1 2.9 1.2 3.4 2.7 0.3 0.9 0.3 1.7 0.1 2.5-0.4 0.9-1.3 1.3-1.7 2.1-0.6 1.2 1.2 2.3 1.4 3.4 0.1 1-0.4 2.2-0.8 3.1-1 2.9-1.6 6-2.4 9-0.3 1.1-0.4 2.4-0.7 3.5-0.2 0.6-0.5 1.1-1.1 1.3-0.9 0.2-1.9-0.3-2.9-0.9q0.3 0.3 0.6 0.5c0.8 0.7 1.7 1.4 2.5 2 0.3 0.1 2.4 1.7 2.5 1q0 0 0 0 0 0.1 0.1 0.2c-0.5 1-3.6-1.6-4.1-1.9q-0.8-0.6-1.6-1.4c1.1 1.4 2.4 2.6 3.4 4 0.6 0.7 2 2.3 0.9 3.1-1 0.8-2.4-0.5-3.1-1.1-1-1-1.6-2.3-2.1-3.6q0 0 0 0c0.2 1.3 0.3 2.7 0.4 4 0 0.1-0.1 0.2-0.2 0.2q-4.8 0.3-9.5 0.7c-1.5 0.1-3.1 0.2-4.6 0-1.1-0.1-2.1-0.7-3.2-1-1.5-0.4-1.9 1.3-2.7 2.2-0.5 0.5-1.1 0.4-1.6 0.1-0.7-0.3-0.8-1.5-0.9-2.2-0.3-0.9-0.7-1.8-1.2-2.6 0.2 1.6 0.3 3.2 0.3 4.8 0 0.2-0.3 0.3-0.4 0.1-0.7-0.7-1.1-1.6-1.5-2.5q0.1 0.5 0.2 1.1c0.2 1 0.3 2.2 0.7 3.2 0.3 0.7 1 0.6 1.6 0.4-0.2-0.4-0.3-0.8-0.3-1.3 0-0.9 0.2-1.9 0.1-2.8q-0.1-1.1-0.4-2 0.2 0.3 0.4 0.7c0.3 0.8 0.3 1.7 0.3 2.7-0.1 0.5-0.2 1.6 0.1 2.3q0 0.3 0.3 0.4c0.2 0.2 0.5 0.2 0.8 0.2 0.7 0 1.4-0.1 2-0.2 3.3-0.4 6.6 0.2 9.8 0.2 3.5 0.1 7 0.1 10.5-0.2 1.7-0.1 3.4-0.3 4.8-0.9 1.1-0.4 1.8-1.1 2.4-2q-0.1-0.1 0-0.2c0.7-1.5 1.5-2.9 1.9-4.5 0.5-1.7 0.9-3.3 1.3-5 0.7-3.1 1-6.3 1.3-9.5 0.4-3.3 1-6.9 0.3-10.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp12)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m146.5 111.6q0.1 0.2 0.1 0.4c0.3 0.7 1 0.6 1.6 0.4q-0.2-0.4-0.3-0.9c-0.4 0-0.9 0.1-1.4 0.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp13)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m183.8 80.1c-0.3-1.5-0.9-3.2-1.9-4.5-0.8-0.8-1.8-1.6-2.9-1.8q-0.2 0-0.3 0c1.8 0.8 3.2 2.7 3.7 4.9 0.4 2.3 0.2 4.5 0 6.8-0.3 2.5-0.7 5-1.2 7.5-0.5 2.6-1.2 5.2-1.4 7.8-0.1 0.8 0 2.6-1 3-1 0.3-2.4-0.2-3.4-0.6q-0.8-0.3-1.6-0.7c0.6 0.5 1.2 1.1 1.9 1.5 0.4 0.3 0.8 0.5 1.2 0.8 0.2 0 0.3 0 0.4-0.2q0 0 0 0 0 0.1 0.1 0.2-0.1 0.1-0.2 0.1 0.4 0.3 0.7 0.5c1.1 1 0.9 2.6 0.4 3.8-0.5 1.2-2.1 1.6-3.4 1.5-1 0-2.1-0.2-3.2-0.2-1.2 0-2.4 0.2-3.7 0.4-2.5 0.3-5 0.3-7.5 0.2-2.5 0-5-0.4-7.4-0.2-1.3 0.1-2.3 0.6-3.6 0.9-0.4 0.1-1-0.1-1.3-0.5q0 0 0 0.1 0.1 0.3 0.2 0.6 0 0.3 0.3 0.4c0.2 0.2 0.5 0.2 0.8 0.2 0.7 0 1.4-0.1 2-0.2 3.3-0.4 6.6 0.2 9.8 0.2 3.5 0.1 7 0.1 10.5-0.2 1.7-0.1 3.4-0.3 4.8-0.9 1.1-0.4 1.8-1.1 2.4-2q-0.1-0.1 0-0.2c0.7-1.5 1.5-2.9 1.9-4.5 0.5-1.7 0.9-3.3 1.3-5 0.7-3.1 1-6.3 1.3-9.5 0.4-3.3 1-6.9 0.3-10.2z"
  })))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "t",
    d: "m204.8 145.3l0.5-59.8 60.4 0.5-0.6 59.8z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "u",
    d: "m265.1 146l-60.3-0.5c-0.1 0-0.2-0.1-0.2-0.2l0.5-59.8c0-0.1 0.1-0.2 0.2-0.2l60.4 0.5q0 0 0.1 0.1 0.1 0 0.1 0.1l-0.6 59.8q0 0.1 0 0.2-0.1 0-0.2 0zm-60.2-0.9l60 0.6 0.6-59.5-60-0.6z"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp14)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "m249.3 143.1l-43.9 0.6 1.3-45.9 2.1 41.6z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp15)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "m265.1 145.8l-60.3-0.5 60.9-59.3z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp16)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "v",
    d: "m205.2 95.9l0.1-10.4 60.4 0.5-0.1 10.5z"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "w",
    d: "m204.2 93.5l0.1-10.7 62.4 0.6-0.1 10.6z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "x",
    d: "m266.6 94.2l-62.4-0.6q-0.1 0-0.1 0-0.1-0.1-0.1-0.2l0.1-10.6c0-0.1 0.1-0.1 0.2-0.1l62.4 0.5q0.1 0 0.1 0.1 0.1 0 0.1 0.1l-0.1 10.6c0 0.1-0.1 0.2-0.2 0.2zm-62.2-0.9l62 0.5 0.1-10.2-62-0.6z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "f",
    d: "m244.6 108.5v-10.4l17.4 0.2v10.3z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "u",
    d: "m262 108.8l-17.5-0.2c-0.1 0-0.1 0-0.1-0.1l0.1-10.4q0-0.1 0-0.1 0.1-0.1 0.1-0.1l17.5 0.2c0.1 0 0.1 0.1 0.1 0.2l-0.1 10.3q0 0.1 0 0.2-0.1 0-0.1 0zm-17.3-0.5l17.1 0.1 0.1-9.9-17.1-0.2z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m123.6 126.4l4.3-11.5-16.6-7.3-2.5 13.7z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "x",
    d: "m123.6 126.6q0 0 0 0l-14.8-5.2c-0.1 0-0.2-0.1-0.1-0.2l2.4-13.6q0.1-0.1 0.1-0.1 0.1-0.1 0.2 0l16.6 7.2c0.1 0 0.1 0.2 0.1 0.2l-4.3 11.6q0 0.1-0.2 0.1zm-14.6-5.5l14.5 5.1 4.2-11.2-16.2-7.1z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "m75 238.9c-6.2-0.1-11.9-3-15.7-7.9-3.5-4.7-4.8-10.8-3.6-16.5 2.5-12.2 16.1-19.2 27.5-14.3 8.8 3.7 13.6 13.5 11.7 22.7-1.9 9.3-10.5 16-19.9 16-0.3 0 0.1 0.2 0.2 0.2 11.2 0 20.4-8.9 20.6-20.1 0.2-10.9-8.7-19.9-19.3-20.6-11-0.8-20.7 7.8-21.7 18.7-0.9 10.8 7.3 20.4 17.9 21.8q1.3 0.2 2.5 0.2c0.3 0 0-0.2-0.2-0.2z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m75.1 215.7c4.6 5.1-6.5 8.8-5.7 1.3 1.3-1.1 3.7-2.5 5.7-1.3z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "A",
    d: "m75.1 215.7c4.6 5.1-6.5 8.8-5.7 1.3 1.3-1.1 3.7-2.5 5.7-1.3zm-1.1 4.2c-0.1-1.5 0.3-2.4-0.6-2.8-2-1-2.6 3.3 0.6 2.8z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m74 219.9c-0.1-1.5 0.3-2.4-0.6-2.8-2-1-2.6 3.3 0.6 2.8z"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp17)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "B",
    d: "m67.3 200.9l10.1-5.1 6.2 12.1-10.2 5.1z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp18)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "C",
    d: "m66.9 200.8l10.7-5.4 6.4 12.6-10.8 5.4z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp19)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "D",
    d: "m66.8 200.9l10.1-5.1 6.1 12.1-10.1 5.1z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp20)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "E",
    d: "m66.4 200.8l10.6-5.4 6.4 12.6-10.7 5.4z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp21)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "F",
    d: "m71.6 202.8l11.8-6 5.6 11.1-11.8 6z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp22)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "G",
    d: "m71.2 202.6l12.3-6.2 5.9 11.6-12.3 6.3z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp23)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "H",
    d: "m73.3 201.2l7.2-3.7 5.8 11.6-7.2 3.6z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp24)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "I",
    d: "m73 201.1l7.6-3.9 6 11.9-7.6 3.9z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp25)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "J",
    d: "m76.4 206.5l12-6.1 4.4 8.8-12 6.1z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp26)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "K",
    d: "m76 206.3l12.4-6.3 4.8 9.4-12.5 6.3z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp27)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "L",
    d: "m77.5 203.5l7.4-3.7 5.9 11.7-7.4 3.7z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp28)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "M",
    d: "m77.2 203.5l7.9-4 6.1 12-7.9 4z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp29)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "N",
    d: "m80.9 211.7l10.9-5.5 2.8 5.5-10.9 5.5z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp30)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "O",
    d: "m80.7 211.5l11.1-5.6 3 6-11.1 5.6z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp31)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "P",
    d: "m79.3 207.7l10.2-5.1 6.2 12.1-10.3 5.2z"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp32)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "Q",
    d: "m78.9 207.7l10.8-5.5 6.3 12.6-10.7 5.4z"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp33)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "R",
    d: "m81.1 215l12.1-6.1 4.5 8.9-12.1 6.1z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp34)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "S",
    d: "m80.8 214.8l12.4-6.3 4.8 9.4-12.4 6.3z"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp35)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "T",
    d: "m80.6 213.3l11.8-6 5.6 11.1-11.8 6z"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp36)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m80.2 213.1l12.3-6.2 5.9 11.6-12.3 6.3z"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp37)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "V",
    d: "m80.6 218.7l11.8-5.9 5.7 11.1-11.8 6z"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp38)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "W",
    d: "m80.3 218.6l12.2-6.2 6 11.7-12.3 6.2z"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp39)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "X",
    d: "m81.2 219.5l12.1-6.1 4.4 8.7-12 6.1z"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp40)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "Y",
    d: "m80.9 219.3l12.4-6.3 4.7 9.3-12.4 6.3z"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp41)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "Z",
    d: "m79.5 222.5l10.1-5.1 6.1 12.1-10.1 5.1z"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp42)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a0",
    d: "m79.1 222.4l10.7-5.4 6.3 12.6-10.6 5.4z"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp43)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a1",
    d: "m81 225.5l10.9-5.5 2.9 5.6-10.9 5.5z"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp44)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a2",
    d: "m80.8 225.3l11.1-5.6 3.1 6.1-11.1 5.6z"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp45)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a3",
    d: "m77.8 225.8l7.3-3.6 5.8 11.5-7.2 3.7z"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp46)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a4",
    d: "m77.5 225.8l7.7-3.9 6.1 11.9-7.8 3.9z"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp47)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a5",
    d: "m76.5 228l12.1-6.1 4.5 9-12.1 6.1z"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp48)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a6",
    d: "m76.2 227.8l12.4-6.3 4.8 9.5-12.4 6.3z"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp49)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a7",
    d: "m73.5 228.3l7.3-3.8 5.9 11.7-7.4 3.7z"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp50)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a8",
    d: "m73.1 228.2l7.9-3.9 6 11.9-7.8 4z"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp51)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a9",
    d: "m71.8 229.4l11.8-5.9 5.7 11.2-11.8 5.9z"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp52)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aa",
    d: "m71.5 229.3l12.2-6.2 6 11.7-12.3 6.2z"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp53)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ab",
    d: "m67 229.6l10.2-5.2 6.1 12.1-10.2 5.2z"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp54)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ac",
    d: "m66.6 229.5l10.7-5.5 6.4 12.6-10.7 5.4z"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp55)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ad",
    d: "m67.6 229.5l10.1-5.1 6.1 12.2-10.1 5.1z"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp56)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ae",
    d: "m67.2 229.5l10.6-5.4 6.4 12.5-10.6 5.4z"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp57)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "af",
    d: "m61.5 229.6l11.9-6 5.6 11.1-11.8 6z"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp58)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ag",
    d: "m61.2 229.4l12.3-6.2 5.9 11.6-12.3 6.3z"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp59)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ah",
    d: "m64.3 228.4l7.1-3.7 5.9 11.6-7.2 3.6z"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp60)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ai",
    d: "m63.9 228.3l7.7-3.9 6 11.9-7.7 3.9z"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp61)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aj",
    d: "m57.7 228.3l12.1-6.1 4.4 8.8-12 6.1z"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp62)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ak",
    d: "m57.4 228.1l12.4-6.3 4.8 9.3-12.5 6.3z"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp63)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "al",
    d: "m59.8 226l7.3-3.7 5.9 11.6-7.3 3.8z"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp64)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "am",
    d: "m59.4 226l7.9-4 6.1 12-7.9 4z"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp65)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "an",
    d: "m56 225.7l10.9-5.4 2.8 5.5-10.9 5.5z"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp66)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ao",
    d: "m55.7 225.6l11.2-5.6 3 6-11.1 5.6z"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp67)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ap",
    d: "m54.9 222.8l10.2-5.2 6.2 12.1-10.3 5.2z"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp68)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aq",
    d: "m54.5 222.7l10.8-5.5 6.4 12.6-10.8 5.4z"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp69)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ar",
    d: "m52.9 219.7l12-6.1 4.5 8.9-12 6.1z"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp70)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "as",
    d: "m52.6 219.5l12.4-6.3 4.8 9.5-12.5 6.3z"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp71)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "at",
    d: "m52.5 219.1l11.9-6 5.6 11.1-11.9 6z"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp72)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "au",
    d: "m52.2 218.9l12.3-6.2 5.9 11.6-12.4 6.2z"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp73)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "av",
    d: "m52.5 213.5l11.8-6 5.6 11.2-11.8 6z"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp74)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aw",
    d: "m52.1 213.4l12.3-6.2 5.9 11.7-12.3 6.2z"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp75)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ax",
    d: "m52.9 215.3l12-6.1 4.4 8.8-12 6.1z"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp76)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ay",
    d: "m52.6 215.1l12.4-6.2 4.7 9.2-12.4 6.3z"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp77)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "az",
    d: "m54.8 208l10.1-5.2 6.2 12.2-10.1 5.1z"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp78)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aA",
    d: "m54.5 207.9l10.6-5.4 6.4 12.6-10.7 5.3z"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp79)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aB",
    d: "m55.8 211.9l10.9-5.5 2.8 5.6-10.8 5.5z"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp80)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aC",
    d: "m55.6 211.7l11.1-5.6 3.1 6-11.2 5.7z"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp81)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aD",
    d: "m59.6 203.7l7.3-3.6 5.8 11.6-7.2 3.6z"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp82)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aE",
    d: "m59.3 203.7l7.7-3.9 6.1 11.9-7.8 3.9z"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp83)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aF",
    d: "m57.5 206.6l12-6.1 4.6 8.9-12.1 6.1z"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp84)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aG",
    d: "m57.1 206.4l12.5-6.3 4.8 9.5-12.5 6.3z"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp85)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aH",
    d: "m63.9 201.3l7.3-3.7 5.9 11.6-7.3 3.7z"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp86)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aI",
    d: "m63.6 201.2l7.8-3.9 6.1 11.9-7.9 4z"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp87)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aJ",
    d: "m61.3 202.8l11.8-6 5.6 11.2-11.8 6z"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp88)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aK",
    d: "m60.9 202.6l12.3-6.2 5.9 11.8-12.3 6.2z"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "aL",
    d: "m75.1 237.9v-1.2c5 0 9.5-2 12.8-5.2 3.2-3.2 5.3-7.7 5.3-12.6 0.1-5-1.9-9.5-5.1-12.7-3.2-3.3-7.7-5.4-12.7-5.4-4.9-0.1-9.4 1.9-12.7 5.1-3.3 3.2-5.3 7.7-5.4 12.7 0 4.9 2 9.4 5.2 12.7 3.2 3.3 7.7 5.3 12.6 5.4v1.2 1.2c-11.2-0.1-20.3-9.3-20.2-20.6 0.1-11.2 9.3-20.2 20.6-20.1 11.2 0.1 20.2 9.3 20.1 20.5-0.1 11.3-9.3 20.3-20.5 20.2z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "aM",
    d: "m75.4 237.1v-1.2c4.9 0 9.2-1.9 12.4-5 3.2-3.2 5.2-7.5 5.2-12.3 0.1-4.8-1.8-9.2-5-12.4-3.1-3.2-7.4-5.2-12.3-5.2-4.8-0.1-9.1 1.8-12.3 5-3.2 3.1-5.2 7.5-5.3 12.3 0 4.8 1.9 9.2 5 12.4 3.2 3.1 7.5 5.1 12.3 5.2v1.2 1.1c-10.9-0.1-19.7-9-19.6-20 0.1-10.9 9-19.7 20-19.6 10.9 0.1 19.7 9.1 19.6 20-0.1 10.9-9 19.7-20 19.6z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "aN",
    d: "m75 236.9l0.1-1.2c4.5 0.1 8.7-1.8 11.7-4.8 3-3.1 4.9-7.3 4.9-11.9 0.1-4.7-1.7-9-4.7-12.1-3-3-7.1-5-11.6-5-4.6-0.1-8.7 1.8-11.8 4.8-3 3.1-4.9 7.3-4.9 12 0 4.6 1.8 8.9 4.7 12 3 3.1 7.1 5 11.7 5l-0.1 1.2v1.1c-10.3-0.1-18.6-8.8-18.5-19.4 0.1-10.6 8.5-19.1 18.9-19 10.3 0.1 18.6 8.8 18.6 19.4-0.1 10.6-8.6 19.1-19 19z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "aO",
    d: "m75.1 236.1v-1.1c4.5 0 8.6-1.7 11.6-4.7 3-2.9 4.8-6.9 4.9-11.4 0-4.5-1.8-8.6-4.7-11.6-2.9-3-7-4.8-11.5-4.9-4.5 0-8.5 1.8-11.5 4.7-3 2.9-4.9 7-4.9 11.5 0 4.5 1.7 8.6 4.7 11.5 2.9 3 6.9 4.9 11.4 4.9v1.1 1.1c-10.2-0.1-18.4-8.4-18.3-18.6 0.1-10.2 8.4-18.4 18.7-18.4 10.2 0.1 18.4 8.5 18.3 18.7-0.1 10.2-8.5 18.4-18.7 18.3z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "aP",
    d: "m59.2 227.2c-4.6-12.7 2.3-21.8 9.2-24.3 2.2-0.8 7.9-1.5 8.5-1.4-4.6 0.1-9.3 1.3-12.9 4.4-3.3 2.8-4.6 7.2-5.2 11.5-0.8 6.7 2.8 13.7 8.9 16.4-0.1 0.3-2-0.2-1.7 0 4.8 2.9 11.9 3.3 16.7 0.6 3.7-2.3 7.8-5.4 9.4-9.6 1.6-4.2 1.2-9.4-0.8-13.3-2.2-4.5-5.6-6.6-9.9-8.7 1.9 0.6 3.7 1.3 5.2 2.5 3.2 2.4 5.1 5.6 6.6 9.1q0.6 2.2 0.6 4.5c-0.1 10.2-8.5 18.4-18.7 18.3-10.1-0.1-18.3-8.3-18.3-18.5 0 2.6 2.6 9 2.4 8.5z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "aP",
    d: "m91.6 218.9c0-3.8-1.2-7.2-3.4-10 0.8 0.9 1.5 1.9 2.1 3.2 1.6 3.9 2.5 9.1 0.4 12.9q-0.8 1.5-1.9 2.8c1.7-2.6 2.7-5.6 2.8-8.9z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "aO",
    d: "m65.3 218.9h1.2c0 2.4 0.9 4.6 2.5 6.2 1.6 1.6 3.8 2.6 6.2 2.7 2.4 0 4.6-1 6.2-2.6 1.6-1.5 2.6-3.7 2.7-6.1 0-2.5-1-4.7-2.6-6.3-1.5-1.6-3.7-2.6-6.1-2.6-2.5 0-4.7 0.9-6.3 2.5-1.6 1.6-2.6 3.8-2.6 6.2h-1.2-1.2c0-6.2 5.1-11.2 11.3-11.1 6.2 0 11.1 5.1 11.1 11.3-0.1 6.2-5.1 11.1-11.3 11.1-6.2-0.1-11.2-5.1-11.1-11.3z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "aQ",
    d: "m65.8 218.5h1.1c0 2.4 1 4.5 2.5 6 1.6 1.6 3.7 2.6 6.1 2.6 2.3 0 4.5-0.9 6.1-2.4 1.5-1.6 2.5-3.7 2.5-6 0-2.4-0.9-4.5-2.4-6-1.6-1.6-3.7-2.6-6.1-2.6-2.4 0-4.5 0.9-6.1 2.5-1.5 1.5-2.5 3.6-2.6 5.9h-1.1-1.2c0-6 5-10.8 11-10.7 6.1 0 10.9 4.9 10.9 10.9-0.1 6-5 10.8-11.1 10.7-6 0-10.9-4.9-10.8-10.9z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "aN",
    d: "m66.1 218.8h1.1c0 2.2 0.9 4.3 2.4 5.8 1.4 1.5 3.5 2.5 5.8 2.5 2.2 0 4.3-0.9 5.8-2.4 1.5-1.5 2.4-3.5 2.5-5.8 0-2.3-0.9-4.3-2.4-5.8-1.5-1.5-3.5-2.5-5.8-2.5-2.3 0-4.3 0.9-5.8 2.4-1.5 1.4-2.5 3.5-2.5 5.8h-1.1l-1.2-0.1c0.1-5.8 4.8-10.4 10.6-10.4 5.8 0.1 10.5 4.8 10.4 10.6 0 5.8-4.8 10.5-10.6 10.5-5.8-0.1-10.4-4.8-10.4-10.7z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "aL",
    d: "m65.3 218.9c-0.1 5.5 4.4 10 9.9 10.1 5.5 0 10-4.4 10.1-9.9 0-5.5-4.4-10.1-9.9-10.1-5.5-0.1-10.1 4.4-10.1 9.9z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "aM",
    d: "m81.5 226.3c0-3-5.2-0.6-6.4-0.7-4.4-0.2-5.9-3.5-5.8-7.4 0-1.3 0.3-2.9-0.8-3.8-0.7-0.7-1.6-0.2-2.4 0.5 1.6-3.5 5.2-5.9 9.3-5.9 5.5 0 9.9 4.6 9.9 10.1-0.1 3.2-1.6 6-3.9 7.8q0.1-0.3 0.1-0.6z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "aN",
    d: "m80.4 213.9c3.4 2 3.6 7.9 0.3 8.9 0.2-2.1 1.2-3.7 0.6-5.9-0.4-1.6-1.8-2.7-3.2-3.3-1.1-0.4-2.1-0.6-3-0.4 0.5-0.2 1-0.4 1.3-0.8 0.5-0.6 0.3-1.3-0.1-1.9-1.1-1.3-5.1 0.5-6.7 0.3 1.6-1.1 3.6-1.8 5.8-1.8 1.8 0 3.5 0.5 5 1.4-0.8 1.2-1.6 2.5 0 3.5z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "aO",
    d: "m71 218.7h1.2c0 1.7 1.3 3.1 3.1 3.1 1.7 0 3.1-1.3 3.1-3 0-1.8-1.4-3.2-3.1-3.2-1.7 0-3.1 1.4-3.1 3.1h-1.2-1.2c0-3.1 2.5-5.5 5.5-5.5 3.1 0 5.5 2.5 5.5 5.6 0 3-2.5 5.5-5.6 5.4-3 0-5.5-2.5-5.4-5.5z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "aO",
    d: "m71 218.7h1.2c0 1.7 1.3 3.1 3.1 3.1 1.7 0 3.1-1.3 3.1-3 0-1.8-1.4-3.2-3.1-3.2-1.7 0-3.1 1.4-3.1 3.1h-1.2-1.2c0-3.1 2.5-5.5 5.5-5.5 3.1 0 5.5 2.5 5.5 5.6 0 3-2.5 5.5-5.6 5.4-3 0-5.5-2.5-5.4-5.5z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "aO",
    d: "m71 218.7h1.2c0 1.7 1.3 3.1 3.1 3.1 1.7 0 3.1-1.3 3.1-3 0-1.8-1.4-3.2-3.1-3.2-1.7 0-3.1 1.4-3.1 3.1h-1.2-1.2c0-3.1 2.5-5.5 5.5-5.5 3.1 0 5.5 2.5 5.5 5.6 0 3-2.5 5.5-5.6 5.4-3 0-5.5-2.5-5.4-5.5z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "aM",
    d: "m71.2 218.4h1.2c0 1.7 1.3 3 3 3 1.7 0 3-1.3 3-2.9 0.1-1.6-1.3-3-3-3-1.6 0-3 1.3-3 2.9h-1.2-1.2c0-2.9 2.5-5.2 5.5-5.2 2.9 0 5.3 2.4 5.3 5.3 0 2.9-2.5 5.2-5.4 5.2-3 0-5.4-2.4-5.4-5.3z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "aN",
    d: "m71.2 218.5h1.1c0 1.6 1.3 2.8 2.9 2.8 1.5 0 2.8-1.2 2.8-2.7 0.1-1.5-1.2-2.8-2.8-2.8-1.6 0-2.9 1.2-2.9 2.7h-1.1-1.1c0-2.7 2.3-4.9 5.1-4.9 2.8 0.1 5.1 2.3 5.1 5 0 2.7-2.3 4.9-5.2 4.9-2.8 0-5.1-2.3-5-5z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "aL",
    d: "m71 218.7c0 2.4 1.9 4.3 4.2 4.3 2.4 0.1 4.4-1.9 4.4-4.2 0-2.4-1.9-4.4-4.3-4.4-2.4 0-4.3 1.9-4.3 4.3z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "aM",
    d: "m77.5 220.9c0.2-1.1-0.3-2.6-1.5-3-0.8-0.3-1.5-0.2-2.3-0.3-1.7-0.1-1.3-1.5-0.7-2.5 0.7-0.4 1.5-0.7 2.3-0.7 2.4 0 4.3 2 4.3 4.4 0 2.3-2 4.3-4.4 4.2 1.1-0.2 2-0.8 2.3-2.1z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "aN",
    d: "m78 216.3c-0.3 0.2-0.4 0.5-0.2 0.8 0.3 0.7 0.2 1.9 0.1 2.6-0.1 0.5 0 1.3-0.1 0.4q0-0.6-0.1-1.1c0-0.6 0-1.4-0.4-1.9-0.3-0.3-0.6-0.5-1-0.7-1-0.5-0.3-1.3 0.3-1.8 0.8 0.3 1.5 0.8 2 1.4q-0.3 0.1-0.6 0.3z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "h",
    d: "m102.4 219c-0.1 15-12.4 27-27.4 26.9-14.9-0.2-27-12.4-26.8-27.4 0.1-15 12.4-27 27.3-26.9 15 0.2 27 12.4 26.9 27.4zm-6.7-0.1c0.1-11.2-9-20.4-20.2-20.6-11.3-0.1-20.5 9-20.6 20.3-0.1 11.2 8.9 20.5 20.2 20.6 11.3 0.1 20.5-9 20.6-20.3z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aR",
    d: "m75.3 246.1h-0.3c-15-0.2-27.2-12.5-27-27.6 0.1-14.9 12.4-27 27.3-27h0.2c7.3 0 14.2 2.9 19.3 8.1 5.1 5.2 7.9 12.1 7.8 19.4-0.1 14.9-12.4 27.1-27.3 27.1zm0-54.3c-14.7 0-26.8 12-26.9 26.7-0.2 14.9 11.8 27.1 26.6 27.2h0.3c14.7 0 26.8-12 26.9-26.7 0.1-7.2-2.7-14-7.7-19.1-5-5.1-11.8-8-19-8.1zm0 47.6l-0.2-0.1c-11.3-0.1-20.5-9.4-20.4-20.7 0.1-11.3 9.4-20.4 20.6-20.4h0.2c5.5 0 10.7 2.2 14.5 6.1 3.9 4 6 9.1 5.9 14.6-0.1 11.3-9.3 20.5-20.6 20.5zm0-40.9c-11 0-20.1 9-20.2 20.1-0.1 11.1 8.9 20.3 20.1 20.4h0.1c11.1 0 20.2-9 20.3-20.1 0-5.4-2.1-10.5-5.8-14.3-3.8-3.9-8.9-6-14.3-6.1z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "aS",
    d: "m99.9 218.2c0.1-6.7-2.5-12.9-6.7-17.5 5.1 4.7 8.2 11.5 8.2 19-0.2 14.3-11.8 25.7-26.1 25.6-7.5-0.1-14.2-3.4-18.9-8.5 4.6 4.3 10.7 6.9 17.5 7 14.2 0.1 25.9-11.3 26-25.6z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp89)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp90)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aT",
    d: "m27.8 219.9l39.4-49.3 49.3 39.4-39.4 49.3z"
  }))))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp91)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m67.9 199.5q0.2 0 0.5 0.1c2.2-0.8 4.6-1.3 7.1-1.3 11 0.1 19.9 8.9 20.2 19.8q1.1 1.5 2.1 3c1.2 1.9 2.2 3.8 3.4 5.7 0.8-2.5 1.2-5.1 1.2-7.8 0.1-15-11.9-27.2-26.9-27.4-8.3 0-15.8 3.6-20.8 9.5 4.3-1.3 8.7-2 13.2-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aR",
    d: "m101.2 227q-0.1 0-0.2-0.1-0.7-1.1-1.3-2.3c-0.7-1.1-1.4-2.3-2.1-3.4q-1-1.5-2.1-2.9 0-0.1 0-0.1c-0.3-10.9-9.1-19.6-20-19.7h-0.2c-2.4 0-4.7 0.4-6.9 1.2q0 0-0.1 0h-0.1q-0.2 0-0.3 0c-4.1-0.4-8.6 0.1-13.1 1.6q-0.2 0-0.2-0.1-0.1-0.1 0-0.2c5.2-6.1 12.7-9.5 20.7-9.5h0.2c7.3 0 14.2 2.9 19.3 8.1 5.1 5.2 7.9 12.1 7.8 19.4 0 2.7-0.4 5.3-1.2 7.9q-0.1 0.1-0.2 0.1 0 0 0 0zm-5.3-8.9q1 1.4 2 2.9c0.8 1.1 1.4 2.3 2.1 3.5q0.6 0.9 1.1 1.9c0.7-2.4 1.1-4.9 1.1-7.4 0.1-7.2-2.7-14-7.7-19.1-5-5.1-11.8-8-19-8.1h-0.2c-7.7 0-14.9 3.3-20 8.9 4.4-1.3 8.6-1.8 12.6-1.4q0.2 0 0.3 0l0.1 0.1c2.3-0.8 4.6-1.2 7-1.2h0.2c11.1 0.1 20 8.8 20.4 19.9z"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "m237.2 240.3c-6.2-0.1-11.9-3-15.6-7.9-3.6-4.6-4.8-10.7-3.7-16.4 2.5-12.2 16.1-19.2 27.5-14.4 8.8 3.8 13.6 13.6 11.7 22.8-1.9 9.3-10.5 16-19.9 15.9-0.3 0 0.1 0.3 0.2 0.3 11.2 0 20.4-9 20.6-20.2 0.2-10.8-8.7-19.8-19.3-20.5-11-0.8-20.7 7.7-21.6 18.7-1 10.8 7.2 20.4 17.8 21.8q1.3 0.2 2.5 0.2c0.3 0 0-0.3-0.2-0.3z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m237.3 217.1c4.7 5.2-6.5 8.9-5.7 1.4 1.4-1.2 3.7-2.6 5.7-1.4z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "A",
    d: "m237.3 217.1c4.7 5.2-6.5 8.9-5.7 1.4 1.4-1.2 3.7-2.6 5.7-1.4zm-1.1 4.3c-0.1-1.5 0.3-2.4-0.6-2.9-2-0.9-2.6 3.3 0.6 2.9z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m236.2 221.4c-0.1-1.5 0.3-2.4-0.6-2.9-2-0.9-2.6 3.3 0.6 2.9z"
  })), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp92)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aU",
    d: "m229.5 202.4l10.2-5.2 6.1 12.2-10.2 5.1z"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp93)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aV",
    d: "m229.1 202.3l10.7-5.4 6.4 12.5-10.8 5.5z"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp94)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aW",
    d: "m229 202.4l10.1-5.1 6.1 12.1-10.1 5.1z"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp95)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aX",
    d: "m228.6 202.3l10.6-5.4 6.4 12.6-10.6 5.3z"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp96)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aY",
    d: "m233.8 204.2l11.8-6 5.6 11.2-11.8 5.9z"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp97)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aZ",
    d: "m233.4 204.1l12.3-6.3 5.9 11.7-12.3 6.2z"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp98)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b0",
    d: "m235.5 202.6l7.2-3.6 5.8 11.6-7.1 3.6z"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp99)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b1",
    d: "m235.2 202.6l7.6-3.9 6.1 11.9-7.7 3.9z"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp100)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b2",
    d: "m238.6 208l12-6.1 4.4 8.8-12 6z"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp101)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b3",
    d: "m238.2 207.8l12.5-6.3 4.7 9.3-12.5 6.3z"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp102)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b4",
    d: "m239.8 205l7.3-3.7 5.9 11.6-7.4 3.8z"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp103)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b5",
    d: "m239.4 205l7.9-4 6.1 12-7.9 3.9z"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp104)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b6",
    d: "m243.1 213.1l10.9-5.5 2.8 5.6-10.9 5.5z"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp105)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b7",
    d: "m242.9 212.9l11.1-5.6 3 6.1-11.1 5.6z"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp106)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b8",
    d: "m241.5 209.2l10.3-5.2 6.1 12.1-10.3 5.2z"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp107)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b9",
    d: "m241.1 209.1l10.8-5.4 6.4 12.5-10.8 5.5z"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp108)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ba",
    d: "m243.3 216.4l12.1-6.1 4.5 8.9-12.1 6.1z"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp109)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bb",
    d: "m243 216.3l12.5-6.3 4.7 9.4-12.4 6.3z"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp110)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bc",
    d: "m242.8 214.8l11.8-6 5.7 11.1-11.9 5.9z"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp111)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bd",
    d: "m242.4 214.6l12.4-6.2 5.8 11.6-12.3 6.2z"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp112)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "be",
    d: "m242.9 220.2l11.7-6 5.7 11.2-11.8 6z"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp113)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bf",
    d: "m242.5 220.1l12.3-6.3 5.9 11.8-12.3 6.2z"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp114)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bg",
    d: "m243.4 220.9l12.1-6 4.4 8.7-12 6.1z"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp115)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bh",
    d: "m243.1 220.8l12.4-6.3 4.7 9.3-12.4 6.3z"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp116)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bi",
    d: "m241.7 224l10.1-5.2 6.2 12.2-10.2 5.1z"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp117)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bj",
    d: "m241.3 223.9l10.7-5.4 6.3 12.6-10.6 5.3z"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp118)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bk",
    d: "m243.2 227l10.9-5.6 2.9 5.6-10.9 5.6z"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp119)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bl",
    d: "m243 226.8l11.1-5.7 3.1 6.1-11.1 5.7z"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp120)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bm",
    d: "m240.1 227.3l7.2-3.7 5.8 11.6-7.2 3.7z"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp121)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bn",
    d: "m239.7 227.2l7.8-3.9 6 11.9-7.7 3.9z"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp122)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bo",
    d: "m238.7 229.5l12.1-6.1 4.5 8.9-12 6.1z"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp123)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bp",
    d: "m238.4 229.3l12.5-6.3 4.7 9.5-12.4 6.3z"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp124)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bq",
    d: "m235.7 229.7l7.3-3.7 5.9 11.7-7.4 3.7z"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp125)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "br",
    d: "m235.3 229.7l7.9-4 6 12-7.8 4z"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp126)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bs",
    d: "m234.1 230.9l11.7-6 5.7 11.2-11.8 6z"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp127)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bt",
    d: "m233.7 230.8l12.3-6.3 5.9 11.8-12.3 6.2z"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp128)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bu",
    d: "m229.2 231l10.2-5.1 6.1 12.1-10.2 5.1z"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp129)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bv",
    d: "m228.8 230.9l10.8-5.4 6.3 12.6-10.7 5.4z"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp130)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bw",
    d: "m229.8 231l10.1-5.1 6.1 12.1-10.1 5.1z"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bx",
    d: "m229.4 230.9l10.6-5.4 6.4 12.6-10.6 5.4z"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp132)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "by",
    d: "m223.8 231l11.8-5.9 5.6 11.1-11.8 6z"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp133)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bz",
    d: "m223.4 230.9l12.3-6.2 5.9 11.6-12.3 6.2z"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp134)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bA",
    d: "m226.5 229.8l7.1-3.6 5.9 11.6-7.2 3.6z"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp135)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bB",
    d: "m226.1 229.8l7.7-3.9 6 11.9-7.6 3.9z"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp136)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bC",
    d: "m220 229.7l12-6.1 4.4 8.8-12 6.1z"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp137)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bD",
    d: "m219.6 229.6l12.5-6.3 4.7 9.3-12.5 6.3z"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp138)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bE",
    d: "m222 227.5l7.4-3.8 5.8 11.7-7.3 3.7z"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp139)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bF",
    d: "m221.6 227.4l7.9-4 6.1 12-7.9 4z"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp140)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bG",
    d: "m218.2 227.2l10.9-5.5 2.8 5.6-10.9 5.5z"
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp141)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bH",
    d: "m218 227l11.1-5.6 3 6-11.1 5.7z"
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp142)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bI",
    d: "m217.1 224.2l10.3-5.1 6.1 12.1-10.3 5.1z"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp143)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bJ",
    d: "m216.7 224.2l10.8-5.5 6.4 12.6-10.8 5.4z"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp144)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bK",
    d: "m215.1 221.1l12.1-6 4.5 8.9-12.1 6.1z"
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp145)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bL",
    d: "m214.8 221l12.4-6.3 4.8 9.4-12.5 6.3z"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp146)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bM",
    d: "m214.7 220.5l11.9-6 5.6 11.1-11.8 6z"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp147)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bN",
    d: "m214.4 220.4l12.3-6.2 5.9 11.6-12.4 6.2z"
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp148)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bO",
    d: "m214.7 215l11.8-6 5.6 11.2-11.7 6z"
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp149)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bP",
    d: "m214.3 214.8l12.3-6.2 5.9 11.7-12.3 6.2z"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp150)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bQ",
    d: "m215.1 216.8l12-6.1 4.5 8.7-12.1 6.1z"
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp151)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bR",
    d: "m214.8 216.6l12.4-6.3 4.7 9.3-12.4 6.3z"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp152)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bS",
    d: "m217 209.4l10.2-5.1 6.1 12.1-10.1 5.1z"
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp153)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bT",
    d: "m216.7 209.3l10.6-5.3 6.4 12.5-10.7 5.4z"
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp154)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bU",
    d: "m218 213.3l10.9-5.5 2.9 5.6-10.9 5.5z"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp155)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bV",
    d: "m217.8 213.2l11.1-5.7 3.1 6.1-11.1 5.6z"
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp156)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bW",
    d: "m221.9 205.2l7.2-3.7 5.8 11.6-7.2 3.7z"
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp157)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bX",
    d: "m221.5 205.1l7.7-3.9 6.1 11.9-7.8 3.9z"
  }))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp158)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bY",
    d: "m219.7 208.1l12.1-6.1 4.5 8.9-12.1 6.1z"
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp159)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bZ",
    d: "m219.4 207.9l12.4-6.3 4.8 9.5-12.5 6.3z"
  }))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp160)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c0",
    d: "m226.1 202.7l7.3-3.7 5.9 11.7-7.3 3.7z"
  }))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp161)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c1",
    d: "m225.8 202.7l7.8-4 6.1 12-7.9 4z"
  }))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp162)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c2",
    d: "m223.5 204.3l11.8-6 5.6 11.2-11.7 6z"
  }))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp163)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c3",
    d: "m223.1 204.1l12.3-6.2 5.9 11.7-12.3 6.2z"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "aL",
    d: "m237.3 239.3v-1.2c5 0.1 9.5-1.9 12.8-5.1 3.3-3.2 5.3-7.7 5.3-12.6 0.1-5-1.9-9.5-5.1-12.8-3.2-3.3-7.7-5.3-12.6-5.4-5 0-9.5 2-12.8 5.2-3.3 3.2-5.3 7.7-5.3 12.6-0.1 5 1.9 9.5 5.1 12.8 3.2 3.2 7.7 5.3 12.6 5.3v1.2 1.3c-11.2-0.1-20.3-9.3-20.2-20.6 0.1-11.2 9.3-20.3 20.6-20.2 11.2 0.1 20.3 9.3 20.2 20.6-0.1 11.2-9.3 20.3-20.6 20.2z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "aM",
    d: "m237.6 238.5v-1.2c4.9 0.1 9.2-1.8 12.4-5 3.2-3.1 5.2-7.4 5.3-12.2 0-4.9-1.9-9.2-5-12.4-3.2-3.2-7.5-5.2-12.3-5.3-4.9 0-9.2 1.9-12.4 5-3.2 3.2-5.2 7.5-5.2 12.3-0.1 4.9 1.8 9.2 5 12.4 3.1 3.2 7.4 5.2 12.2 5.2v1.2 1.2c-10.9-0.1-19.7-9-19.6-20 0.1-10.9 9-19.7 20-19.6 10.9 0.1 19.7 9 19.6 20-0.1 10.9-9 19.7-20 19.6z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "aN",
    d: "m237.3 238.3v-1.1c4.5 0 8.7-1.8 11.7-4.9 3-3 4.9-7.2 4.9-11.9 0.1-4.7-1.7-8.9-4.7-12-3-3.1-7.1-5-11.6-5.1-4.6 0-8.7 1.9-11.7 4.9-3.1 3-4.9 7.2-5 11.9 0 4.7 1.8 8.9 4.7 12 3 3.1 7.1 5.1 11.7 5.1v1.1 1.2c-10.4-0.1-18.7-8.8-18.6-19.4 0.1-10.6 8.5-19.1 18.9-19 10.4 0.1 18.7 8.7 18.6 19.3-0.1 10.7-8.6 19.2-18.9 19.1z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "aO",
    d: "m237.3 237.6l0.1-1.1c4.5 0 8.5-1.8 11.5-4.7 3-2.9 4.8-7 4.9-11.5 0-4.5-1.8-8.5-4.7-11.5-2.9-3-7-4.8-11.5-4.9-4.5 0-8.5 1.8-11.5 4.7-3 2.9-4.8 6.9-4.9 11.4 0 4.5 1.8 8.6 4.7 11.6 2.9 3 7 4.8 11.5 4.9l-0.1 1.1v1.1c-10.2-0.1-18.4-8.5-18.3-18.7 0.1-10.2 8.5-18.4 18.7-18.3 10.2 0.1 18.4 8.5 18.3 18.7-0.1 10.2-8.5 18.4-18.7 18.3z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "aP",
    d: "m221.4 228.7c-4.6-12.7 2.3-21.8 9.2-24.3 2.2-0.8 7.9-1.5 8.5-1.4-4.6 0-9.3 1.3-12.9 4.3-3.3 2.9-4.6 7.3-5.1 11.6-0.9 6.7 2.7 13.7 8.8 16.4-0.1 0.3-2-0.2-1.7 0 4.8 2.8 11.9 3.3 16.7 0.5 3.8-2.2 7.8-5.4 9.4-9.6 1.6-4.1 1.2-9.3-0.8-13.2-2.2-4.5-5.6-6.7-9.9-8.7 1.9 0.5 3.7 1.3 5.3 2.5 3.1 2.4 5 5.5 6.6 9.1q0.5 2.1 0.5 4.5c-0.1 10.2-8.5 18.4-18.7 18.3-10.1-0.1-18.3-8.4-18.3-18.5 0 2.6 2.6 9 2.4 8.5z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "aP",
    d: "m253.8 220.3c0-3.7-1.2-7.2-3.3-9.9 0.7 0.9 1.4 1.9 2 3.1 1.7 3.9 2.5 9.1 0.4 13q-0.8 1.4-1.9 2.7c1.7-2.5 2.7-5.6 2.8-8.9z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "aO",
    d: "m227.5 220.4h1.2c0 2.4 1 4.6 2.5 6.2 1.6 1.6 3.8 2.6 6.2 2.6 2.4 0 4.6-0.9 6.2-2.5 1.7-1.6 2.7-3.7 2.7-6.2 0-2.4-1-4.6-2.5-6.2-1.6-1.6-3.8-2.6-6.2-2.6-2.4 0-4.6 0.9-6.3 2.5-1.6 1.6-2.6 3.7-2.6 6.2h-1.2l-1.2-0.1c0.1-6.1 5.1-11.1 11.3-11 6.2 0 11.1 5.1 11.1 11.2-0.1 6.2-5.1 11.2-11.3 11.1-6.2 0-11.2-5.1-11.1-11.3z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "aQ",
    d: "m228 220h1.2c-0.1 2.3 0.9 4.5 2.4 6 1.6 1.6 3.7 2.5 6.1 2.5 2.3 0.1 4.5-0.9 6.1-2.4 1.5-1.5 2.5-3.6 2.5-6 0.1-2.3-0.9-4.4-2.4-6-1.6-1.5-3.7-2.5-6.1-2.5-2.3 0-4.5 0.9-6.1 2.4-1.5 1.5-2.5 3.6-2.5 6h-1.2-1.2c0.1-6 5-10.8 11-10.7 6.1 0 10.9 4.9 10.9 10.9-0.1 5.9-5 10.7-11 10.7-6.1-0.1-11-5-10.9-10.9z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "aN",
    d: "m228.3 220.2h1.1c0 2.3 0.9 4.4 2.4 5.9 1.5 1.5 3.5 2.4 5.8 2.5 2.3 0 4.3-0.9 5.8-2.4 1.5-1.5 2.5-3.5 2.5-5.8 0-2.3-0.9-4.4-2.4-5.9-1.5-1.5-3.5-2.4-5.8-2.4-2.2-0.1-4.3 0.8-5.8 2.3-1.5 1.5-2.5 3.5-2.5 5.8h-1.1-1.1c0-5.8 4.7-10.5 10.6-10.4 5.8 0 10.4 4.8 10.4 10.6-0.1 5.8-4.8 10.5-10.6 10.4-5.8 0-10.5-4.8-10.4-10.6z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "aL",
    d: "m227.5 220.4c0 5.5 4.4 10 9.9 10 5.5 0.1 10-4.3 10.1-9.9 0-5.5-4.4-10-9.9-10-5.5-0.1-10 4.3-10.1 9.9z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "aM",
    d: "m243.7 227.8c0-3.1-5.2-0.7-6.4-0.7-4.4-0.2-5.9-3.5-5.8-7.4 0-1.3 0.3-2.9-0.7-3.8-0.8-0.7-1.7-0.2-2.4 0.5 1.5-3.5 5.1-6 9.2-5.9 5.5 0 9.9 4.5 9.9 10 0 3.2-1.6 6-3.9 7.9q0.1-0.3 0.1-0.6z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "aN",
    d: "m242.6 215.3c3.4 2.1 3.6 7.9 0.3 8.9 0.2-2 1.2-3.6 0.6-5.9-0.3-1.6-1.8-2.6-3.2-3.2-1.1-0.5-2.1-0.6-3-0.5 0.5-0.1 1-0.4 1.3-0.7 0.5-0.6 0.3-1.4-0.1-1.9-1.1-1.3-5 0.4-6.7 0.3 1.6-1.2 3.6-1.9 5.8-1.8 1.8 0 3.5 0.5 5 1.4-0.8 1.1-1.6 2.4 0 3.4z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "aO",
    d: "m233.2 220.2h1.2c0 1.7 1.4 3.1 3.1 3.1 1.7 0 3.1-1.4 3.1-3.1 0-1.7-1.4-3.1-3.1-3.1-1.7 0-3.1 1.4-3.1 3.1h-1.2l-1.2-0.1c0-3 2.5-5.4 5.6-5.4 3 0 5.4 2.5 5.4 5.5 0 3.1-2.5 5.5-5.5 5.5-3.1 0-5.5-2.5-5.5-5.6z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "aO",
    d: "m233.2 220.2h1.2c0 1.7 1.4 3.1 3.1 3.1 1.7 0 3.1-1.4 3.1-3.1 0-1.7-1.4-3.1-3.1-3.1-1.7 0-3.1 1.4-3.1 3.1h-1.2l-1.2-0.1c0-3 2.5-5.4 5.6-5.4 3 0 5.4 2.5 5.4 5.5 0 3.1-2.5 5.5-5.5 5.5-3.1 0-5.5-2.5-5.5-5.6z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "aO",
    d: "m233.2 220.2h1.2c0 1.7 1.4 3.1 3.1 3.1 1.7 0 3.1-1.4 3.1-3.1 0-1.7-1.4-3.1-3.1-3.1-1.7 0-3.1 1.4-3.1 3.1h-1.2l-1.2-0.1c0-3 2.5-5.4 5.6-5.4 3 0 5.4 2.5 5.4 5.5 0 3.1-2.5 5.5-5.5 5.5-3.1 0-5.5-2.5-5.5-5.6z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "aM",
    d: "m233.4 219.9h1.2c0 1.6 1.3 2.9 3 3 1.7 0 3-1.3 3.1-2.9 0-1.7-1.4-3-3.1-3-1.6 0-3 1.3-3 2.9h-1.2-1.2c0-2.9 2.5-5.2 5.5-5.2 2.9 0 5.3 2.4 5.3 5.3 0 2.9-2.4 5.2-5.4 5.2-3-0.1-5.4-2.4-5.4-5.3z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "aN",
    d: "m233.4 220h1.1c0 1.5 1.3 2.8 2.9 2.8 1.5 0 2.8-1.2 2.9-2.8 0-1.5-1.3-2.7-2.9-2.8-1.6 0-2.9 1.3-2.9 2.8h-1.1-1.1c0-2.7 2.3-4.9 5.1-4.9 2.9 0 5.1 2.2 5.1 5 0 2.7-2.3 4.9-5.2 4.8-2.8 0-5-2.2-5-4.9z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "aL",
    d: "m233.2 220.2c0 2.3 1.9 4.3 4.3 4.3 2.3 0 4.3-1.9 4.3-4.3 0-2.3-1.9-4.3-4.3-4.3-2.3 0-4.3 1.9-4.3 4.3z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "aM",
    d: "m239.7 222.4c0.2-1.2-0.3-2.7-1.5-3.1-0.8-0.2-1.5-0.2-2.3-0.2-1.7-0.1-1.3-1.6-0.7-2.6 0.7-0.4 1.5-0.6 2.3-0.6 2.4 0 4.3 2 4.3 4.3 0 2.4-2 4.3-4.3 4.3h-0.1c1.1-0.2 2-0.8 2.3-2.1z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "aN",
    d: "m240.2 217.8c-0.3 0.1-0.4 0.5-0.2 0.8 0.3 0.7 0.3 1.9 0.1 2.6-0.1 0.4 0 1.3-0.1 0.4q0-0.6-0.1-1.1c0-0.6 0-1.4-0.4-1.9-0.3-0.3-0.6-0.6-1-0.8-1-0.4-0.3-1.3 0.3-1.7 0.8 0.3 1.5 0.8 2 1.4q-0.2 0.1-0.6 0.3z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "h",
    d: "m264.6 220.5c-0.1 14.9-12.4 27-27.3 26.8-15-0.1-27.1-12.3-26.9-27.3 0.1-15 12.4-27 27.3-26.9 15 0.1 27.1 12.4 26.9 27.4zm-6.7-0.1c0.1-11.3-8.9-20.5-20.2-20.6-11.3-0.1-20.5 9-20.6 20.2-0.1 11.3 8.9 20.5 20.2 20.6 11.3 0.1 20.5-8.9 20.6-20.2z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aR",
    d: "m237.5 247.5h-0.2c-7.3 0-14.2-2.9-19.3-8.1-5.1-5.2-7.9-12.1-7.8-19.4 0.1-14.9 12.4-27.1 27.3-27.1h0.2c7.3 0.1 14.2 3 19.3 8.2 5.1 5.2 7.9 12.1 7.8 19.4-0.1 14.9-12.4 27-27.3 27zm0-54.2c-14.7 0-26.8 12-26.9 26.7-0.1 7.2 2.6 14 7.7 19.1 5 5.1 11.8 8 19 8.1h0.2c14.7 0 26.8-12 26.9-26.7 0.1-7.2-2.6-14-7.7-19.1-5-5.2-11.8-8-19-8.1zm0.1 47.5h-0.2c-11.4-0.1-20.5-9.4-20.4-20.8 0.1-11.2 9.3-20.4 20.5-20.4h0.2c5.5 0.1 10.7 2.3 14.5 6.2 3.9 3.9 6 9.1 5.9 14.6-0.1 11.3-9.3 20.4-20.5 20.4zm-0.1-40.8c-11 0-20.1 9-20.2 20-0.1 11.2 8.9 20.3 20.1 20.4h0.2c11 0 20.1-8.9 20.2-20 0-5.4-2-10.5-5.8-14.3-3.8-3.9-8.9-6.1-14.3-6.1z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "aS",
    d: "m262.1 219.7c0.1-6.8-2.5-12.9-6.7-17.6 5.1 4.8 8.3 11.6 8.2 19.1-0.1 14.2-11.8 25.7-26.1 25.5-7.5 0-14.2-3.3-18.9-8.4 4.6 4.2 10.7 6.9 17.5 7 14.2 0.1 25.9-11.4 26-25.6z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp164)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp165)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c4",
    d: "m190 221.3l39.4-49.2 49.3 39.4-39.4 49.2z"
  }))))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp166)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c5",
    d: "m236.8 220.5v-2.4h2.4v2.4z"
  }))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp167)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m217.1 220c0.1-11.2 9.3-20.3 20.6-20.2 6.9 0.1 12.9 3.6 16.6 8.8q2.6-2.2 5.5-3.8c-4.8-7-12.9-11.6-22.1-11.7-14.9-0.1-27.2 11.9-27.3 26.9q0 3 0.6 5.8c2.5 0.7 5 1.3 7.5 1.9-0.9-2.4-1.4-5-1.4-7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aR",
    d: "m218.5 227.9q0 0 0 0c-1.4-0.4-2.8-0.7-4.1-1q-1.7-0.4-3.5-0.9-0.1 0-0.1-0.1-0.6-2.9-0.6-5.9c0.1-14.9 12.4-27.1 27.3-27.1h0.2c8.9 0.1 17.2 4.5 22.3 11.8q0 0.1 0 0.1 0 0.1-0.1 0.2-2.9 1.6-5.5 3.8-0.1 0-0.1 0-0.1 0-0.2-0.1c-3.7-5.4-9.9-8.6-16.4-8.7h-0.2c-11.1 0-20.1 9-20.2 20 0 2.7 0.4 5.2 1.4 7.6q0 0.1 0 0.2-0.1 0.1-0.2 0.1zm-7.4-2.2q1.7 0.4 3.4 0.8 1.8 0.5 3.7 0.9-1.3-3.5-1.3-7.4c0.1-11.2 9.3-20.4 20.6-20.4h0.2c6.6 0.1 12.8 3.3 16.6 8.7q2.5-2 5.2-3.6c-5-7.1-13.1-11.3-21.8-11.4h-0.2c-14.7 0-26.8 12-26.9 26.7q-0.1 2.9 0.5 5.7z"
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "c6",
    d: "m218.3 197.4l19 15.8-9.7 14.7-23.6-9.4z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "c7",
    d: "m210.5 220.5l-6.1-2.5 14.3-21 3.8 3c-3.8 7-7.9 13.7-12 20.5z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "c7",
    d: "m213 221.4l-1.7-0.6c4-6.7 8.1-13.4 11.8-20.2l1.2 1c-4.1 6.4-7.6 13.1-11.3 19.8z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "c7",
    d: "m214.7 222.1l-1-0.4c3.6-6.6 7.2-13.3 11.2-19.6l1.4 1.1c-3.8 6.4-7.8 12.6-11.6 18.9z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "c7",
    d: "m227.5 209.4c-2.1 2.6-4 5.4-5.8 8.1q-2 2.9-4 5.8l-0.6-0.3q1.9-3.1 3.9-6.2c2.4-3.9 5.1-7.7 7.6-11.6l1.3 1q-1.2 1.6-2.4 3.2z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "c7",
    d: "m220.8 224.5l-2.3-0.9q2.4-3.6 4.9-7.3c2.3-3.2 4.9-6.3 7.2-9.5l1.2 1q-5.6 8.3-11 16.7z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "c7",
    d: "m222.9 225.4l-1.4-0.6q5.4-8.3 10.9-16.5l1.4 1.2c-3.2 5.5-7.2 10.6-10.9 15.9z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "c7",
    d: "m228.7 220.9c-1.1 1.8-2.3 3.6-3.4 5.4l-1.6-0.6c3.6-5.3 7.5-10.3 10.8-15.7l1.2 1c-2.1 3.4-4.8 6.6-7 9.9z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "c7",
    d: "m229.1 221.8c2.2-3.4 5-6.7 7.2-10.3l1.4 1.2-9.7 14.7-2-0.8q1.6-2.4 3.1-4.8z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "c7",
    d: "m219.6 217.4q-1.6 2.7-3.3 5.3l-0.9-0.3c3.8-6.2 7.8-12.4 11.5-18.7l1.1 1c-2.7 4.3-5.7 8.4-8.4 12.7z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp168)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c7",
    d: "m221.3 204.1c0.8 2.7 2.2 4.7 4.2 6.6 2.2 2 4.7 3.7 7 5.6q0.9 0.8 1.8 1.5l-6.7 10.1-23.6-9.4 14.3-21.1 1.7 1.5c0.5 1.7 0.8 3.5 1.3 5.2z"
  })))), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "c8",
    d: "m246.8 215.3c0.3-7.3-6.8-11.9-7.6-12.4l-17.2-11.6-2.2 3.3 17.3 11.7c0.1 0.1 6.8 4.2 5.5 10.2l4 0.8q0.2-1 0.2-2z"
  })), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp169)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c9",
    d: "m237.4 204.4c2.8 2 5.6 4.3 6.8 7.7q0.7 2.4 0.9 4.9l-2.5-0.5c1.3-6-5.4-10.1-5.5-10.2l-17.3-11.7 0.6-1c5.8 3.3 11.6 6.9 17 10.8z"
  }))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp170)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c8",
    d: "m242 211.7q1.4-1.6 2.9-3.2c1.1 1.9 2 4.2 1.9 6.8q0 1-0.2 2l-4-0.8c0.4-1.8 0.1-3.4-0.6-4.8z"
  }))), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "ca",
    d: "m235.2 231.1c6 0.2 11.1-4.5 11.3-10.5 0.2-6-4.5-11.1-10.5-11.3-6-0.2-11.1 4.5-11.3 10.5-0.2 6 4.5 11.1 10.5 11.3z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aR",
    d: "m235.6 231.3q-0.2 0-0.4 0c-6.1-0.3-10.9-5.4-10.7-11.5 0.2-6.1 5.3-10.9 11.5-10.7 2.9 0.1 5.7 1.4 7.7 3.5 2 2.2 3.1 5 3 8-0.2 6-5.1 10.7-11.1 10.7zm0-21.8c-5.8 0-10.5 4.5-10.7 10.3-0.2 5.9 4.4 10.9 10.3 11.1q0.2 0 0.4 0c5.8 0 10.5-4.5 10.7-10.3 0.1-2.9-0.9-5.6-2.9-7.7-1.9-2.1-4.6-3.3-7.4-3.4q-0.2 0-0.4 0z"
  })), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp171)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c8",
    d: "m224.7 197.9l-4.9-3.3 2.2-3.3 4.7 3.2q-1 1.7-2 3.4z"
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "ca",
    d: "m236.8 228.8c4.5 0.1 8.2-3.3 8.3-7.8 0.2-4.4-3.3-8.1-7.7-8.3-4.4-0.1-8.1 3.3-8.3 7.8-0.2 4.4 3.3 8.1 7.7 8.3z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "cb",
    d: "m237.1 228.9q-0.1 0-0.3 0c-4.5-0.1-8.1-3.9-7.9-8.5 0.2-4.5 3.9-8 8.5-7.9 2.2 0.1 4.2 1 5.7 2.6 1.5 1.7 2.3 3.7 2.2 5.9-0.1 4.5-3.7 7.9-8.2 7.9zm0-16c-4.2 0-7.7 3.3-7.8 7.6-0.2 4.3 3.2 7.9 7.5 8.1 4.4 0.1 8-3.2 8.1-7.6 0.1-2.1-0.6-4.1-2.1-5.6-1.4-1.5-3.3-2.4-5.4-2.5q-0.2 0-0.3 0z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "ca",
    d: "m236.8 227.5c3.8 0.1 6.9-2.8 7-6.5 0.2-3.8-2.7-6.9-6.5-7-3.7-0.2-6.9 2.8-7 6.5-0.1 3.7 2.8 6.9 6.5 7z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "cb",
    d: "m237.1 227.7q-0.1 0-0.3 0c-1.8-0.1-3.5-0.9-4.8-2.2-1.3-1.4-1.9-3.2-1.9-5 0.2-3.9 3.4-6.9 7.2-6.7 1.9 0.1 3.6 0.8 4.9 2.2 1.2 1.4 1.9 3.1 1.8 5-0.1 3.7-3.2 6.7-6.9 6.7zm0-13.5c-3.6 0-6.5 2.7-6.6 6.3-0.1 1.8 0.6 3.4 1.8 4.7 1.2 1.3 2.8 2.1 4.5 2.1 3.7 0.1 6.7-2.7 6.9-6.3 0-1.8-0.6-3.5-1.8-4.7-1.2-1.3-2.8-2.1-4.6-2.1q-0.1 0-0.2 0z"
  })), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp172)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp173)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "cc",
    d: "m222.7 209.7l12.9-8.6 8.1 12.2-12.9 8.6z"
  })))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp174)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp175)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "cd",
    d: "m220.7 199.4l17.6-11.7 11.1 16.6-17.7 11.7z"
  })))), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m105.2 190.2c0 0-9.9-15-33.9-11.2 0 0-13.4 2.4-21.4 14 0 0-1.7 3.5 1.6 2.9 3.3-0.5 37.3-10 45.9 14 0 0 5.9 11.2 10.4 11.2z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "x",
    d: "m107.8 221.3c-4.5 0-10.3-10.8-10.5-11.3-3.9-10.8-13.2-16.2-27.8-16.2-7.4 0-13.9 1.5-16.8 2.1q-0.8 0.2-1.1 0.2-1.6 0.3-2.1-0.5c-0.6-0.9 0.2-2.6 0.3-2.6 7.9-11.6 21.3-14.1 21.4-14.2 2.6-0.4 5.2-0.6 7.7-0.6 9.6 0 16.3 3.2 20.2 6 4.3 2.9 6.2 5.9 6.3 5.9q0 0.1 0 0.1l2.5 30.9q0 0.1 0 0.2-0.1 0-0.1 0zm-38.3-27.9c6.4 0 11.9 1.1 16.3 3.3 5.7 2.7 9.6 7.1 11.8 13.1 0 0.1 5.7 10.8 10 11.1l-2.6-30.6c-0.5-0.8-8.4-11.7-26.1-11.7-2.5 0-5 0.2-7.6 0.6-0.1 0-13.3 2.5-21.2 13.9 0 0-0.7 1.5-0.3 2.3q0.4 0.6 1.7 0.4 0.3-0.1 1.2-0.3c2.8-0.6 9.4-2.1 16.8-2.1z"
  })), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp176)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m105.2 190.2c0 0-9.9-15-33.9-11.2 0 0-8.2 1.5-15.6 7.7 5.2-2.8 10.7-5.3 16.6-5 7.4 0.4 12.9 4.3 16.6 10.6 0.2 0.3-7.7-2.8-20.9-0.5-3.8 0.7-7.5 1.5-10.9 3 10.8-1.9 33.5-3.9 40.3 15.1 0 0 5.9 11.2 10.4 11.2z"
  }))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp177)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ce",
    d: "m105.2 190.2c0 0-9.9-15-33.9-11.2 0 0-0.6 0.1-1.5 0.4 0.8-0.1 1.5-0.1 2.2-0.1 2.6 0 6.2 0.5 8.6 1.7 4.6 2.2 8.4 4.3 10.6 8.9 2.6 5.3 3.8 12.2 5.4 18q0.4 0.9 0.8 2c0 0 5.9 11.2 10.4 11.2z"
  }))), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "m110.1 126.8l3.2-5.1 10.3 4.7c0 0-0.3 2.8-3.2 8.6-2.8 5.3-14.1 23.2-13.7 38.1 0.4 14.8 13.2 26.9 13.2 26.9 0 0 9.4 8.2 16.3 7.5 6.8-0.6 31.8-0.9 32.5-16.7 0.7-15.8-6.9-24.8-2.4-30.5 4.4-5.6 60.1-7.2 70.4-3.5 10.2 3.7 38.8 28.1 38.5 31.8-0.3 3.8-32.4 22.7-81.6 29.5 0 0-30.5 3.3-59.3 1.2-28.9-2-27.6-10.2-32.4-19.8-4.8-9.6-14.1-29.1-13.2-36.9 0.8-7.8 21.4-35.8 21.4-35.8z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "x",
    d: "m154.4 220.2c-7.2 0-14-0.2-20.2-0.7-24.8-1.7-27.4-8-30.7-15.8-0.5-1.3-1.1-2.7-1.8-4.1-5.3-10.5-14.1-29.4-13.2-37 0.9-7.8 20.6-34.8 21.5-35.9l3.2-5.1c0-0.1 0.1-0.1 0.2-0.1l10.3 4.7q0.1 0.1 0.1 0.2c0 0.1-0.3 3-3.3 8.7-0.3 0.7-0.9 1.7-1.5 2.8-4.1 7.3-12.5 22.4-12.1 35.2 0.3 14.5 13 26.6 13.1 26.8 0.1 0 8.8 7.5 15.4 7.5q0.4 0 0.7-0.1 1-0.1 2.4-0.2c8.8-0.6 29.4-2.1 30-16.3 0.4-7.5-1.2-13.4-2.4-18.2-1.4-5.4-2.4-9.4 0-12.4 3.1-3.9 28.7-5.6 45.9-5.6 12.2 0 21.2 0.7 24.7 2 5.5 2 15.7 9.5 23.3 15.9 7.8 6.6 15.5 14.1 15.4 16.2-0.2 2-8.9 7.8-22.6 13.7-12.2 5.2-32.4 12.2-59.1 15.8-0.2 0.1-18.2 2-39.3 2zm-41-98.3l-3.1 5c-0.3 0.3-20.6 28-21.5 35.7-0.8 7.6 7.9 26.3 13.2 36.8 0.7 1.4 1.3 2.8 1.9 4.1 3.2 7.8 5.8 13.9 30.4 15.7 6.2 0.4 12.9 0.6 20.1 0.6 21.1 0 39-1.9 39.2-1.9 49-6.8 81.1-25.6 81.4-29.3 0.3-3.6-28.2-28-38.4-31.7-3.4-1.2-12.6-2-24.6-2-20.3 0-42.9 2.1-45.6 5.5-2.3 2.9-1.3 6.8 0.1 12.1 1.2 4.8 2.7 10.8 2.4 18.3-0.7 14.5-21.5 16.1-30.4 16.7q-1.4 0.1-2.3 0.2-0.4 0-0.8 0c-6.8 0-15.3-7.2-15.6-7.6-0.1-0.1-12.9-12.3-13.3-27-0.3-12.9 8.1-28.1 12.2-35.4 0.6-1.1 1.1-2.1 1.5-2.8 2.6-5 3.1-7.8 3.2-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp178)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cf",
    d: "m236.7 156.8c-10.3-3.7-66-2.1-70.4 3.5-4.5 5.7 3.1 14.7 2.4 30.5-0.7 15.8-25.7 16.1-32.5 16.7-6.9 0.7-16.3-7.5-16.3-7.5 0 0-12.8-12.1-13.2-26.9q0-1.2 0-2.4c-1.5 1.1-3 2.4-3.9 4-1 3.7-0.1 7.8 1.2 11.6 0.8 2.6 1.8 5.3 3 7.7q0.3 0.7 0.6 1.3c1.7 2.7 3.6 5.4 5.3 8 0.2 0.2-0.1 0.5-0.3 0.4-4.6-3-6.6-8.5-8.7-13.3-1.9-4.3-3.9-8.7-5-13.3-0.8-3-1.3-6.1-0.9-9.3 0.6-6.1 4-11.6 7.6-16.5 3.3-4.7 7.1-9 10-14.1 2.2-3.9 3.9-8.3 3.6-12.8l-5.9-2.7-3.2 5.1c0 0-20.6 28-21.4 35.8-0.9 7.8 8.4 27.3 13.2 36.9 4.8 9.6 3.5 17.8 32.4 19.8 28.8 2.1 59.3-1.2 59.3-1.2 49.2-6.8 81.3-25.7 81.6-29.5 0.3-3.7-28.3-28.1-38.5-31.8z"
  })))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m103 178.1c0.2 4.5 2.4 9.2 4.1 13.4 1.5 3.3 3.2 7 6.1 9.3 2.9 2.4 6.2 2.4 9.5 1.3-1.7-1.2-2.8-2.1-2.8-2.1 0 0-12.8-12.1-13.2-26.9q0-0.8 0-1.6c-2.1 1.7-3.7 3.9-3.7 6.6z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "x",
    d: "m118.8 203q-3.2 0-5.8-2.1c-2.9-2.3-4.5-5.9-6-9.4q-0.3-0.6-0.5-1.2c-1.7-3.8-3.5-8.1-3.6-12.2-0.1-2.4 1.1-4.7 3.7-6.7q0.1-0.1 0.2-0.1 0.1 0.1 0.1 0.2-0.1 0.9 0 1.6c0.3 14.5 13 26.6 13.1 26.8 0 0 1.1 0.9 2.8 2.1q0.1 0.1 0.1 0.2-0.1 0.1-0.2 0.1-2 0.7-3.9 0.7zm-12.3-31.1q-3.4 2.9-3.3 6.2c0.1 4.1 2 8.3 3.6 12.1q0.3 0.6 0.5 1.2c1.5 3.4 3.1 7 6 9.2 2.5 2.1 5.5 2.5 9 1.5-1.5-1.1-2.5-2-2.5-2-0.1-0.1-12.9-12.3-13.3-27q0-0.6 0-1.2z"
  })), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp179)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m105.3 185.8q0 0 0 0c-0.6-2.3-1.6-6.8 1.1-7.9q-0.4-2-0.5-4c-3.4 2.4-2 7.8-0.6 11.9z"
  }))), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m106.6 182.6q0.8-0.4 1.7-0.9-0.2-0.3-0.3-0.7-0.8 0.4-1.6 0.9 0 0.3 0.2 0.7z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m107.3 184.8q0.8-0.5 1.7-1-0.1-0.3-0.2-0.5-0.9 0.4-1.7 0.9 0.1 0.3 0.2 0.6z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m107.8 186.2q0.9-0.6 1.8-1.1-0.2-0.4-0.4-0.9-0.9 0.5-1.8 1 0.2 0.5 0.4 1z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m107.9 186.6q0.2 0.4 0.3 0.7 1-0.5 1.9-1.1-0.2-0.3-0.3-0.6-0.9 0.5-1.9 1z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m108.6 188.4q1-0.6 2-1.2-0.2-0.3-0.3-0.6-1 0.6-1.9 1.2 0.1 0.3 0.2 0.6z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m109.7 190.8c0.7-0.5 1.4-0.9 2.1-1.4q-0.3-0.4-0.5-0.7-0.9 0.7-1.9 1.4 0.1 0.3 0.3 0.7z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m110.3 191.9q1.1-0.7 2-1.6-0.1-0.2-0.3-0.5c-0.7 0.5-1.4 0.9-2.1 1.4q0.2 0.4 0.4 0.7z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m111 193c0.6-0.5 1.3-1.1 2-1.7q-0.2-0.3-0.4-0.6-1 0.9-2 1.7 0.2 0.3 0.4 0.6z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m111.6 194q1-0.8 2-1.6-0.2-0.3-0.4-0.7-1 0.9-2 1.7 0.2 0.3 0.4 0.6z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m112.3 195q1-0.8 2-1.7-0.2-0.3-0.4-0.6-1 0.9-2.1 1.7 0.3 0.3 0.5 0.6z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m113.1 196q1-0.8 1.9-1.7-0.2-0.3-0.4-0.6-1 0.9-2 1.7 0.2 0.3 0.5 0.6z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m113.7 196.8c0.7-0.5 1.4-1.1 2-1.6q-0.2-0.3-0.4-0.5-0.9 0.9-1.9 1.7 0.1 0.2 0.3 0.4z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m114.6 197.7c0.6-0.5 1.2-1.1 1.8-1.6q-0.2-0.3-0.4-0.6c-0.6 0.6-1.3 1.1-1.9 1.7q0.2 0.2 0.5 0.5z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m115.4 198.3q0.8-0.8 1.6-1.5-0.2-0.2-0.3-0.4c-0.6 0.6-1.2 1.1-1.7 1.6q0.2 0.2 0.4 0.3z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m116.2 198.9q0.6-0.7 1.3-1.5-0.1-0.1-0.2-0.3-0.8 0.8-1.6 1.5 0.3 0.2 0.5 0.3z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m109.2 189.6q1-0.6 1.9-1.4-0.1-0.3-0.3-0.6-1 0.6-2 1.2 0.2 0.4 0.4 0.8z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m106.9 183.8q0.9-0.5 1.7-1-0.1-0.3-0.2-0.6-0.9 0.4-1.7 0.9 0.1 0.3 0.2 0.7z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m168.7 190.8c-0.5 10.4-11.6 14.1-21 15.6 2.1 0.1 4.2 0 6.1-0.1 5.9-0.4 12.3-2.1 15.8-7.3 4.3-6.4 4-15.6 3-22.9-0.8-5.9-2.2-11.6-3.7-17.3-1.3 0.5-2.2 1-2.6 1.5-4.5 5.7 3.1 14.7 2.4 30.5z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "x",
    d: "m150.2 206.6q-1.3 0-2.5-0.1c-0.1 0-0.2 0-0.2-0.1 0-0.1 0.1-0.2 0.2-0.2 13.4-2.1 20.5-7.3 20.8-15.4 0.4-7.5-1.2-13.4-2.4-18.2-1.4-5.4-2.4-9.4 0-12.4 0.5-0.6 1.3-1.1 2.7-1.6q0.1 0 0.2 0 0.1 0.1 0.1 0.1c1.4 5.6 2.9 11.4 3.7 17.4 0.9 6.6 1.5 16.3-3 23-3.1 4.4-8.3 6.9-16 7.4q-1.9 0.1-3.6 0.1zm-0.7-0.4q0.3 0 0.7 0 1.7 0 3.6-0.1c7.6-0.5 12.7-2.9 15.7-7.2 4.5-6.7 3.8-16.2 2.9-22.8-0.8-5.8-2.2-11.6-3.6-17.1q-1.8 0.7-2.4 1.4c-2.3 2.9-1.3 6.8 0.1 12.1 1.2 4.8 2.7 10.8 2.4 18.3-0.4 8-6.9 13.1-19.4 15.4z"
  })), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp180)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m171.8 171.6c-0.8-4.3-1.8-8.6-2.9-12.8-1.3 0.5-2.2 1-2.6 1.5-2.5 3.1-1.3 7.2 0.1 12.8 1.8-0.5 3.6-1.1 5.4-1.5z"
  }))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp181)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m162.9 201c-4.1 3-9.9 4.5-15.2 5.4 2.1 0.1 4.2 0 6.1-0.1 3.7-0.3 7.5-1 10.7-2.8q-0.8-1.2-1.6-2.5z"
  }))), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cg",
    d: "m165.7 170.3c0 0-6.6 1.3-8.6-4.1-1.9-5.3 1.7-17.6 6.1-19.2 6.9-2.4 70.6-3.1 78.1-1 7.5 2.1 4 11.7-1.4 12.3-5.4 0.6-55.1 2.9-74.2 12z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ch",
    d: "m164.1 170.6c-2.1 0-5.7-0.5-7.1-4.3-1.4-3.7-0.1-10.2 1.9-14.5 1.2-2.7 2.8-4.4 4.2-5 4.2-1.4 28-2.2 48.3-2.2 15.9 0 27.1 0.5 30 1.3 2.9 0.8 4.6 3 4.4 5.9-0.3 3.4-2.9 6.3-5.9 6.7-0.7 0-2.3 0.1-4.5 0.3-14.5 1.1-53.1 3.8-69.6 11.7q0 0 0 0c-0.1 0-0.7 0.1-1.7 0.1zm47.3-25.6c-20.5 0-44.1 0.8-48.1 2.2-1.4 0.5-2.9 2.2-4.1 4.7-2 4.2-3.2 10.7-1.9 14.3 1.3 3.5 4.8 4.1 6.8 4.1 0.8 0 1.4-0.1 1.6-0.1 16.5-7.9 55.1-10.7 69.7-11.8 2.2-0.1 3.8-0.2 4.5-0.3 2.8-0.3 5.2-3.1 5.5-6.3 0.2-2.8-1.3-4.8-4.1-5.6-2.8-0.8-14-1.2-29.9-1.2z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "ci",
    d: "m165.7 170.3c0 0-6.6 1.3-8.6-4.1-1.9-5.3 1.7-17.6 6.1-19.2 6.9-2.4 70.6-3.1 78.1-1 7.5 2.1 4 11.7-1.4 12.3-5.4 0.6-55.1 2.9-74.2 12z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ch",
    d: "m164.1 170.6c-2.1 0-5.7-0.5-7.1-4.3-1.4-3.7-0.1-10.2 1.9-14.5 1.2-2.7 2.8-4.4 4.2-5 4.2-1.4 28-2.2 48.3-2.2 15.9 0 27.1 0.5 30 1.3 2.9 0.8 4.6 3 4.4 5.9-0.3 3.4-2.9 6.3-5.9 6.7-0.7 0-2.3 0.1-4.5 0.3-14.5 1.1-53.1 3.8-69.6 11.7q0 0 0 0c-0.1 0-0.7 0.1-1.7 0.1zm47.3-25.6c-20.5 0-44.1 0.8-48.1 2.2-1.4 0.5-2.9 2.2-4.1 4.7-2 4.2-3.2 10.7-1.9 14.3 1.3 3.5 4.8 4.1 6.8 4.1 0.8 0 1.4-0.1 1.6-0.1 16.5-7.9 55.1-10.7 69.7-11.8 2.2-0.1 3.8-0.2 4.5-0.3 2.8-0.3 5.2-3.1 5.5-6.3 0.2-2.8-1.3-4.8-4.1-5.6-2.8-0.8-14-1.2-29.9-1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp182)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ci",
    d: "m241.3 146c-1.6-0.4-6.4-0.8-12.1-1-4.6 3.7-11.8 12.6-13.5 15.3 2.6-0.3 4.3-0.5 6.6-0.7 1.4-1.9 7.8-9.3 9.8-10.2 1.9-1 4.2-0.8 6.4-1 2.1-0.2 4.2 0.1 6.3 0.1-0.6-1.1-1.8-2-3.5-2.5z"
  })))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp183)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cg",
    d: "m166.4 166.8c0 0-5.1 1-6.6-3.1-1.5-4.2 1.3-13.7 4.7-14.9 5.3-1.9 54.6-2.4 60.4-0.8 5.7 1.7-43.7 11.8-58.5 18.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp184)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cg",
    d: "m161.6 162.9c0.7-7.1 1.8-12.4 4.3-16.4q-0.8 0.1-1.5 0.2c-2.2 4.1-3.2 9.3-4 16-0.4 3.7 0.3 6 1.2 7.5q0.9 0.2 1.7 0.2c-1.1-1.1-2.2-3.3-1.7-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cg",
    d: "m171.4 162.6q0.2-1.4 0.3-2.7c0.9-6.5 1.5-11 3.5-14.2q-0.7 0-1.3 0c-1.9 3.5-2.5 8.1-3.3 14q-0.1 1.3-0.3 2.7c-0.4 2.6-0.1 4.5 0.4 5.9q0.5-0.1 1-0.3c-0.4-1.3-0.6-3-0.3-5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cg",
    d: "m181.2 162.3c0.5-2.9 0.8-5.3 1-7.5 0.5-4.3 0.9-7.4 2.1-9.6q-0.6 0.1-1.3 0.1c-1.1 2.3-1.4 5.3-1.9 9.4-0.3 2.1-0.5 4.6-1 7.4-0.2 1.4-0.2 2.6-0.1 3.6q0.5-0.1 1.1-0.3c-0.1-0.9-0.1-1.9 0.1-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cg",
    d: "m192.3 151.3c0.2-2.9 0.3-4.9 1-6.3q-0.6 0-1.2 0c-0.6 1.6-0.8 3.6-0.9 6.2-0.2 2.8-0.5 6.1-1.2 10.6q-0.2 1-0.3 1.9 0.6-0.1 1.2-0.2 0-0.7 0.2-1.6c0.8-4.4 1-7.8 1.2-10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cg",
    d: "m202.1 148.7c-0.1-1.7-0.1-3 0.2-3.9q-0.6 0-1.2 0c-0.2 1-0.2 2.3-0.2 3.9 0 2.9 0.1 6.8-1.1 12.7q-0.1 0.4-0.1 0.8 0.6-0.1 1.1-0.2 0.1-0.2 0.1-0.4c1.2-6 1.2-10.2 1.2-12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cg",
    d: "m211.5 146.6q-0.1-1.2-0.1-1.8-0.6 0-1.1 0c0 0.5 0 1.2 0.1 1.9 0.3 2.6 0.9 6.9-0.7 14.2q0.6-0.1 1.2-0.1c1.5-7.3 1-11.6 0.6-14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cg",
    d: "m220.8 144.9q0 0-0.1-0.1-0.5 0-1.1 0 0 0.2 0.1 0.4c0.6 2.1 1.9 6.2 0 14.7q0.6-0.1 1.2-0.1c1.8-8.5 0.5-12.8-0.1-14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cg",
    d: "m230.5 145.1q-0.6 0-1.3-0.1c1.1 1.9 2.4 5.8 0.5 14q0.6 0 1.1 0c1.7-7.3 0.9-11.4-0.3-13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cg",
    d: "m241 146.1q0-0.1-0.1-0.2-0.5-0.1-1.4-0.2 0.3 0.4 0.5 0.9c0.8 2.1 1.2 5.8-0.3 11.7q0.1 0 0.2 0 0.5-0.1 1-0.2c1.1-4.4 1.4-8.7 0.1-12z"
  })))), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cj",
    d: "m267.8 187.5c0 0-25.8-21.3-60.9-15.9-35 5.3-36.5 34.8-33.5 37.4 3 2.6 23.3 0.7 38.6-0.8 15.4-1.5 55.8-20.7 55.8-20.7z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp185)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cf",
    d: "m261.7 187.4c0 0-18.7-15.1-44.2-11.3-25.5 3.8-26.8 21.8-26.1 24.5 3.8 14.9 70.3-13.2 70.3-13.2z"
  })))), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m192.7 201.6c-0.7-2.7 0.5-20.8 26-24.6 21.6-3.2 38.3 7.2 42.9 10.4q0.1 0 0.1 0c0 0-18.7-15.1-44.2-11.3-25.5 3.8-26.8 21.8-26.1 24.5 0.4 1.3 1.2 2.3 2.3 3q-0.7-0.8-1-2z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "ck",
    d: "m96.3 99.6l-1-1.1c0 0-3.3 12.6 0.2 24.6z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m95.3 98.5c0 0 15.7-2.1 19.6 7.8 3.9 10-3.2 17.9-19.4 16.8z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "x",
    d: "m98.4 123.4q-1.4 0-2.9-0.1c-0.1 0-0.2-0.1-0.2-0.2l-0.1-24.6c0 0 0-0.1 0.1-0.1 0 0 1.5-0.2 3.6-0.2 4.8 0 13.4 1 16.2 8.1 1.6 4.1 1.4 7.9-0.7 10.9-2.7 4-8.4 6.2-16 6.2zm-2.7-0.4q1.4 0.1 2.7 0.1c7.5 0 13.1-2.2 15.7-6.1 2-2.9 2.2-6.6 0.6-10.6-2.7-6.8-11.1-7.9-15.8-7.9-1.7 0-2.9 0.2-3.4 0.2z"
  })), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp186)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cl",
    d: "m113.5 118c2.7-3 3.2-7.1 1.4-11.7-1.6-4-5.1-6.1-8.8-7.1 2.7 6.3 5.4 12.4 7.4 18.8z"
  }))), _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp187)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cl",
    d: "m106.8 114.1q-0.3 2.2-0.4 4.3-0.1 1.9-0.1 3.9c2.6-0.8 4.8-1.9 6.3-3.3q-0.9-2.9-1.9-5.7-0.2 0.1-0.3 0c-1.8-1-3.3-1.5-3.6 0.8z"
  }))), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cm",
    d: "m101.9 98.5c-3.7-0.4-6.6 0-6.6 0l0.2 24.6c2.4 0.2 4.5 0.2 6.5 0 0-8.2 0.1-16.4-0.1-24.6z"
  })), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp188)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cl",
    d: "m105.9 117.3c-3.5 0.5-7 0.8-10.4 0.7v5.1c11.4 0.8 18.3-2.9 20-8.6-3.2 1.5-6.9 2.4-9.6 2.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp189)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m97.5 104.5c2.4 0 4.8-0.1 7.1 0.3q2 0.3 3.9 0.9c1.9 0.7 3.8 1.5 5.3 2.8 0.8 0.6 1.5 1.4 2.1 2.2-3.6-6.9-12.7-9.3-20.5-9.1v2.9q1 0 2.1 0z"
  })))), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cn",
    d: "m129.9 114.7l-14 5.2-9-24.3 10.2-3.8z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "co",
    d: "m115.9 120.1q-0.1 0-0.1 0-0.1 0-0.1-0.1l-9-24.4q0 0 0-0.1 0-0.1 0.1-0.1l10.3-3.8q0.1 0 0.2 0.1l12.7 22.9q0.1 0.1 0.1 0.2-0.1 0.1-0.1 0.1l-14.1 5.2q0 0 0 0zm-8.8-24.4l8.9 24 13.6-5.1-12.6-22.6z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _g185 || (_g185 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp190)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cp",
    d: "m121.7 104.5c-3.3 1.4-6.6 3-10 4.3l4.2 11.1 14-5.2-6.2-11q-1 0.4-2 0.8z"
  })))), _g186 || (_g186 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp191)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cn",
    d: "m123.2 102.7q-0.4 1.6-0.8 3.2c-0.6 2.2-0.9 5.1-2.2 7-1.3 1.8-4.4 0.8-7.1-0.4l2.8 7.4 11.4-4.2c0.2-1.5 0.4-3 0.6-4.5z"
  }))), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cq",
    d: "m126.6 112.4c-2.5 0.5-4.4 4.8-5.9 9.6q0 0.5 0.2 1c0.5 1.3 2.2 1.1 3.1 0.5 0.7-2.2 1.3-4 1.8-4.9 1.5-2.9 5.1-2.3 5.1-2.3l13.6 0.9 0.6-4.4c0 0-13.2-1.6-18.5-0.4z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "cr",
    d: "m122.4 124.1c-0.8 0-1.4-0.4-1.7-1q-0.1-0.5-0.2-1.1 0-0.1 0-0.1c1.9-6 3.9-9.2 6-9.7q2.1-0.4 5.8-0.4c5.8 0 12.7 0.8 12.8 0.8q0.1 0 0.1 0.1 0.1 0 0.1 0.1l-0.6 4.4c0 0.1-0.1 0.2-0.2 0.2l-13.6-0.9c0 0-0.4-0.1-0.9-0.1-1.1 0-3 0.3-4.1 2.3q-0.6 1.1-1.7 4.8 0 0.1-0.1 0.1c-0.4 0.3-1.1 0.5-1.7 0.5zm-1.5-2.1q0 0.5 0.2 0.9c0.3 0.8 1 0.9 1.3 0.9 0.5 0 1.1-0.2 1.5-0.5q1-3.6 1.7-4.8c1.1-2.1 3.3-2.4 4.4-2.4 0.6 0 0.9 0 0.9 0l13.4 0.9 0.6-4.1c-1.2-0.1-7.4-0.8-12.6-0.8q-3.7 0-5.7 0.5c-2 0.4-3.9 3.6-5.7 9.4z"
  })), _g187 || (_g187 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp192)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cs",
    d: "m129.2 114.8c-5.1 0.6-5.6 4.3-6.6 9.1 0.5 0 1-0.2 1.4-0.4 0.7-2.2 1.3-4 1.8-4.9 1.5-2.9 5.1-2.3 5.1-2.3l13.6 0.9 0.3-2.2c-5.2-0.2-10.5-0.9-15.6-0.2z"
  }))), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "m138.2 114.3c-0.1 2.5-1.7 4.5-3.6 4.5-2-0.1-3.6-2.1-3.6-4.6 0-2.4 1.7-4.4 3.6-4.4 2 0 3.6 2 3.6 4.5z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cu",
    d: "m138.2 114.3c-0.1 2.3-1.6 4.2-3.4 4.2-1.9-0.1-3.3-1.9-3.3-4.3 0-2.3 1.5-4.1 3.4-4.1 1.8 0 3.3 1.9 3.3 4.2z"
  })), _g188 || (_g188 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp193)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cv",
    d: "m138.2 114.6c-0.1 1.7-1.3 3.1-2.8 3.1-1.5 0-2.7-1.4-2.7-3.2 0-1.7 1.3-3.1 2.8-3.1 1.5 0 2.7 1.4 2.7 3.2z"
  }))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cw",
    d: "m144.7 112.2l-9.1-0.4c-1.3 0-2.5 1.2-2.5 2.7 0 1.5 1.1 2.7 2.5 2.8l9.3 0.3z"
  })), _g189 || (_g189 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp194)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cw",
    d: "m141.1 113c-2.5-0.1-5 0-7.5 0q-0.2 0.2-0.3 0.6c3.8 0 7.6 0.3 11.5 0.4l-0.1-0.9q-1.8-0.1-3.6-0.1z"
  }))), _g190 || (_g190 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp195)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cw",
    d: "m133.4 115.8c0.4 0.9 1.3 1.5 2.2 1.5l9.3 0.3-0.1-1.3c-1.6-0.1-9.1-0.4-11.4-0.5z"
  }))), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "m146.9 114.9c0 1.5-1.1 2.7-2.5 2.7-1.4 0-2.5-1.2-2.5-2.7 0-1.5 1.1-2.7 2.5-2.7 1.4 0 2.5 1.2 2.5 2.7z"
  })), _g191 || (_g191 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp196)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cs",
    d: "m127.6 112.7c0 0-2.6 0.3-4.3 3.9-0.9 1.8-1.7 4-2.4 6.4q0 0 0 0 0.1 0.3 0.3 0.4c1.3-3.9 3.1-8.4 4.4-9.3 1.4-1 2.9-1.4 3.9-1.6z"
  }))), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m131.5 213.4c0 0-18.9 2.1-24-9.9-5.2-12.1-14.9-28-11-40.1 3.8-12.1 29-40.1 16.8-41.7 0 0-7.3-2.2-10.9 3.1-3.6 5.3-29 33.5-34.3 53.5 0 0 20.1-0.7 25.1 10.1 5 10.9 4 31.6 19.1 35.4 0 0 5.1 1.7 12.3 1.1 2.6-0.2 11.3-0.2 21.2-0.1 5.2 0.5 17.3 2.1 23.1 6.2 7.6 5.4 36.2-4.9 39.4-16.9z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "x",
    d: "m175.1 232.7q-4.2 0-6.3-1.5c-5.8-4.2-18-5.7-23-6.2-4.6 0-8.6 0-11.8 0-4.9 0-8.1 0-9.4 0.1q-1.6 0.2-3.1 0.2c-5.5 0-9.2-1.3-9.3-1.3-10.7-2.7-13.4-14-15.7-24-1-4.3-2-8.3-3.5-11.5-4.4-9.5-21-10-24.3-10q-0.6 0-0.6 0-0.1 0-0.2-0.1 0-0.1 0-0.2c4.3-16 21.6-37.6 29.9-47.9 2.2-2.7 3.7-4.6 4.4-5.6 2-3 5.2-3.7 7.6-3.7 2 0 3.5 0.5 3.6 0.5 1.5 0.2 2.5 0.9 3 2 1.9 4-4.3 13.8-10.3 23.2-4.2 6.4-8.1 12.5-9.4 16.8-3.2 9.7 2.6 21.9 7.7 32.7 1.2 2.5 2.3 4.9 3.3 7.2 1.5 3.7 6.4 10 20.7 10 1.9 0 3.1-0.2 3.1-0.2l76.8 0.7q0.1 0 0.1 0.1 0.1 0.1 0 0.2c-2.6 10-22.3 18.5-33.3 18.5zm-41.1-8.1c3.2 0 7.2 0 11.8 0.1 5.1 0.4 17.3 2 23.2 6.2q2 1.4 6.1 1.4c10.8 0 30.1-8.2 32.9-18l-76.5-0.7c0 0-1.2 0.1-3.1 0.1-2.9 0-7.2-0.3-11.2-1.7-4.9-1.7-8.2-4.5-9.9-8.5-1-2.2-2.1-4.6-3.3-7.2-5.1-10.8-10.9-23.1-7.7-32.9 1.4-4.3 5.3-10.4 9.5-16.9 5.9-9.3 12.1-19 10.3-22.9q-0.6-1.4-2.8-1.7c0 0-1.6-0.5-3.5-0.5-2.3 0-5.4 0.6-7.3 3.5-0.7 1-2.3 2.9-4.4 5.6-8.3 10.3-25.4 31.7-29.8 47.6q0.2 0 0.4 0c3.4 0 20.1 0.5 24.7 10.3 1.5 3.2 2.4 7.2 3.4 11.5 2.4 9.9 5 21.1 15.5 23.8 0.1 0 3.8 1.2 9.2 1.2q1.5 0 3-0.1c1.4-0.2 4.6-0.2 9.5-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _g192 || (_g192 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp197)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cf",
    d: "m131.5 213.4c0 0-18.9 2.1-24-9.9-5.2-12.1-14.9-28-11-40.1 3.8-12.1 28.9-40.1 16.8-41.7 0 0-7.3-2.2-10.9 3.1q-0.1 0.1-0.2 0.2c1-0.4 2-0.8 3.1-0.7 9.1 0.6 7.4 7.2 6 9.6-1.7 3.1-4.5 7.5-6.6 10.4-2.6 3.6-5.1 7-7.2 11-2.2 4.3-4.4 9.5-4.7 14.5-0.2 4.8 3.7 13.7 4.3 18.4 0 0.3-17.5-16.9-27.7-9.9 4.5 0.1 19.5 1 23.8 10.1 5 10.9 4 31.6 19.1 35.4 0 0 5.1 1.7 12.3 1.1 2.6-0.2 11.3-0.2 21.2-0.1 5.2 0.5 17.3 2.1 23.1 6.2 7.6 5.4 36.2-4.9 39.4-16.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _g193 || (_g193 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp198)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cf",
    d: "m131.5 213.4c0 0-18.9 2.1-24-9.9-2.2-5.1-5.1-10.8-7.6-16.7q0.4 2.5 0.9 5c0.7 3.5 1.3 7.1 2.4 10.5 1 3.2 2.5 6.2 4.9 8.6 2.1 1.9 4.7 3.1 7.4 3.9 5.7 1.5 12 1.7 17.9 2.1 7.5 0.4 15.1 0.5 22.6 0.9 7.8 0.5 15.5 1 23.3 0.8 2.3 0 9.4-1.1 9.3 3-0.1 1.6-1.6 2.9-2.8 3.8-1.6 1.1-3.4 2.1-5.2 2.6-6.5 2.1-13-0.8-19-3-3.3-1.2-6.7-2.2-10.2-2.7-3.5-0.6-6.9-0.5-10.4-0.3-6.6 0.4-13.3 1.5-19.9 0.7-6-0.8-11.6-3.2-15.9-7.4-4-4-6.5-8.9-8.1-14.2-0.4-1.5-0.8-3-1.3-4.5 2.8 10.9 4.7 24.3 16.5 27.2 0 0 5.1 1.7 12.3 1.1 2.6-0.2 11.3-0.2 21.2-0.1 5.2 0.5 17.3 2.1 23.1 6.2 7.6 5.4 36.2-4.9 39.4-16.9z"
  })))), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m127.8 214.6c-5.9-0.1-17.3-1.5-21.2-10.7-1-2.3-2.1-4.7-3.3-7.2-5.2-11-11-23.4-7.8-33.6 1.4-4.4 5.4-10.5 9.6-17.1 5.5-8.7 11.9-18.6 10.3-22-0.2-0.3-0.5-1.1-2.2-1.3-0.6-0.1-0.9-0.6-0.9-1.1 0.1-0.6 0.6-1 1.2-0.9q2.8 0.4 3.7 2.4c2.1 4.5-4 14-10.4 24-4 6.2-8 12.5-9.4 16.6-3 9.4 2.7 21.5 7.7 32.1 1.2 2.6 2.3 5 3.3 7.3 4.8 11.2 22.8 9.3 23 9.3q0.1 0 0.1 0l55.5 0.5c0.6 0 1 0.5 1 1 0 0.6-0.4 1-1 1l-55.4-0.5c-0.4 0.1-1.8 0.2-3.8 0.2z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "cr",
    d: "m187 215.1l-55.4-0.5c-0.3 0-1.6 0.2-3.4 0.2h-0.4c-14.7-0.2-19.7-6.9-21.4-10.9-1-2.2-2.1-4.6-3.3-7.1-5.2-11-11-23.5-7.8-33.7 1.5-4.5 5.4-10.6 9.6-17.2 5.6-8.6 11.9-18.5 10.3-21.9-0.1-0.2-0.4-0.9-2-1.1-0.3-0.1-0.6-0.2-0.8-0.5q-0.3-0.4-0.2-0.9c0-0.6 0.6-1.1 1.3-1q2.9 0.4 3.9 2.5c2.1 4.6-4 14.1-10.5 24.2-3.9 6.1-8 12.5-9.3 16.6-3 9.3 2.7 21.3 7.7 31.9 1.2 2.6 2.3 5 3.3 7.3 3.6 8.4 15.1 9.3 19.8 9.3 1.9 0 3-0.1 3-0.1q0.1 0 0.1 0l55.5 0.5c0.7 0 1.2 0.6 1.2 1.2 0 0.7-0.5 1.2-1.2 1.2zm-55.4-0.9l55.4 0.5v0.2-0.2c0.5 0 0.8-0.3 0.9-0.8 0-0.4-0.4-0.8-0.9-0.8l-55.5-0.5q0 0-0.1 0c0 0-1.1 0.1-3 0.1-2.7 0-6.8-0.3-10.7-1.6-4.7-1.6-7.9-4.3-9.5-8-0.9-2.3-2.1-4.7-3.3-7.2-5-10.7-10.7-22.7-7.6-32.2 1.3-4.2 5.4-10.5 9.3-16.7 6.4-10 12.5-19.4 10.4-23.8q-0.9-2-3.6-2.3c-0.4-0.1-0.8 0.2-0.9 0.7q0 0.3 0.2 0.6 0.2 0.3 0.5 0.3c1.8 0.3 2.2 1.1 2.3 1.4 1.7 3.6-4.7 13.5-10.3 22.2-4.2 6.6-8.1 12.7-9.5 17.1-3.2 10.1 2.6 22.5 7.7 33.4 1.2 2.5 2.4 4.9 3.3 7.2 1.7 3.9 6.7 10.5 21.1 10.6h0.4c1.8 0 3-0.1 3.4-0.2z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "ck",
    d: "m108.9 113.8l-0.4-0.4c0 0-1.5 5.5 0.1 10.8z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m108.5 113.4c0 0 6.9-1 8.6 3.4 1.7 4.4-1.4 7.9-8.5 7.4z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "x",
    d: "m109.8 124.5q-0.6 0-1.3-0.1c-0.1 0-0.1-0.1-0.1-0.2l-0.1-10.8c0-0.1 0.1-0.2 0.2-0.2 0 0 0.6-0.1 1.5-0.1 2.2 0 6 0.5 7.3 3.6 0.7 1.9 0.6 3.6-0.3 5-1.2 1.8-3.8 2.8-7.2 2.8zm-1.1-0.4c3.8 0.2 6.7-0.8 8-2.6 0.8-1.3 0.9-2.9 0.2-4.6-1.1-3-4.8-3.4-6.9-3.4-0.6 0-1.1 0-1.3 0z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cx",
    d: "m111.4 113.3c-1.6-0.1-2.9 0.1-2.9 0.1l0.1 10.8q1.5 0.1 2.8 0c0-3.6 0.1-7.2 0-10.9z"
  })), _g194 || (_g194 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp199)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cl",
    d: "m113.1 121.6c-1.5 0.3-3 0.4-4.6 0.4l0.1 2.2c5 0.4 8-1.3 8.8-3.8-1.4 0.7-3.1 1.1-4.3 1.2z"
  }))), _g195 || (_g195 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp200)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cy",
    d: "m109.4 116c1.1 0 2.1 0 3.2 0.1q0.9 0.1 1.7 0.4c0.8 0.3 1.7 0.7 2.3 1.2 0.4 0.3 0.7 0.7 1 1-1.7-3-5.6-4.1-9.1-4v1.3q0.5 0 0.9 0z"
  }))), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cq",
    d: "m254.2 165.1c0 0-8.6-1-7.5 1.8 1.1 2.8 21.1 15.1 21.1 15.1 0 0 3.5 2.6 3.3 0-0.3-2.5-10.4-15.8-16.9-16.9z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "cr",
    d: "m270.3 183.3c-1 0-2.5-1.1-2.6-1.1-0.8-0.5-20.1-12.4-21.2-15.2q-0.2-0.7 0.1-1.1 0.8-1.2 4.6-1.2c1.6 0 3.1 0.2 3.1 0.2 6.6 1.1 16.7 14.7 16.9 17.1q0.1 0.8-0.2 1.1-0.2 0.2-0.7 0.2zm-19.1-18.2c-2.3 0-3.9 0.3-4.3 1q-0.2 0.3 0 0.8c1 2.7 20.8 14.8 21 15 0 0 1.5 1.1 2.4 1.1q0.3 0 0.4-0.2 0.2-0.2 0.2-0.7c-0.2-2.4-10.2-15.7-16.7-16.8 0 0-1.4-0.2-3-0.2z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cz",
    d: "m256.2 165.9c0 0-6-1.8-5.1 0.8 0.8 2.6 16 14 16 14 0 0 2.6 2.4 2.4 0.1-0.1-2.4-8.4-13.9-13.3-14.9z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "aS",
    d: "m208.2 214.4c0 0 0.7-2.2-2.3-2.1-3.1 0.1-21.6-0.2-21.6-0.2l-0.1 3.2z"
  })), _g196 || (_g196 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp201)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cs",
    d: "m120.8 98.4l-0.9-1.6c-3.8 1.1-7.6 2.2-11.3 3.4l0.7 1.9q5.7-1.9 11.5-3.7z"
  }))), _g197 || (_g197 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp202)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cn",
    d: "m112.4 108.4l-4.8-12.7 9.2-3.4-8.4 3.6z"
  }))), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m109.6 133.9c0 2.1-1.7 3.8-3.8 3.8-2.1-0.1-3.8-1.8-3.8-3.9 0-2.1 1.8-3.8 3.9-3.7 2.1 0 3.7 1.7 3.7 3.8z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "x",
    d: "m105.8 137.8c-1.1 0-2.1-0.4-2.8-1.1-0.8-0.8-1.2-1.8-1.2-2.9 0.1-2.2 1.9-3.9 4-3.9 2.3 0 4 1.8 4 4 0 2.2-1.8 3.9-4 3.9zm0.1-7.6c-2 0-3.7 1.7-3.7 3.6 0 1 0.4 1.9 1.1 2.6 0.6 0.7 1.5 1.1 2.5 1.1v0.2-0.2c2 0 3.6-1.6 3.6-3.6 0.1-2-1.5-3.6-3.5-3.7z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "ck",
    d: "m108.9 133.9c0 1.8-1.4 3.2-3.1 3.2-1.8-0.1-3.2-1.5-3.2-3.2 0-1.8 1.5-3.2 3.2-3.2 1.8 0.1 3.2 1.5 3.1 3.2z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cq",
    d: "m122 82.5c0 4.8-1.2 8.7-2.6 8.6-1.5 0-2.6-3.9-2.5-8.6 0-4.8 1.2-8.7 2.6-8.7 1.4 0.1 2.5 3.9 2.5 8.7z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "cr",
    d: "m119.4 91.3c-1.8 0-2.8-4.5-2.7-8.8 0-4.4 1.1-8.8 2.8-8.8 1.7 0 2.7 4.5 2.7 8.8-0.1 4.3-1.1 8.8-2.8 8.8zm0.1-17.3c-1.1 0-2.4 3.4-2.4 8.5-0.1 5 1.1 8.5 2.3 8.5v0.1-0.1c1.1 0 2.4-3.4 2.4-8.5 0.1-5.1-1.1-8.5-2.3-8.5z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cq",
    d: "m119.1 123.2c-0.3 0-0.5-0.2-0.5-0.4 0-0.3-2.5-29.5-3.2-34.6-0.7-5.5 3.2-6.2 3.2-6.2 0.2 0 0.5 0.2 0.5 0.4 0.1 0.3-0.1 0.5-0.4 0.6-0.1 0-2.9 0.5-2.3 5.1 0.6 5.1 3.1 34.3 3.1 34.6 0.1 0.3-0.1 0.5-0.4 0.5q0 0 0 0z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "cr",
    d: "m119.1 123.4c-0.4 0-0.7-0.3-0.7-0.6 0-0.3-2.5-29.5-3.2-34.5-0.7-5.8 3.3-6.5 3.4-6.5 0.3 0 0.7 0.2 0.7 0.6 0.1 0.3-0.2 0.7-0.5 0.7-0.1 0.1-2.8 0.5-2.3 5 0.6 4.7 2.8 29.5 3.2 34.4v0.2q0 0.3-0.1 0.5-0.2 0.2-0.5 0.2 0 0 0 0zm-0.4-41.2q-0.1 0-0.1 0c-0.1 0-3.7 0.7-3 6 0.7 5.1 3.2 34.3 3.2 34.6 0 0.1 0.1 0.2 0.3 0.2v0.2-0.2q0.1 0 0.2-0.1 0.1-0.1 0.1-0.2l-0.1-0.1c-0.4-5-2.5-29.8-3.1-34.5-0.7-4.8 2.4-5.3 2.5-5.3 0.2-0.1 0.3-0.2 0.2-0.4 0-0.1-0.1-0.2-0.2-0.2z"
  })), _g198 || (_g198 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp203)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cA",
    d: "m235.5 183.3c-0.1 0.2-1.1 1.3 0 4.6 1.2 3.2 2.5 5.9 2.5 5.9 0 0 0.3 0.6 1.8 0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cA",
    d: "m238.7 183.2c0 0.2-0.9 1.2 0.1 4.2 1 2.9 2.2 5.3 2.2 5.3 0 0 0.3 0.6 1.7 0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cA",
    d: "m241.9 183.3c-0.1 0.2-0.9 1.1 0 3.8 1 2.8 2.1 5 2.1 5 0 0 0.3 0.5 1.5 0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cA",
    d: "m244.9 184.1c0 0.1-0.7 0.9 0.1 3.2 0.7 2.2 1.7 4 1.7 4 0 0 0.2 0.5 1.2 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cA",
    d: "m247.8 184.6c0 0.2-0.5 0.8 0.1 2.6 0.6 1.8 1.3 3.3 1.3 3.3 0 0 0.2 0.4 1.1 0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cA",
    d: "m250.5 184.9c0 0.1-0.4 0.6 0.1 2.1 0.5 1.5 1.1 2.7 1.1 2.7 0 0 0.1 0.3 0.8 0.3z"
  }))), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cj",
    d: "m102 127.5c0 0-26 29.8-31.7 48.7 0 0 4.1-2.6 12.7 1.4 0 0-8.6-8 19-50.1z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _g199 || (_g199 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp204)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m76.1 168.9c1.2-3.4 2.6-6.7 4.2-9.9 1.6-3.4 3.5-6.7 5.4-10-6 8.7-11.9 18.3-14.2 26.2 0 0 1-0.7 3.1-0.9 0.5-1.8 0.9-3.6 1.5-5.4z"
  })))), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cj",
    d: "m50.1 194.2c0 0 5.2-10.6 20.1-12 0 0-11.1 1-20.1 12z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _g200 || (_g200 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp205)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cg",
    d: "m241.3 146c-7.5-2.1-71.2-1.4-78.1 1-1.5 0.5-3 2.4-4.1 4.8 3.7-4.4 17.1-5 17.1-5 0 0 43-1.1 53-0.7 10 0.4 10.3 5.6 9.4 8.3-0.8 2.7-4.7 3-4.7 3l-20.2 1.8c-8.5 0.9-34.3 4.7-38.6 5.8-4.4 1-7.5 3.7-13 3.7-3.1-0.1-4.7-3.7-5.5-6.8-0.1 1.7 0.1 3.2 0.5 4.3 2 5.4 8.6 4.1 8.6 4.1 19.1-9.1 68.8-11.4 74.2-12 5.4-0.6 8.9-10.2 1.4-12.3z"
  })))), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cB",
    d: "m241.9 165q-0.3 0-0.5-0.1c-0.3-0.3-0.4-0.7-0.1-1.1l13.1-17.7c0.2-0.4 0.7-0.4 1-0.2 0.4 0.3 0.5 0.7 0.2 1.1l-13.1 17.7c-0.2 0.2-0.4 0.3-0.6 0.3z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "cC",
    d: "m241.9 165.2q-0.3 0-0.6-0.2c-0.4-0.3-0.5-0.9-0.2-1.3l13.1-17.7c0.3-0.4 0.9-0.5 1.4-0.2q0.3 0.2 0.3 0.6 0.1 0.4-0.1 0.7l-13.2 17.7c-0.1 0.3-0.4 0.4-0.7 0.4zm13.1-19.2q-0.3 0-0.5 0.2l-13.1 17.7c-0.2 0.3-0.1 0.6 0.1 0.8q0.2 0.1 0.4 0.1v0.2-0.2c0.2 0 0.3 0 0.4-0.2l13.2-17.7q0.1-0.2 0.1-0.5-0.1-0.2-0.3-0.3-0.1-0.1-0.3-0.1z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cB",
    d: "m217.7 164q-0.4 0-0.7-0.2c-0.6-0.3-0.8-1.1-0.4-1.7 0 0 2.5-4 5.5-7.9 5.5-7.5 7.7-8.8 8.9-9 3.8-0.8 28.8-0.4 31.7-0.4 0.7 0 1.2 0.6 1.2 1.3 0 0.7-0.6 1.3-1.3 1.3-7.6-0.2-28.1-0.4-31 0.3-1.6 0.3-6.8 6.3-12.9 15.8-0.2 0.3-0.6 0.6-1 0.5z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "cC",
    d: "m217.7 164.2q-0.5 0-0.8-0.2c-0.7-0.4-0.9-1.3-0.5-2 0.3-0.4 2.7-4.1 5.5-8 5.6-7.5 7.9-8.7 9.1-9 1.5-0.3 6.7-0.5 15.5-0.5 7.3 0 14.8 0.1 16.2 0.1 0.8 0.1 1.4 0.7 1.4 1.5 0 0.8-0.7 1.4-1.4 1.4-4 0-10.3-0.1-16.2-0.1-8.5 0-13.6 0.1-14.9 0.4-1.5 0.4-6.8 6.5-12.7 15.8-0.3 0.4-0.7 0.6-1.2 0.6zm28.8-19.3c-8.6 0-13.9 0.1-15.4 0.5-1.2 0.2-3.4 1.4-8.9 8.9-2.8 3.8-5.2 7.5-5.4 7.9-0.4 0.5-0.2 1.2 0.3 1.5q0.2 0.2 0.6 0.2v0.1-0.1c0.3 0 0.7-0.2 0.9-0.5 6.2-9.9 11.3-15.6 12.9-15.9 1.4-0.3 6.4-0.5 15-0.5 5.9 0 12.2 0.1 16.1 0.2 0.6 0 1.1-0.5 1.1-1.1 0-0.6-0.4-1.1-1-1.1-1.4 0-8.9-0.1-16.2-0.1z"
  })), _g201 || (_g201 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp206)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cg",
    d: "m160 159.1c0 0 1.9-9.2 6.3-10.2 4.4-1 55.5-0.8 55.5-0.8 0 0-31.7 2.1-40.2 2.3-8.5 0.2-17.2 0.2-21.6 8.7z"
  }))), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cj",
    d: "m214.9 161.9c0 0-22.6 1.8-41.5 7.9 0 0 2.7 13.9 1.4 18.1 0 0-0.8 3.6 0 2.5 0.8-1.1 4.8-12.2 19.6-17.4 14.9-5.3 35.8-3.7 44.5-1.2 8.7 2.5 22.3 9.8 19.9 7.2-2.4-2.7-13.9-11.3-13.9-11.3 0 0-6 0.9-5.5-3.5 0.4-4.4-8.5-3.6-8.5-3.6l-9.8 0.9c0 0-1.6 3.8-3.8 4.1-4.1 0.6-2.4-3.7-2.4-3.7z"
  })), _g202 || (_g202 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp207)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cB",
    d: "m258.8 146.3c0 0-23.3-0.1-25.9 0-2.7 0.2-4.3 2.2-4.3 2.2 0 0-7.3 9.3-8.2 10.8-0.9 1.5-2.5 3.8-3.4 3.5-0.3-0.1-0.4-0.3-0.5-0.5-0.2 0.6 0 1.2 0.5 1.5q0.3 0.2 0.7 0.2c0.4 0.1 0.8-0.2 1-0.5 6.1-9.5 11.3-15.5 12.9-15.8 2.9-0.7 23.4-0.5 31-0.3 0.7 0 1.3-0.6 1.3-1.3q0-0.4-0.2-0.8c0 1.1-4.9 1-4.9 1z"
  }))), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cj",
    d: "m112.3 222.8q1 0.3 2 0.5 1.1 0.1 2.1 0.3 1.1 0.1 2.1 0.2h1l1.1 0.1q1 0 2.1-0.1c0.7 0 1.4-0.1 2.1-0.1l1-0.1h1.1q1-0.1 2.1-0.1 2.1 0 4.2-0.1h4.2q2.1 0 4.2 0h4.2 0.1q4.1 0.4 8.3 1.1c2.7 0.5 5.5 1.1 8.2 1.9q2 0.6 3.9 1.4 1 0.5 1.9 1 1 0.5 1.8 1.1c0.2 0.1 0.3 0.2 0.5 0.2q0.1 0.1 0.4 0.2 0.4 0.2 0.9 0.3 1 0.2 2 0.3c1.4 0 2.7-0.1 4.1-0.2q2.1-0.3 4.1-0.7 2-0.5 4-1 4-1.2 7.8-2.9 1.9-0.8 3.7-1.8 1.8-1 3.5-2.2c1.2-0.8 2.2-1.7 3.2-2.7 0.9-1 1.8-2.2 2.3-3.5-0.5 1.4-1.3 2.5-2.2 3.6-0.9 1-2 1.9-3.1 2.8-2.2 1.7-4.7 3.1-7.2 4.3q-3.8 1.8-7.8 3-2 0.6-4.1 1.1-2 0.4-4.1 0.7c-1.4 0.2-2.8 0.3-4.2 0.2q-1.1 0-2.2-0.2-0.5-0.1-1-0.3-0.3-0.1-0.5-0.3c-0.2-0.1-0.3-0.2-0.5-0.3q-0.8-0.6-1.8-1-0.9-0.5-1.8-0.9-1.9-0.8-3.9-1.4c-2.6-0.8-5.3-1.4-8.1-1.9q-4.1-0.7-8.2-1.1l-8.4-0.2h-4.2q-2.1 0-4.2 0-1 0-2.1 0h-1l-1.1 0.1c-0.7 0-1.4 0.1-2.1 0.1q-1.1 0-2.1-0.1h-1.1l-1-0.1q-1.1-0.1-2.1-0.3-1.1-0.1-2.1-0.4-1-0.2-2-0.5z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m217.7 161.3c0 0 8.6-13.8 13.5-15.7 0 0 1.2-0.3 3-0.4 1.8-0.1 16.2-0.1 16.2-0.1l-17.9 0.5c0 0-1.4 0.3-3.6 2-2.7 2.1-11.2 13.7-11.2 13.7z"
  })), _g203 || (_g203 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp208)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "cD",
    d: "m231.3 145.9l0.6-62.8h4.9l-0.5 62.8z"
  }))), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "cE",
    d: "m232 145.9l0.6-63.7h3.6l-0.6 63.7z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "cF",
    d: "m235.6 146.1h-3.6q-0.1 0-0.1-0.1-0.1-0.1-0.1-0.1l0.6-63.7q0-0.2 0.2-0.2l3.6 0.1q0.1 0 0.1 0 0.1 0.1 0.1 0.1l-0.6 63.7c0 0.1-0.1 0.2-0.2 0.2zm-3.4-0.4h3.2l0.6-63.3h-3.2z"
  })), _g204 || (_g204 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp209)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cE",
    d: "m232.5 93.8l0.1-11.6h3.6l-0.1 11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "cF",
    d: "m232.5 94q-0.1 0-0.2-0.1 0 0 0-0.1l0.1-11.6c0-0.1 0.1-0.2 0.2-0.2l3.6 0.1q0.1 0 0.1 0 0.1 0.1 0.1 0.1l-0.1 11.6c0 0.1-0.1 0.2-0.2 0.2zm0.3-11.6l-0.1 11.2h3.2l0.1-11.2z"
  }))), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cG",
    d: "m160.1 199.1c-0.1-0.8-0.2-1.6-0.4-2.4-0.3-1.5-0.8-3-1.2-4.5-0.3-1.1-0.6-2.4-1.6-3.1-0.9-0.7-2.7-0.1-3.6 0q-2.3 0.4-4.6 0.9c-1.4 0.3-2.8 0.6-4.2 1.1-0.9 0.3-1.8 0.7-2.2 1.6-1.9 1.5-3.8 2.6-6.1 3.5-2.4 1-4.9 1.6-7.4 2.4-2 0.6-4 1.4-5.4 2.9q-0.3 0.3-0.5 0.7-0.1 0.1-0.1 0.1c-0.4 1-0.3 2.1 0.7 2.9 1.5 1 4 1.1 5.7 1.3 2.6 0.3 5.4 0.3 8 0.2 5.6-0.3 10.8-2.3 16.2-3q1.6-0.2 3.1-0.2c0.5 0 1.1-0.1 1.5-0.2 0.8-0.1 1.5-0.4 1.8-0.9q0.2-0.3 0.3-0.7 0.2-0.3 0.2-0.8c0-0.6-0.2-1.2-0.2-1.8z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m156.9 189.4c0.7 0.6 1 1.8 1.3 2.6 0.4 1.1 0.6 2.2 0.8 3.2q0.1 0.2 0.2 0.5c-0.4-0.2-0.9-0.2-1.2-0.4-0.9-0.3-1.6-0.8-2.2-1.4-0.7-0.7-1.3-1.7-1.5-2.6-0.1-0.4-0.2-0.7-0.2-1.1 0-0.3 0.1-0.8-0.1-1q0 0.1 0 0c1-0.1 2.1-0.3 2.9 0.2z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m123.8 201.2c1-0.9 2.3-1.5 3.5-2 1.6-0.6 3.2-1 4.9-1.4 1 0.6 1.6 6.5 1.8 7.7q-1.3 0-2.5 0c-1.6-0.1-3.2-0.3-4.8-0.5-1.3-0.3-3.5-0.8-3.8-2.4 0.2-0.5 0.6-1 0.9-1.4z"
  })), _g205 || (_g205 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp210)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cH",
    d: "m132.2 197.8c0.5 1.2 0.8 2.5-0.5 3.3-1.6 0.9-3.7 1.2-5.4 1.3-0.7 0-2.4 0-2.7-0.9-0.3 0.3-0.5 0.7-0.7 1.1 0.3 1.6 2.5 2.1 3.8 2.4 1.6 0.2 3.2 0.4 4.8 0.5q1.2 0 2.5 0c-0.2-1.2-0.8-6.9-1.8-7.7z"
  }))), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m159.8 201.7q0 0.1 0 0.1c-0.3 0.4-0.6 0.6-0.9 0.9q-0.1 0-0.1 0.1 0 0 0 0c-0.4 0.1-0.9 0.2-1.4 0.2q-0.3 0.1-0.6 0.1-0.2 0-0.4 0-1.1 0.1-2.2 0.2c-2.6 0.2-5.2 0.9-7.8 1.5-5.6 1.4-11.3 2-17.1 1.5-1.8-0.2-4.4-0.4-5.9-1.6-0.6-0.5-0.7-1.2-0.6-1.8 0.2 0.9 1.1 1.4 1.9 1.7 1.5 0.7 3.2 0.8 4.7 0.9 3.5 0.4 7.2 0.3 10.7-0.3 3.4-0.6 6.7-1.8 10.1-2.2 1.8-0.2 3.6-0.4 5.3-0.7 1.5-0.2 3.1-0.4 4.4-1.1q0 0.2-0.1 0.5z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "cI",
    d: "m160 200.9c-1.4 0.8-3.1 0.9-4.7 1.2-1.6 0.2-3.3 0.4-5 0.6-3.1 0.4-6.1 1.5-9.1 2q-3.5 0.7-7 0.8c0-1-0.9-7-1.9-7.8q1.2-0.3 2.4-0.6c2.3-0.8 4.5-1.7 6.5-3.2 0.7-0.5 1.3-1.2 1.9-1.8 0-0.1 0-0.1 0-0.1q-0.4 0.3-0.7 0.6c0.6-1.1 2.4-1.4 3.6-1.7q1.8-0.4 3.6-0.8 1.8-0.4 3.6-0.7 0.3-0.1 0.7-0.1c-0.3 1.6 0.3 3.1 1.2 4.4 0.5 0.8 1.4 1.3 2.2 1.8 0.6 0.3 1.2 0.2 1.9 0.4q0 0.1 0 0c0.4 1.3 0.7 2.6 0.7 3.9q0 0.3 0.1 0.7 0 0.2 0 0.4z"
  })), _g206 || (_g206 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp211)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cI",
    d: "m160 200.9c-1.4 0.8-3.1 0.9-4.7 1.2-1.6 0.2-3.3 0.4-5 0.6-3.1 0.4-6.1 1.5-9.1 2q-3.5 0.7-7 0.8c0-1-0.9-7-1.9-7.8q1.2-0.3 2.4-0.6c2.3-0.8 4.5-1.7 6.5-3.2 0.7-0.5 1.3-1.2 1.9-1.8 0-0.1 0-0.1 0-0.1q-0.4 0.3-0.7 0.6c0.6-1.1 2.4-1.4 3.6-1.7q1.8-0.4 3.6-0.8 1.8-0.4 3.6-0.7 0.3-0.1 0.7-0.1c-0.3 1.6 0.3 3.1 1.2 4.4 0.5 0.8 1.4 1.3 2.2 1.8 0.6 0.3 1.2 0.2 1.9 0.4q0 0.1 0 0c0.4 1.3 0.7 2.6 0.7 3.9q0 0.3 0.1 0.7 0 0.2 0 0.4z"
  }))), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "cJ",
    d: "m193.4 131.8c-1.7-0.6-3.6-1-5.4-1.4-1.9-0.4-3.8-1-5.7-1.4-3.6-0.9-7.2-1.7-10.9-2.1-1.9-0.2-3.7-0.4-5.5-0.3q-0.7 0-1.1 0.3c0 0 0 0.1 0 0.1q0 0 0 0-0.3 0.3-0.3 0.8c-0.3 1.1-0.8 2.1-1.2 3.1q-0.1 0-0.3 0-3.1-0.1-6.3 0.1c-4.3 0.2-8.7 0.8-12.9 1.7q-3.1 0.6-6.1 1.6c-1.8 0.6-3.5 1.1-5 2.2-1.2 0.9-2.5 2.1-3.1 3.4-0.7 1.3-0.6 2.8-0.5 4.2 0 3.2 0.9 6.5 1.6 9.6 0.9 4 1.8 8.1 2.8 12.1 1 4.1 2.2 8.1 3.3 12.2 1.2 3.9 2.2 7.9 3.4 11.9 0 0.1 0 0.4 0.2 0.4 0.4 0.2 1 0 1.5 0 1.4-0.1 2.9-0.4 4.3-0.7 3-0.6 5.9-1.3 8.7-2.1 0.2-0.1 0.3-0.2 0.2-0.3-0.1-0.3-0.3-0.6-0.5-0.8-0.9-3.2-1.3-6.4-1.9-9.7q-0.8-4.8-1.5-9.7c-0.5-3.3-1.1-6.6-1.8-9.9-0.4-1.5-0.7-3.1-1.1-4.6-0.2-0.7-0.6-1.4-0.9-2.1q0-0.1 0-0.1 0.1-0.1 0-0.2-0.4-0.7-0.9-1.3 0 0 0-0.1c0-0.4 0.3-0.8 0.1-1.3 0-0.2-0.3-0.3-0.5-0.3 2.2-0.3 4.3-0.2 6.5 0 2.4 0.1 4.9 0.1 7.3 0 4.9-0.1 9.8-0.3 14.7-0.7 4.5-0.4 9.1-1.2 13.4-2.8 2.9-1.1 4.8-3.5 5.4-6.4q0 0 0 0c0.2-0.8 0.2-1.6 0.5-2.3 0.2-0.7 1-1.1 1.1-1.7 0.2-0.9-1-1.1-1.6-1.4z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "cK",
    d: "m194.2 133.9c-0.2 0.4-0.5 0.8-0.7 1.2-0.1 0.6-0.1 1.3-0.2 1.9-0.3 1.6-1 3.1-2.2 4.4-1.5 1.5-3.6 2.2-5.6 2.7-4.3 1.2-8.6 1.8-13.1 2.1-4.4 0.3-8.9 0.6-13.4 0.6-2.2 0-4.4 0-6.6-0.1-2.2-0.2-4.3-0.2-6.4 0.2q0 0-0.1 0c-0.2-0.1-0.1-0.2 0-0.5 0.2-0.7 0-1.2-0.4-1.8-0.6-0.7-1.2-1.5-1.9-2.2-0.1 0-0.2 0.1-0.1 0.1 0.5 0.7 1 1.4 1.5 2.2 0.2 0.3 0.4 0.5 0.6 0.9 0.5 1.3-0.2 0.7-0.3 1.3-0.1 0.3 0.3 0.4 0.6 0.5 0.5 0.3 0.3 0.7 0.2 1-0.8-0.9-1.8-1.7-2.7-2.5-0.9-0.7-1.7-1.3-2.7-1.9-0.8-0.5-1.7-1.2-2.7-1.4-0.1 0-0.2 0-0.1 0.1 1 0.3 1.7 1.1 2.6 1.6 0.9 0.5 1.8 1.3 2.6 1.9 0.7 0.6 1.4 1.2 2.1 1.9q0.2 0.3 0.5 0.6c-0.9-0.6-1.8-1.2-2.8-1.7-1.4-0.7-2.8-1.3-4.3-1.8q-1.9-0.6-3.8-1c-0.5-0.1-1.5-0.3-1.2-1 0.1-0.1 0.2-0.5 0.4-0.8q-0.2 0.2-0.4 0.4-0.1 0.2-0.2 0.4c-0.6 1 1 1.3 1.7 1.4 1.9 0.5 3.8 1 5.6 1.8 1.1 0.5 2 0.9 3 1.5 0.8 0.5 1.6 1.1 2.5 1.4q0.4 0.6 0.9 1.1 0 0 0 0c0.1 0.2 0.1 0.5 0.2 0.7 0.1 0.3 0.3 0.7 0.5 1.1 0.5 1.7 0.8 3.4 1.2 5.1 0.7 3.4 1.3 6.8 1.8 10.2q0.8 4.9 1.6 9.7c0.3 1.7 0.5 3.4 0.8 5 0.3 1.4 0.6 2.8 1.1 4.2q0 0 0 0c0 0.4 0.2 0.6 0.4 0.8-2.2 0.7-4.5 1.2-6.8 1.7q-1.8 0.4-3.6 0.7c-0.6 0.1-3.5 0.9-3.9 0.1-0.8-3.8-2-7.6-3-11.4-1.2-4-2.4-8.1-3.4-12.2-1.1-4.1-1.9-8.2-2.9-12.3-0.4-2-0.9-4-1.3-6.1-0.2-1.1-0.3-2.2-0.4-3.3-0.1-1.7-0.2-3.5 0.8-5 0.9-1.4 2.5-2.7 4-3.5 0.8-0.4 1.7-0.6 2.6-0.9 0.9-0.3 1.8-0.6 2.8-0.9 1.9-0.5 3.8-1 5.8-1.3q5.8-1.1 11.8-1.4 3-0.2 6-0.2c0.8-0.1 1.7 0 2.5 0 0.9 0 1.9 0 2.9-0.1-1.7-0.2-3.3-0.2-5-0.2 0.5-1.2 1.1-2.4 1.2-3.6 0.4-0.6 1.5-0.5 2.2-0.5q1.1 0 2.3 0.1 2.5 0.2 4.9 0.6c3.2 0.5 6.2 1.3 9.3 2 3.1 0.7 6.1 1.5 9.1 2.4q0.8 0.2 1.5 0.5 0.3 0.1 0.6 0.4c0.4 0.3-0.3 0.9-0.5 1.1z"
  })), _g207 || (_g207 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp212)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cK",
    d: "m194.2 133.9c-0.2 0.4-0.5 0.8-0.7 1.2-0.1 0.6-0.1 1.3-0.2 1.9-0.3 1.6-1 3.1-2.2 4.4-1.5 1.5-3.6 2.2-5.6 2.7-4.3 1.2-8.6 1.8-13.1 2.1-4.4 0.3-8.9 0.6-13.4 0.6-2.2 0-4.4 0-6.6-0.1-2.2-0.2-4.3-0.2-6.4 0.2q0 0-0.1 0c-0.2-0.1-0.1-0.2 0-0.5 0.2-0.7 0-1.2-0.4-1.8-0.6-0.7-1.2-1.5-1.9-2.2-0.1 0-0.2 0.1-0.1 0.1 0.5 0.7 1 1.4 1.5 2.2 0.2 0.3 0.4 0.5 0.6 0.9 0.5 1.3-0.2 0.7-0.3 1.3-0.1 0.3 0.3 0.4 0.6 0.5 0.5 0.3 0.3 0.7 0.2 1-0.8-0.9-1.8-1.7-2.7-2.5-0.9-0.7-1.7-1.3-2.7-1.9-0.8-0.5-1.7-1.2-2.7-1.4-0.1 0-0.2 0-0.1 0.1 1 0.3 1.7 1.1 2.6 1.6 0.9 0.5 1.8 1.3 2.6 1.9 0.7 0.6 1.4 1.2 2.1 1.9q0.2 0.3 0.5 0.6c-0.9-0.6-1.8-1.2-2.8-1.7-1.4-0.7-2.8-1.3-4.3-1.8q-1.9-0.6-3.8-1c-0.5-0.1-1.5-0.3-1.2-1 0.1-0.1 0.2-0.5 0.4-0.8q-0.2 0.2-0.4 0.4-0.1 0.2-0.2 0.4c-0.6 1 1 1.3 1.7 1.4 1.9 0.5 3.8 1 5.6 1.8 1.1 0.5 2 0.9 3 1.5 0.8 0.5 1.6 1.1 2.5 1.4q0.4 0.6 0.9 1.1 0 0 0 0c0.1 0.2 0.1 0.5 0.2 0.7 0.1 0.3 0.3 0.7 0.5 1.1 0.5 1.7 0.8 3.4 1.2 5.1 0.7 3.4 1.3 6.8 1.8 10.2q0.8 4.9 1.6 9.7c0.3 1.7 0.5 3.4 0.8 5 0.3 1.4 0.6 2.8 1.1 4.2q0 0 0 0c0 0.4 0.2 0.6 0.4 0.8-2.2 0.7-4.5 1.2-6.8 1.7q-1.8 0.4-3.6 0.7c-0.6 0.1-3.5 0.9-3.9 0.1-0.8-3.8-2-7.6-3-11.4-1.2-4-2.4-8.1-3.4-12.2-1.1-4.1-1.9-8.2-2.9-12.3-0.4-2-0.9-4-1.3-6.1-0.2-1.1-0.3-2.2-0.4-3.3-0.1-1.7-0.2-3.5 0.8-5 0.9-1.4 2.5-2.7 4-3.5 0.8-0.4 1.7-0.6 2.6-0.9 0.9-0.3 1.8-0.6 2.8-0.9 1.9-0.5 3.8-1 5.8-1.3q5.8-1.1 11.8-1.4 3-0.2 6-0.2c0.8-0.1 1.7 0 2.5 0 0.9 0 1.9 0 2.9-0.1-1.7-0.2-3.3-0.2-5-0.2 0.5-1.2 1.1-2.4 1.2-3.6 0.4-0.6 1.5-0.5 2.2-0.5q1.1 0 2.3 0.1 2.5 0.2 4.9 0.6c3.2 0.5 6.2 1.3 9.3 2 3.1 0.7 6.1 1.5 9.1 2.4q0.8 0.2 1.5 0.5 0.3 0.1 0.6 0.4c0.4 0.3-0.3 0.9-0.5 1.1z"
  }))), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "cL",
    d: "m146.2 169.5c0.1-2.6 0.2-5.2 0.1-7.8q-0.1-1.8-0.2-3.7c-0.1-1.2 0-2.5-0.1-3.7 0 0-0.1 0-0.1 0.1 0.1 1 0 2.1 0 3.1q0 1.9 0.1 3.7c0.1 2.6 0 5.2-0.1 7.8-0.1 2.7-0.1 5.4-0.3 8.1-0.2 2.6-0.6 5.1-0.9 7.7 0 0.1 0.2 0 0.2-0.1 0.4-2.5 0.8-5.1 1-7.7 0.2-2.5 0.2-5 0.3-7.5z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cM",
    d: "m156.8 190.6c-0.4-1-0.6-2-0.8-3-0.1-0.5-0.2-1.3-0.7-1.5-0.6-0.3-1.2 0-1.7 0.3-1 0.5-2.2 0.6-3.2 0.8-2.2 0.5-4.4 0.8-6.6 1.1q-1.5 0.2-3 0.3c0 0-0.4 0-0.7 0.1q0 0 0 0c-1.6 0-0.3 2.6-0.2 3.3 0.2 0.6 0.4 1.2 1.1 1.2 0.3 0.1 0.7 0 1.1-0.1 0.7-0.2 1.4-0.2 2.1-0.3 1.2-0.1 2.4 0 3.5 0 1.2 0 2.4-0.1 3.5-0.2 1.9-0.2 3.6-0.5 5.1-1.6q0.2-0.1 0.3-0.2c0.1 0 0.2-0.1 0.2-0.2z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "cN",
    d: "m151.7 192.3q-2.5 0.3-5.1 0.2c-1.5 0-3 0-4.5 0.3-0.6 0.1-1.2 0.4-1.6-0.3-0.2-0.3-0.3-0.8-0.4-1.2-0.1-0.5-0.8-1.9-0.2-2.4 0.5-0.2 1.4-0.1 1.9-0.1q1.4-0.2 2.8-0.3 2.6-0.3 5.1-0.9 1.3-0.2 2.5-0.5 0.6-0.2 1.1-0.3c0.6-0.2 1.2-0.8 1.8-0.4 0.6 0.3 0.6 1.5 0.8 2.1q0.2 1.1 0.5 2.1c-0.2 0.1-0.4 0.1-0.6 0.3q0 0.1 0 0.2-0.7 0.4-1.5 0.7c-0.8 0.3-1.7 0.3-2.6 0.5z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "cO",
    d: "m143 195.8c-0.4-0.7-1.6-1.4-2.6-1.6 0 0 0.1-0.1 0.1-0.1 0-0.2-0.2-0.6-0.5-0.5-0.3 0-0.6 0.2-0.7 0.5-0.4 0-0.8 0.1-1.2 0.3q-0.3 0.1-0.5 0.3-0.2 0.1-0.3 0.2-0.1 0.1-0.1 0.3-0.1 0-0.1 0.1c-0.9-0.2-1.8 0-2.3 1-0.9-0.4-1.7-0.2-2 1q0 0.1 0.1 0.1 0 0 0 0 0.4 0 0.7 0.1c-0.2 0.6-0.2 1.3-0.2 1.9 0 0.4 0 1.4 0.6 1.5 0.2 0 0.4-0.2 0.4-0.4 0.2-0.8 0.2-1.6 0.3-2.4q0.4 0.2 0.7 0.5c0.5 0.4 0.9 1.1 1.6 1.4 0.6 0.2 0.9-0.1 0.9-0.6 0-0.3-0.1-0.6-0.1-0.8 0-0.5-0.1-1-0.1-1.4q0.2 0.1 0.4 0.3c0.5 0.3 0.8 0.9 1.3 1.1 0.5 0.2 1.2 0 1.1-0.6 0.1-0.3 0.1-0.6 0-0.9 0-0.4-0.1-0.8-0.2-1.1 0.7 0.4 1.4 0.9 2.2 1.1 0.8 0.1 0.8-0.9 0.5-1.3z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m140.1 193.8c0.2 0.1 0.2 0.2 0.2 0.4q-0.3-0.1-0.5-0.1-0.2 0-0.4 0c0.1-0.2 0.5-0.5 0.7-0.3z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m134.5 198q-0.1 0.7-0.1 1.4c-0.1 0.2 0 1.6-0.5 1.2-0.4-0.2-0.3-1.4-0.3-1.8q0-0.6 0.1-1.2 0.5 0.1 0.9 0.4-0.1 0-0.1 0z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m136.7 199.5c-0.7-0.5-1.1-1.2-1.8-1.6-0.6-0.4-1.2-0.7-1.9-0.7q0 0 0 0c0.7-1.9 2.4-0.3 3.2 0.4q0.4 0.5 0.8 0.9 0.3 0.3 0.5 0.6c0.4 0.5-0.5 0.7-0.8 0.4z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m136.7 197.4q0 0.1-0.1 0.2c-0.3-0.3-0.8-0.7-1.2-1q0.7-0.1 1.3 0.1-0.1 0.3 0 0.7z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m137.6 198.8c-0.1-0.3-0.4-0.6-0.8-1q0-0.1 0-0.1c0-0.1 0-0.3 0-0.4 0-0.2 0-0.4 0-0.6q0.4 0.2 0.9 0.5c-0.2 0.5-0.1 1.1-0.1 1.6z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m139.3 198.4c-0.7-0.4-1.1-1.3-1.8-1.7-0.7-0.4-1.4-0.4-2.2-0.3q0 0-0.1 0.1-0.1-0.1-0.3-0.1 0-0.1 0-0.1 0 0 0 0 0.5-0.5 1.1-0.9 0.4 0 0.8 0.1c0.6 0.1 1.1 0.3 1.6 0.6 0.3 0.2 0.6 0.5 0.9 0.7q0.2 0.2 0.4 0.5c0.1 0.1 0.4 0.4 0.5 0.5 0 0.8-0.4 1-0.9 0.6z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m139.2 196.4q-0.6-0.5-1.2-0.8c0.4-0.2 0.8-0.2 1.2-0.1q0 0.3 0 0.6 0 0.1 0 0.3z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m140.3 197c0 0.2 0.1 0.5 0.1 0.8q0 0 0-0.1c-0.2-0.3-0.5-0.8-1-1.1 0-0.2 0-0.4 0-0.5q-0.1-0.3-0.1-0.6 0.4 0.2 0.8 0.4c0 0.4 0.1 0.7 0.2 1.1z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m142.5 196.9c-0.5-0.1-1.1-0.6-1.5-0.8q-0.4-0.2-0.8-0.4c0 0 0-0.1-0.1 0q-0.1-0.1-0.2-0.1c-0.7-0.4-1.3-0.5-2.1-0.2q0 0.1 0 0.1-0.3-0.1-0.6-0.2 0 0 0-0.1c0.1-0.1 0.3-0.3 0.5-0.4q0.1-0.1 0.2-0.2c0.5-0.2 1-0.3 1.2-0.3 0.6-0.1 1.1 0.1 1.7 0.3 0.5 0.1 0.9 0.4 1.4 0.7q0.2 0.1 0.4 0.3 0.1 0.2 0.3 0.4c0.2 0.3 0.2 1.1-0.4 0.9z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "cG",
    d: "m161.6 203.2c-0.1-0.9-0.2-1.7-0.4-2.5-0.3-1.5-0.8-3-1.2-4.5-0.3-1.1-0.7-2.4-1.6-3.1-0.9-0.6-2.7-0.1-3.6 0.1q-2.3 0.4-4.6 0.9c-1.4 0.3-2.8 0.6-4.2 1-0.9 0.4-1.8 0.8-2.2 1.7-1.9 1.5-3.8 2.6-6.1 3.5-2.4 0.9-4.9 1.6-7.4 2.3-2 0.6-4 1.4-5.4 2.9q-0.3 0.4-0.6 0.8 0 0 0 0 0 0.1 0 0.1c-0.4 1-0.3 2.1 0.7 2.8 1.5 1.1 3.9 1.2 5.7 1.4 2.6 0.3 5.4 0.3 8 0.1 5.6-0.3 10.7-2.3 16.2-2.9q1.6-0.2 3.1-0.2c0.5-0.1 1.1-0.1 1.5-0.3 0.7-0.1 1.5-0.3 1.8-0.8q0.2-0.3 0.3-0.7 0.2-0.4 0.2-0.9c0-0.5-0.2-1.2-0.2-1.7z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m158.4 193.5c0.7 0.5 1 1.8 1.3 2.6 0.3 1 0.6 2.1 0.8 3.1q0.1 0.3 0.2 0.5c-0.4-0.1-0.9-0.2-1.2-0.3-0.9-0.3-1.6-0.8-2.2-1.4-0.7-0.7-1.3-1.7-1.6-2.7-0.1-0.4-0.1-0.7-0.1-1.1 0-0.3 0.1-0.7-0.1-0.9q0 0 0 0c1-0.2 2.1-0.4 2.9 0.2z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m125.3 205.3c1-1 2.3-1.6 3.5-2 1.6-0.7 3.2-1.1 4.9-1.5 1 0.7 1.6 6.6 1.8 7.7q-1.3 0.1-2.5 0c-1.6 0-3.2-0.2-4.8-0.5-1.3-0.2-3.6-0.8-3.8-2.3 0.2-0.5 0.5-1 0.9-1.4z"
  })), _g208 || (_g208 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp213)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cH",
    d: "m133.7 201.8q-0.2 0-0.3 0.1c0.4 1.1 0.5 2.4-0.1 3.4-0.8 1.5-2.9 1.8-4.5 1.8-1 0-3.1 0.1-3-1.4 0.1-0.6 0.3-1 0.7-1.3q-0.6 0.4-1.2 0.9c-0.4 0.4-0.7 0.9-0.9 1.4 0.2 1.5 2.5 2.1 3.8 2.3 1.6 0.3 3.2 0.5 4.8 0.5q1.2 0.1 2.5 0c-0.2-1.1-0.8-7-1.8-7.7z"
  }))), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m161.3 205.7q0 0.1 0 0.2c-0.3 0.3-0.6 0.6-0.9 0.8q-0.1 0.1-0.1 0.1 0 0 0 0c-0.5 0.2-0.9 0.2-1.4 0.3q-0.3 0-0.6 0.1-0.2 0-0.4 0-1.1 0-2.2 0.1c-2.6 0.3-5.2 0.9-7.8 1.6-5.6 1.4-11.3 2-17.1 1.4-1.8-0.2-4.4-0.3-5.9-1.6-0.6-0.5-0.7-1.1-0.6-1.7 0.2 0.8 1.1 1.3 1.9 1.7 1.5 0.6 3.2 0.7 4.7 0.9 3.5 0.4 7.2 0.2 10.7-0.4 3.4-0.5 6.7-1.7 10.1-2.2 1.8-0.2 3.6-0.4 5.3-0.6 1.5-0.3 3.1-0.4 4.4-1.2q0 0.3-0.1 0.5z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "cI",
    d: "m161.5 204.9c-1.4 0.9-3.1 1-4.7 1.2-1.7 0.3-3.3 0.4-5 0.6-3.1 0.4-6.1 1.5-9.2 2.1q-3.4 0.6-6.9 0.7c0-0.9-0.9-6.9-1.9-7.7q1.2-0.3 2.4-0.7c2.3-0.7 4.5-1.6 6.4-3.1 0.8-0.6 1.4-1.2 2-1.9 0 0 0-0.1-0.1 0q-0.3 0.3-0.6 0.6c0.6-1.1 2.4-1.4 3.6-1.7q1.8-0.5 3.6-0.9 1.8-0.4 3.6-0.7 0.3 0 0.7-0.1c-0.3 1.7 0.3 3.1 1.2 4.5 0.5 0.8 1.4 1.2 2.2 1.7 0.6 0.4 1.2 0.3 1.9 0.5q0 0 0 0c0.4 1.2 0.7 2.6 0.7 3.9q0 0.3 0.1 0.6 0 0.2 0 0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _g209 || (_g209 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp214)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cI",
    d: "m137.5 208.4c-1.1-0.8-1.5-1.8-1.7-3-0.2-1.4-0.8-2.7-1.6-3.7q-0.2 0-0.4 0.1c1 0.8 1.9 6.8 1.8 7.7q2.1 0 4.1-0.3c-0.8-0.1-1.6-0.3-2.2-0.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _g210 || (_g210 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp215)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cI",
    d: "m161.4 203.9c0-1.3-0.3-2.7-0.7-3.9q0 0 0 0c-0.7-0.2-1.3-0.1-1.9-0.5-0.8-0.5-1.7-0.9-2.2-1.7-0.9-1.4-1.5-2.8-1.2-4.5q-0.4 0.1-0.7 0.1-1.8 0.3-3.6 0.7-1.8 0.4-3.6 0.9c-1.2 0.3-3 0.6-3.6 1.7q0.3-0.3 0.6-0.6c0.1-0.1 0.1 0 0.1 0-0.6 0.6-1.2 1.2-1.8 1.8 2.9 1 6.7-0.5 9.5-0.9 0.4-0.1 1.9-0.7 2.2 0.1 0.2 0.7 0.7 1.6 1.3 2.2 0.7 0.5 1.5 0.7 2.3 1.1 0.8 0.6 0.8 2.2 0.8 3.1 0 1.2-1.2 1.6-2.1 2q-1.2 0.5-2.4 0.9 1.2-0.1 2.4-0.3c1.6-0.2 3.3-0.3 4.7-1.2q0-0.2 0-0.4-0.1-0.3-0.1-0.6z"
  })))), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "cJ",
    d: "m193.9 130.4c-1.8-0.6-3.6-1-5.4-1.3-1.9-0.4-3.9-0.9-5.8-1.2-3.6-0.8-7.3-1.4-11-1.7-1.8-0.2-3.7-0.3-5.5-0.1q-0.7 0-1 0.4c-0.1 0-0.1 0-0.1 0q0 0 0 0-0.3 0.4-0.2 0.9c-0.3 1.2-0.7 2.2-1.1 3.3q-0.1 0-0.3 0-3.2 0.1-6.3 0.4c-4.3 0.4-8.6 1.3-12.8 2.3q-3.1 0.8-6 2c-1.8 0.7-3.5 1.3-5 2.6-1.1 0.9-2.3 2.2-2.9 3.6-0.7 1.4-0.5 2.9-0.3 4.5 0.1 3.3 1.1 6.7 1.9 9.9 1.1 4.2 2.1 8.4 3.3 12.5 1.2 4.3 2.5 8.5 3.9 12.7 1.3 4.1 2.5 8.2 3.9 12.3-0.1 0.2-0.1 0.4 0.1 0.4 0.5 0.2 1 0 1.5 0 1.5-0.2 2.9-0.6 4.3-1 2.9-0.7 5.8-1.5 8.7-2.6 0.1 0 0.2-0.2 0.1-0.3-0.1-0.3-0.3-0.5-0.5-0.8-1-3.2-1.6-6.6-2.3-10q-1-5.1-1.9-10.2c-0.7-3.4-1.4-6.8-2.3-10.2-0.4-1.6-0.7-3.2-1.2-4.8-0.3-0.8-0.7-1.5-1-2.2q0-0.1 0-0.1 0-0.1 0-0.1-0.4-0.8-1-1.4 0 0 0-0.1c0-0.4 0.3-0.9 0.1-1.4 0-0.1-0.3-0.2-0.5-0.3 2.1-0.3 4.3-0.4 6.4-0.3 2.4 0.1 4.9-0.1 7.4-0.2 4.8-0.3 9.8-0.8 14.6-1.5 4.5-0.6 9.1-1.6 13.3-3.5 2.8-1.3 4.7-3.9 5.1-6.9q0 0 0 0c0.2-0.8 0.2-1.7 0.4-2.5 0.2-0.7 1-1.1 1.1-1.8 0.2-0.9-1.1-1.1-1.7-1.3z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "cP",
    d: "m194.8 132.5c-0.2 0.4-0.5 0.8-0.6 1.3-0.1 0.6-0.1 1.3-0.2 1.9-0.2 1.8-0.9 3.4-2 4.7-1.4 1.7-3.5 2.5-5.4 3.2-4.3 1.4-8.7 2.3-13.1 2.8-4.4 0.4-8.9 1-13.3 1.1-2.2 0.1-4.5 0.3-6.7 0.2-2.1 0-4.2 0.1-6.3 0.5q-0.1 0-0.1 0.1c-0.2-0.2-0.1-0.3 0-0.6 0.1-0.7-0.1-1.2-0.6-1.8-0.6-0.8-1.2-1.6-1.9-2.3-0.1 0-0.2 0.1-0.1 0.1 0.5 0.7 1.1 1.5 1.6 2.2 0.2 0.3 0.4 0.6 0.6 1 0.6 1.3-0.2 0.7-0.2 1.3-0.1 0.4 0.3 0.5 0.5 0.6 0.6 0.2 0.4 0.6 0.4 1-0.9-0.9-1.9-1.8-2.9-2.5-0.9-0.7-1.8-1.3-2.7-1.9-0.9-0.5-1.8-1.2-2.9-1.4 0 0-0.1 0.1 0 0.1 1 0.4 1.7 1.1 2.7 1.6 0.9 0.5 1.8 1.3 2.6 2 0.7 0.6 1.5 1.2 2.2 1.8q0.3 0.3 0.5 0.6c-0.9-0.6-1.9-1.2-2.8-1.6-1.4-0.7-2.9-1.3-4.4-1.8q-1.9-0.5-3.9-0.8c-0.4-0.1-1.4-0.3-1.2-1 0.1-0.1 0.2-0.5 0.4-0.8q-0.2 0.1-0.4 0.4-0.1 0.2-0.2 0.5c-0.5 1 1.1 1.2 1.7 1.3 2 0.4 3.9 0.9 5.8 1.7 1 0.4 2 0.8 3 1.4 0.8 0.5 1.6 1 2.6 1.3q0.4 0.6 0.9 1.1 0 0.1 0 0.1c0.1 0.2 0.2 0.4 0.2 0.6 0.1 0.4 0.4 0.8 0.5 1.2 0.6 1.7 1 3.5 1.5 5.3 0.8 3.5 1.6 7 2.2 10.6q1 5.1 2 10.1c0.4 1.8 0.7 3.5 1 5.2 0.4 1.4 0.7 2.9 1.2 4.3q0 0.1 0 0.1c0.1 0.3 0.3 0.5 0.5 0.8-2.2 0.8-4.4 1.5-6.7 2q-1.8 0.5-3.6 0.9c-0.6 0.2-3.5 1.1-3.9 0.4-0.9-4-2.2-8-3.5-11.9-1.3-4.2-2.7-8.4-3.9-12.6-1.2-4.2-2.2-8.5-3.3-12.8-0.6-2.1-1.1-4.2-1.6-6.3-0.2-1.1-0.4-2.3-0.5-3.5-0.2-1.8-0.4-3.6 0.6-5.2 0.8-1.5 2.4-3 3.8-3.9 0.8-0.4 1.7-0.7 2.5-1 1-0.4 1.9-0.8 2.8-1.1 1.9-0.7 3.8-1.2 5.8-1.7 3.8-0.9 7.8-1.6 11.7-1.9q3-0.3 6-0.5c0.8-0.1 1.7-0.1 2.5-0.1 0.9-0.1 1.9-0.1 2.9-0.2-1.7-0.2-3.4-0.1-5 0 0.4-1.3 1-2.6 1.1-3.9 0.4-0.6 1.4-0.5 2.1-0.6q1.2 0 2.3 0.1 2.5 0.1 5 0.4c3.1 0.4 6.2 1 9.3 1.7 3.1 0.6 6.2 1.2 9.2 2.1q0.8 0.2 1.5 0.4 0.3 0.2 0.6 0.4c0.4 0.3-0.2 0.9-0.4 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _g211 || (_g211 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp216)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cK",
    d: "m138.1 160.7c0.2-1.5 0.1-3 0.1-4.5-0.6 1.7-1 3.4-1.2 5.2-0.3 2.1-0.7 4.4-0.5 6.6 0.8-2.4 1.3-4.9 1.6-7.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _g212 || (_g212 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp217)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cK",
    d: "m144.8 181.7c0.1 1.3 0.3 2.7 0.5 4 0.4-3.8 0.7-7.6 0.3-11.5-0.3-2.5-0.7-4.9-1-7.3-0.2-1.6-0.2-3.3-0.4-4.9-0.2 4.2-0.1 8.3 0.2 12.5 0.1 2.4 0.2 4.8 0.4 7.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _g213 || (_g213 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp218)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cK",
    d: "m131.2 147.2c-0.3-2.3-0.6-4.9 0.9-6.8 1.2-1.7 3-2.8 4.9-3.6 4.9-2.2 10.3-3.5 15.6-4.3 4.4-0.7 8.9-1.2 13.3-1q-1.3-0.2-2.6-0.5-2.8 0.2-5.6 0.5c-3.9 0.3-7.9 1-11.7 1.9-2 0.5-3.9 1-5.8 1.7-0.9 0.3-1.8 0.7-2.8 1.1-0.8 0.3-1.7 0.6-2.5 1-1.4 0.9-3 2.4-3.8 3.9-1 1.6-0.8 3.4-0.6 5.2 0.1 1.2 0.3 2.4 0.5 3.5q0.4 1.7 0.8 3.3-0.3-2.9-0.6-5.9z"
  })))), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "cL",
    d: "m148.3 171.9c0-2.7 0-5.4-0.3-8.2q-0.1-1.9-0.3-3.9c-0.1-1.2-0.1-2.5-0.3-3.8 0 0 0 0 0 0.1 0.1 1 0 2.1 0.1 3.2q0.1 2 0.2 3.9c0.2 2.8 0.3 5.5 0.3 8.2 0 2.8 0.1 5.7 0 8.5-0.1 2.7-0.4 5.4-0.6 8.1 0 0.1 0.2 0 0.2-0.1 0.3-2.7 0.6-5.4 0.7-8.1 0.1-2.6 0-5.3 0-7.9z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _g214 || (_g214 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp219)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cK",
    d: "m195.2 131.3q-0.3-0.2-0.6-0.4-0.7-0.2-1.5-0.4c-3-0.9-6.1-1.5-9.2-2.1-3.1-0.7-6.2-1.3-9.3-1.7q-2.5-0.3-5-0.4-1.1-0.1-2.3-0.1c-0.7 0.1-1.7 0-2.1 0.6-0.1 1.3-0.7 2.6-1.1 3.9 1.6-0.1 3.3-0.2 5 0-1 0.1-2 0.1-2.9 0.2-0.8 0-1.7 0-2.5 0.1q-0.2 0-0.4 0c3.6 0.4 7.3 1 10.8 1.9 3.2 0.7 7.3 1.6 9.5 4.4 0.2 0.2-0.1 0.4-0.3 0.3-2.4-1.1-5.1-1.6-7.7-1.9-2.2-0.4-4.4-1.1-6.7-0.7 1.7 1.5 4.1 2.2 5.3 4.2 0.1 0.1 0.1 0.2-0.1 0.3-2.3 1.6-5.4 1.6-8.1 2.2-3.6 0.8-7.1 1.7-10.7 2.3q-2.4 0.4-4.7 0.8c-1.1 0.2-2.4 0.4-3.5 0-2.1-0.8-3.2-2.8-4.9-4.2 0.6 1.2 1.1 2.4 1.5 3.7 0 0.2-0.1 0.3-0.3 0.3-0.9 0-1.8-0.5-2.7-0.7-0.5-0.2-1.1-0.4-1.7-0.4-0.8 0-0.2 0.8 0 1.2 0.1 0.1 0 0.3-0.2 0.3-1.4-0.2-2.5-0.9-3.8-1.5-0.8-0.4-0.7-0.4-1 0.3q-0.2 0.4-0.3 0.9c-0.2 0.6-0.4 1.4 0.2 1.9 1.6 1.6 4.3 1.7 6.3 2.4 0.7 0.2 1.6 0.5 2 1.1 0.5 0.6 0.1 1.4-0.1 2-1 2.9-2.6 5.6-3.3 8.7 2.3-1.8 3.5-5.1 4.6-7.7 0.1-0.1 0.3-0.2 0.4-0.1 1.4 1.4 1.5 3.8 1.7 5.6 0.4 3.2 0.8 6.3 1 9.5 0.5 6.5 1.2 14 0.8 20.6 0.8-2.7 1.6-9.3 1.7-9.1 0.8 1.8 1.3 3.7 1.5 5.6 0.2 1.6 0.2 3.5-1 4.8-1.6 1.4-4.3 2.2-6.6 1.8q0.2 0.8 0.4 1.6c0.4 0.7 3.3-0.2 3.9-0.4q1.8-0.4 3.6-0.9c2.3-0.5 4.5-1.2 6.7-2-0.2-0.3-0.4-0.5-0.5-0.8q0 0 0-0.1c-0.5-1.4-0.8-2.9-1.2-4.3-0.3-1.7-0.6-3.4-1-5.2q-1-5-2-10.1c-0.6-3.6-1.4-7.1-2.2-10.6-0.5-1.8-0.9-3.6-1.5-5.3-0.1-0.4-0.4-0.8-0.5-1.2 0-0.2-0.1-0.4-0.2-0.6q0 0 0-0.1-0.5-0.5-0.9-1.1c-1-0.3-1.8-0.8-2.6-1.3-1-0.6-2-1-3-1.4-1.9-0.8-3.8-1.3-5.8-1.7-0.6-0.1-2.2-0.3-1.7-1.3q0.1-0.3 0.2-0.5 0.2-0.3 0.4-0.4c-0.2 0.3-0.3 0.7-0.4 0.8-0.2 0.7 0.8 0.9 1.2 1q2 0.3 3.9 0.8c1.5 0.5 3 1.1 4.4 1.8 0.9 0.4 1.9 1 2.8 1.6q-0.2-0.3-0.5-0.6c-0.7-0.6-1.5-1.2-2.2-1.8-0.8-0.7-1.7-1.5-2.6-2-1-0.5-1.7-1.2-2.7-1.6-0.1 0 0-0.1 0-0.1 1.1 0.2 2 0.9 2.9 1.4 0.9 0.6 1.8 1.2 2.7 1.9 1 0.7 2 1.6 2.9 2.5 0-0.4 0.2-0.8-0.4-1-0.2-0.1-0.6-0.2-0.5-0.6 0-0.6 0.8 0 0.2-1.3-0.2-0.4-0.4-0.7-0.6-1-0.5-0.7-1.1-1.5-1.6-2.2-0.1 0 0-0.1 0.1-0.1 0.7 0.7 1.3 1.5 1.9 2.3 0.5 0.6 0.7 1.1 0.6 1.8-0.1 0.3-0.2 0.4 0 0.6q0-0.1 0.1-0.1c2.1-0.4 4.2-0.5 6.3-0.5 2.2 0.1 4.5-0.1 6.7-0.2 4.4-0.1 8.9-0.7 13.3-1.1 4.4-0.5 8.8-1.4 13.1-2.8 1.9-0.7 4-1.5 5.4-3.2 1.1-1.3 1.8-2.9 2-4.7 0.1-0.6 0.1-1.3 0.2-1.9 0.1-0.5 0.4-0.9 0.6-1.3 0.2-0.3 0.8-0.9 0.4-1.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _g215 || (_g215 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp220)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cK",
    d: "m164.4 129.8q-0.2 0.4-0.3 0.9 0.9-0.1 1.9-0.1-0.9-0.3-1.6-0.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _g216 || (_g216 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp221)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cK",
    d: "m146.1 146.9c0 0.1-0.1 0.3-0.3 0.2-1.3-0.5-2.5-1.2-3.8-1.7q-0.3-0.1-0.5-0.1 0.1 0 0.3 0.1c0.9 0.6 1.8 1.2 2.7 1.9 1 0.8 2 1.6 2.9 2.5 0-0.4 0.2-0.8-0.4-1-0.2-0.1-0.6-0.2-0.5-0.6 0-0.6 0.8 0 0.2-1.3-0.2-0.4-0.4-0.7-0.6-1q-0.1-0.2-0.3-0.3 0.3 0.6 0.3 1.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _g217 || (_g217 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp222)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cK",
    d: "m141.8 146.5c0.2 0.1-0.1 0.4-0.2 0.3-1.2-0.4-2.5-0.5-3.8-0.5q1 0.2 1.9 0.4c1.5 0.5 3 1.1 4.4 1.8 0.9 0.4 1.9 1 2.8 1.6q-0.2-0.3-0.5-0.6c-0.7-0.6-1.5-1.2-2.2-1.8-0.8-0.7-1.7-1.5-2.6-2q-0.6-0.3-1.1-0.7c0.4 0.5 1 1 1.3 1.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _g218 || (_g218 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp223)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cK",
    d: "m135.6 146.2c1.3 1.3 3.5 1.7 5.1 2.2 2.4 0.6 4.1 2 5.7 3.8 0.8 0.8 1.2 1.8 1.1 2.9q0 0.4 0 0.7c0.8 9.1 0 18.2 0.3 27.3 1.3-3 1.4-6.6 1.5-9.9 0.3-4.2 0.4-8.5 0-12.8 0-0.2 0.3-0.3 0.4-0.1 0.9 1.1 1.6 2.4 2 3.7q-0.5-2.5-1.1-5c-0.5-1.8-0.9-3.6-1.5-5.3-0.1-0.4-0.4-0.8-0.5-1.2 0-0.2-0.1-0.4-0.2-0.6q0 0 0-0.1-0.5-0.5-0.9-1.1c-1-0.3-1.8-0.8-2.6-1.3-1-0.6-2-1-3-1.4-1.9-0.8-3.8-1.3-5.8-1.7q-0.2 0-0.5-0.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _g219 || (_g219 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp224)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cK",
    d: "m157 189.2q-0.4-1-0.6-2.1c-0.7 0.7-1.4 1.4-2.1 2-1.2 1.1-2.5 1.9-3.8 2.7q-0.6 0.4-1.3 0.8 0.8-0.2 1.6-0.5c2.3-0.5 4.5-1.2 6.7-2-0.2-0.3-0.4-0.5-0.5-0.8q0 0 0-0.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _g220 || (_g220 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp225)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cK",
    d: "m140.2 159.3c0.6-1.1 1.3-2.3 1.7-3.5 0.6-1.4 1.2-3.2 0.5-4.6-0.1 0.3-0.2 0.6-0.3 0.9-1 2.9-2.6 5.6-3.3 8.7q0.8-0.7 1.4-1.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _g221 || (_g221 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp226)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cK",
    d: "m195.2 131.3q-0.3-0.2-0.6-0.4-0.7-0.2-1.5-0.4c-3-0.9-6.1-1.5-9.2-2.1-3.1-0.7-6.2-1.3-9.3-1.7q-2.5-0.3-5-0.4-1.1-0.1-2.3-0.1c-0.7 0.1-1.7 0-2.1 0.6-0.1 0.9-0.3 1.7-0.6 2.5 0.7 0.6 1.6 1 2.5 1.3q1 0 2 0.1-0.6 0.1-1.2 0.1c2.1 0.4 4.4 0.5 6.1 0.8 5.3 0.9 10.6 1.7 14.2 6.2 0.3 0.4 1 1.3 0.6 1.9-0.4 0.6-1.3 0.9-2 1.2-2.5 1.1-5 2.1-7.6 2.7-7 1.8-14.4 1.7-21.5 2.5q-3.2 0.4-6.3 0.8c-1.2 0.2-2.4 0.5-3.5 0.1q-0.5-0.2-0.9-0.5 0.2 0.6 0.1 1.2c-0.1 0.3-0.2 0.4 0 0.6q0-0.1 0.1-0.1c2.1-0.4 4.2-0.5 6.3-0.5 2.2 0.1 4.5-0.1 6.7-0.2 4.4-0.1 8.9-0.7 13.3-1.1 4.4-0.5 8.8-1.4 13.1-2.8 1.9-0.7 4-1.5 5.4-3.2 1.1-1.3 1.8-2.9 2-4.7 0.1-0.6 0.1-1.3 0.2-1.9 0.1-0.5 0.4-0.9 0.6-1.3 0.2-0.3 0.8-0.9 0.4-1.2z"
  })))), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "cQ",
    d: "m159.7 193.5c-0.4-1-0.6-2.1-0.9-3.1-0.1-0.5-0.2-1.3-0.7-1.5-0.6-0.3-1.2 0.1-1.7 0.4-1 0.5-2.2 0.7-3.2 1-2.1 0.6-4.3 1-6.5 1.4q-1.5 0.2-3 0.4c0 0-0.4 0.1-0.7 0.2q0 0 0 0c-1.6 0.1-0.2 2.7 0 3.4 0.1 0.6 0.3 1.3 1 1.3 0.4 0 0.8-0.1 1.1-0.2 0.7-0.2 1.4-0.3 2.2-0.4 1.1-0.1 2.3-0.1 3.5-0.1 1.2-0.1 2.3-0.3 3.5-0.4 1.8-0.3 3.5-0.7 4.9-2q0.2 0 0.4-0.1c0.1-0.1 0.2-0.2 0.1-0.3z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "cN",
    d: "m154.7 195.5q-2.5 0.4-5.1 0.5c-1.5 0-3 0.1-4.4 0.5-0.6 0.1-1.3 0.4-1.7-0.2-0.2-0.4-0.3-0.9-0.4-1.3-0.1-0.6-0.9-2-0.3-2.5 0.4-0.2 1.4-0.1 1.9-0.2q1.4-0.2 2.8-0.5 2.6-0.4 5.1-1.1 1.2-0.3 2.4-0.6 0.6-0.2 1.1-0.4c0.6-0.2 1.1-0.9 1.8-0.5 0.6 0.3 0.7 1.6 0.8 2.2q0.3 1.1 0.6 2.2c-0.2 0.1-0.3 0.3-0.5 0.5-0.1 0.1-1 0.6-1.5 0.8-0.8 0.3-1.7 0.4-2.6 0.6z"
  })), _g222 || (_g222 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp227)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cN",
    d: "m143 194.5c-0.1-0.4-0.3-0.7-0.2-1.2 0-0.4 0.5-0.6 0.9-0.7 1.2-0.1 2.2 0 3.4-0.3q0.9-0.3 1.8-0.5c-1.3 0.2-2.5 0.3-3.8 0.4q-0.2 0-0.4 0.1c-0.5 0.1-1.5 0-1.9 0.2-0.6 0.5 0.2 1.9 0.3 2.5 0.1 0.4 0.2 0.8 0.3 1.1-0.1-0.5-0.2-1-0.4-1.6z"
  }))), _g223 || (_g223 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp228)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cN",
    d: "m158.7 191.4c-0.1-0.6-0.2-1.9-0.8-2.2-0.7-0.4-1.2 0.3-1.8 0.5q-0.5 0.2-1.1 0.4-1.2 0.3-2.4 0.6-0.9 0.3-1.7 0.5 0.6-0.1 1.2-0.2c1-0.1 1.9-0.5 2.8 0 0.5 0.2 0.8 1.4 0.9 1.9 0.1 0.4 0.4 1.3-0.1 1.6-1 0.5-2 0.6-3 0.6-1.7 0-3.2 0.5-4.8 1q0.8-0.1 1.7-0.1 2.6-0.1 5.1-0.5c0.9-0.2 1.8-0.3 2.6-0.6 0.5-0.2 1.4-0.7 1.5-0.8 0.2-0.2 0.3-0.4 0.5-0.5q-0.3-1.1-0.6-2.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, _g224 || (_g224 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp229)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m140.5 152.5c-2.5-0.7-4.8-1.6-7.1-2.7 1.6 0.6 3.1 1.3 4.7 1.7 0.2 0 0.4-0.3 0.2-0.4-1.6-0.5-3-1.3-4.4-2.3-0.7-0.6-2.6-2-3.1-3.1 1.9 1.1 3.5 2.6 5.4 3.7 0.1 0.1 0.4-0.3 0.3-0.4-1-0.8-2.1-1.4-3-2.3-0.5-0.5-1.8-1.9-2.2-2.9 0.9 0.7 1.5 1.7 2.4 2.3 0.1 0.1 0.4-0.2 0.3-0.3-0.5-1-1.5-2-1.9-3.1 0.4 0.4 0.7 1 1.2 1.2 0.2 0.1 0.3-0.2 0.3-0.3 0-0.6-0.4-1.1-0.7-1.6-0.6-1.1-0.3-0.6 0.8-0.4 0.2 0 0.4-0.4 0.2-0.4-0.5-0.1-1-0.4-1.6-0.4-0.1 0-0.2 0.2-0.2 0.3-0.1 0.8 0.6 1.4 1 2.1-0.4-0.4-0.7-1-1.3-1.1-0.1 0-0.3 0.2-0.3 0.3 0.1 0.6 0.4 1.1 0.7 1.6-0.3-0.3-0.6-0.6-1.1-0.8-0.1-0.1-0.3 0.1-0.3 0.2 0 0.9 1 1.9 1.5 2.5q0.2 0.2 0.3 0.4-0.9-0.7-1.9-1.2c-0.1-0.1-0.3 0.1-0.3 0.2-0.1 1.1 1.7 2.5 2.4 3.1q0.8 0.7 1.7 1.3c-1-0.4-2-0.8-3-1-0.2 0-0.4 0.3-0.3 0.3 2.2 1.4 4.4 2.3 6.8 3.1q-0.8-0.2-1.5-0.4c-1.5-0.4-3.9-1-4.9-2.2-0.1 0-0.2 0.1-0.1 0.2 0.8 1 2.4 1.4 3.5 1.9q2.6 1 5.4 1.3c0.1 0 0.3-0.3 0.1-0.4z"
  })))), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "cO",
    d: "m144.5 199.9c-0.4-0.8-1.6-1.4-2.6-1.6 0-0.1 0.1-0.1 0.1-0.2-0.1-0.2-0.2-0.5-0.5-0.5-0.3 0-0.6 0.3-0.7 0.6q-0.7 0-1.2 0.2-0.3 0.1-0.5 0.3-0.2 0.1-0.3 0.3-0.1 0.1-0.1 0.2-0.1 0.1-0.1 0.1c-0.9-0.2-1.8 0-2.3 1.1-0.9-0.4-1.7-0.3-2 1q0 0 0.1 0 0 0.1 0 0.1 0.4 0 0.7 0.1c-0.2 0.6-0.2 1.2-0.2 1.8 0 0.5-0.1 1.5 0.6 1.5 0.2 0.1 0.4-0.2 0.4-0.3 0.2-0.8 0.1-1.7 0.3-2.5q0.3 0.2 0.7 0.5c0.5 0.4 0.9 1.2 1.6 1.4 0.6 0.2 0.9-0.1 0.9-0.5 0-0.3-0.1-0.6-0.1-0.9 0-0.4-0.1-0.9-0.1-1.4q0.2 0.2 0.4 0.3c0.4 0.4 0.7 0.9 1.3 1.2 0.5 0.2 1.2-0.1 1.1-0.6 0.1-0.3 0.1-0.6 0-1 0-0.3-0.1-0.7-0.2-1.1 0.7 0.4 1.4 1 2.2 1.1 0.8 0.2 0.8-0.8 0.5-1.2z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m141.6 197.8c0.2 0.1 0.2 0.3 0.2 0.4q-0.3 0-0.6 0-0.1-0.1-0.4 0c0.2-0.3 0.6-0.5 0.8-0.4z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m136 202.1q-0.1 0.7-0.1 1.3c-0.1 0.2 0 1.6-0.5 1.3-0.4-0.2-0.3-1.5-0.3-1.8q0-0.7 0.1-1.3 0.5 0.2 0.9 0.4-0.1 0.1-0.1 0.1z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m138.2 203.6c-0.7-0.6-1.1-1.2-1.8-1.6-0.6-0.4-1.2-0.7-1.9-0.8q0 0 0 0.1c0.7-1.9 2.4-0.4 3.2 0.4q0.4 0.4 0.8 0.8 0.3 0.3 0.5 0.7c0.3 0.5-0.5 0.6-0.8 0.4z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m138.2 201.4q0 0.1-0.1 0.3c-0.3-0.4-0.8-0.8-1.2-1q0.7-0.1 1.3 0.1-0.1 0.3 0 0.6z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m139.1 202.9c-0.1-0.3-0.4-0.7-0.8-1.1q0 0 0-0.1c0-0.1 0-0.3 0-0.4 0-0.1 0-0.3 0-0.5q0.4 0.1 0.9 0.4c-0.2 0.5-0.1 1.1-0.1 1.7z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m140.8 202.4c-0.7-0.4-1.1-1.2-1.8-1.6-0.7-0.5-1.4-0.5-2.2-0.3q0 0-0.1 0.1-0.1-0.1-0.3-0.2 0 0 0-0.1 0.5-0.5 1.1-0.8 0.4-0.1 0.8 0c0.6 0.1 1.1 0.4 1.6 0.7 0.3 0.2 0.6 0.4 0.9 0.7q0.2 0.2 0.4 0.4c0.1 0.1 0.4 0.4 0.5 0.6 0 0.8-0.4 0.9-0.9 0.5z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m140.7 200.4q-0.6-0.5-1.3-0.8c0.5-0.1 0.9-0.1 1.3 0q0 0.3 0 0.6 0 0.1 0 0.2z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m141.8 201.1c0 0.1 0.1 0.4 0.1 0.7q0 0 0 0c-0.2-0.4-0.5-0.8-1-1.2 0-0.2 0-0.3 0-0.5q-0.1-0.3-0.1-0.5 0.4 0.1 0.8 0.3c0 0.4 0.1 0.8 0.2 1.2z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m144 200.9c-0.6-0.1-1.1-0.5-1.5-0.8q-0.4-0.2-0.8-0.4c0 0 0 0-0.1 0q-0.1 0-0.2-0.1c-0.7-0.3-1.3-0.5-2.1-0.1q0 0 0 0-0.3-0.1-0.6-0.2 0 0 0 0c0.1-0.2 0.3-0.4 0.5-0.5q0.1-0.1 0.2-0.2c0.5-0.1 1-0.2 1.2-0.2 0.6-0.1 1.1 0 1.7 0.2 0.5 0.2 0.9 0.5 1.4 0.7q0.2 0.2 0.4 0.4 0.1 0.1 0.3 0.3c0.2 0.3 0.2 1.1-0.4 0.9z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m175.2 74q0 0-0.1 0 0 0 0 0c0-0.1-1.4-4.1-2.3-5.8q-0.4-0.9-1.7-0.9c-1 0-2 0.4-2 0.4q-0.1 0-0.2-0.1-0.1 0 0-0.1l8.1-12.5q0 0 0.1 0 0 0 0.1 0c0 0 1.1 1.3 2.2 3q2.2 3.5 2.1 5.8c-0.3 3.5 0.9 7.2 0.9 7.2 0 0.1 0 0.2-0.1 0.2l-7 2.8q-0.1 0-0.1 0z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m171.1 67q1.5 0 2 1c0.8 1.6 1.9 5 2.2 5.7l6.8-2.7c-0.2-0.7-1.2-4-0.9-7.2 0.2-3.2-3.4-7.6-4.1-8.5l-7.8 12c0.5-0.1 1.1-0.3 1.8-0.3z"
  })), _g225 || (_g225 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp230)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m171.6 67c1.1-0.3 2.1-1.1 3-1.7 0.3-0.2 0.7-0.5 1.1-0.4 0.4 0.2 0.6 0.7 0.8 1 0.5 1.1 0.6 2.2 1 3.3 0.4 1.1 0.8 2.1 1.2 3.1l3.4-1.3c-0.2-0.7-1.2-4-0.9-7.2 0.2-3.2-3.4-7.6-4.1-8.5l-7.8 12c0.5-0.1 1.1-0.3 1.8-0.3q0.3 0 0.5 0z"
  }))), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "cR",
    d: "m178.7 50.7c-0.3-1.5-1.6-2.1-3-1.5q-0.5 0.2-0.8 0.7-0.1 0-0.1 0 0 0.1 0 0.1-0.1 0.2-0.2 0.4-0.1 0.3-0.2 0.6c-1.1-2-2.8-3.7-4.4-5.2-1.8-1.8-3.8-3.3-6.1-4.5-2.1-1-4.6-2-7-1.4-1 0.3-1.6 1.1-1.8 2q0-0.1 0-0.2c0 0-0.1 0-0.1 0.1-0.5 2-0.5 4 0 6 0.3 1 0.7 2 1.2 2.9 0.5 1.1 1.4 2.4 0.8 3.6-0.4 0.9-0.5 1.9-0.6 2.8-0.2 1.1-0.8 2.1-0.9 3.2 0 0.6 0.5 1 1 1 1.1 0.1 2.1-0.1 3.1 0.1 0.3 0.4 0.3 0.9 0.3 1.3l0.1 1.1c0.3 0.2 0.6 0.1 1 0.1q0.1 0.1 0.2 0.1c0 0.4-0.1 0.8 0.3 1.1 0.2 0.2 0.4 0.2 0.7 0.3 0.6 0.1 0.7 0.6 1 1.1 0.6 1.2 1.2 2.8 2.8 2.8 1.6 0 2.9-1 4.3-1.7q0.3-0.2 0.6-0.4 0.2-0.1 0.5-0.2c0.7-0.6 0.9-0.9 1.4-1.3 0.6-0.7 1.1-1.4 1.5-2.1 1.1-1.6 1.9-3.8 1.9-5.9 0.8-0.1 1.3-1 1.8-1.9 1-1.5 1.1-3.4 0.7-5.1z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m178.5 51.2c-0.2-1.3-1.2-2.4-2.6-1.8-0.7 0.2-1 0.8-1.3 1.4q0 0.2-0.1 0.5 0.1 0 0.1 0 0 0-0.1 0.1-0.3 1.6 0.1 3.3c0 0-0.1 0-0.1 0-0.6-1-0.6-2.2-0.2-3.4-1-1.8-2.5-3.5-4-4.8-1.4-1.4-2.9-2.8-4.6-3.8-1.9-1.2-4.1-2.4-6.3-2.7-1.5-0.2-3.7-0.1-4.2 1.7-0.2 1.1-0.3 2-0.4 3.1q0.1 1.9 0.8 3.7c0.3 1 0.7 2 1.1 2.9q0.2 0.3 0.3 0.7c0.3 0.3 0.5 0.6 0.5 0.9q0.1 0.4 0 0.7c-0.1 0.2-0.1 0.4-0.2 0.6q-0.3 0.8-0.5 1.7c-0.2 0.9-0.3 1.8-0.6 2.6-0.1 0.5-0.8 1.8-0.2 2.2 0.5 0.3 1 0.2 1.6 0.2 0.7 0 1.4 0 2.2 0.3q0 0 0 0.1c0.5 0.4 0.3 1.1 0.4 1.7 0 0.7 0.6 0.5 1.1 0.6q0 0 0 0c0.3-0.1 0.5-0.1 0.7-0.3q0.2-0.2 0.4-0.3c0.6-0.3 1.6-0.4 1.7-0.5 0 0 0.6-0.3 0.5-0.2-0.5 0.5-1.4 0.7-1.9 0.9-0.3 0.1-1 0.8-1.2 0.7 0.1 0.6 0.2 1 0.9 1.1 0.1 0 0.3 0 0.4 0.2 0.5 0.6 0.8 1.4 1.1 2.1 0.6 1 1.2 1.6 2.4 1.5 1-0.1 1.8-0.4 2.6-0.9 0.8-0.5 1.6-0.8 2.4-1.3q0.3-0.2 0.5-0.3c0.4-0.4 0.7-0.8 1-1.1 0.6-0.7 1.1-1.4 1.6-2.3 0.8-1.6 1.5-3.4 1.6-5.2q-0.4 0-0.9-0.2c-0.1-0.1 1.5 0.4 2.4-1.3 0.3-0.5 0.6-1 0.8-1.5 0.4-1.1 0.5-2.5 0.2-3.6z"
  })), _g226 || (_g226 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp231)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m178.5 51.2c-0.2-1.3-1.2-2.4-2.6-1.8-0.7 0.2-1 0.8-1.3 1.4q0 0.2-0.1 0.5 0.1 0 0.1 0 0 0-0.1 0.1-0.3 1.6 0.1 3.3c0 0-0.1 0-0.1 0-0.6-1-0.6-2.2-0.2-3.4-1-1.8-2.5-3.5-4-4.8-1.4-1.4-2.9-2.8-4.6-3.8-1.9-1.2-4.1-2.4-6.3-2.7-1.5-0.2-3.7-0.1-4.2 1.7-0.2 1.1-0.3 2-0.4 3.1q0.1 1.9 0.8 3.7 0.1 0.5 0.3 1v-0.1c0-0.8 0-1.6 0.2-2.4 0.1-0.1 0.2-0.2 0.3-0.1 1.7 1.8 3.5 3.4 5.8 4.4-0.5-0.8-0.8-1.7-1.2-2.5 0-0.1 0.1-0.3 0.2-0.2 2.2 1.1 5.1 1.7 6.6 3.8 1.5 2.1 1.7 5.3 1.7 7.8-0.1 2.6-0.8 5.3-2.9 7.1-0.4 0.4-1 0.9-1.7 1.3 0.3 0.2 0.8 0.4 1.4 0.3 1-0.1 1.8-0.4 2.6-0.9 0.8-0.5 1.6-0.8 2.4-1.3q0.3-0.2 0.5-0.3c0.4-0.4 0.7-0.8 1-1.1 0.6-0.7 1.1-1.4 1.6-2.3 0.8-1.6 1.5-3.4 1.6-5.2q-0.4 0-0.9-0.2c-0.1-0.1 1.5 0.4 2.4-1.3 0.3-0.5 0.6-1 0.8-1.5 0.4-1.1 0.5-2.5 0.2-3.6z"
  }))), _g227 || (_g227 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp232)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m164 64.9q0.6-0.6 1.1-1.2c-0.8 0.4-1.5 0.7-2.3 1q-0.5 0.2-1 0.2 0.2 0.2 0.6 0.2c0.1 0 0.3 0 0.4 0.2q0.2 0.2 0.3 0.5 0.1-0.1 0.1-0.1 0.4-0.4 0.8-0.8z"
  }))), _g228 || (_g228 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp233)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m162.4 63.1c0.6-0.3 1.6-0.4 1.7-0.5q0 0 0.2-0.1-0.1 0-0.1-0.1c-1.2 0.2-3.1 1.7-4 0.5q0 0.1 0 0.2c0 0.7 0.6 0.5 1.1 0.6q0 0 0 0c0.3-0.1 0.5-0.1 0.7-0.3q0.2-0.2 0.4-0.3z"
  }))), _g229 || (_g229 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp234)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m159.8 61.4q0.1 0 0.2 0.1 0 0 0 0c0.4-0.5 1.1-1 1.4-1.6-0.8 0.2-1.5 0.4-2.3 0.5-0.8 0.2-1.7 0.4-2.5 0.1-0.8-0.3-0.5-1.4-0.3-2q0.5-1.7 0.7-3.5-0.1 0.5-0.2 1c-0.2 0.9-0.3 1.8-0.6 2.6-0.1 0.5-0.8 1.8-0.2 2.2 0.5 0.3 1 0.2 1.6 0.2 0.7 0 1.4 0 2.2 0.3q0 0 0 0.1z"
  }))), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "cS",
    d: "m174.7 45.6q0 0-0.1 0c0-0.1 0.1-0.1 0-0.1q-0.2 0-0.3 0c-1.1-0.2-2-0.6-2.9-1.3-1-0.8-1.4-1.9-1.8-3 0 0-0.1 0 0 0.1 0.3 1.2 0.6 2.2 1.6 3.1 0.5 0.6 1.3 1 2 1.2q-0.4 0-0.8 0c-0.7-0.1-1.8-0.5-2.2-1.1 0-0.1-0.1 0-0.1 0.1 0.4 0.7 1.4 1.1 2.1 1.2 0.5 0.2 1.4 0.2 2 0q0.2 0 0.4 0c0.1 0 0.2-0.2 0.1-0.2z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "cT",
    d: "m195.5 43.7c-0.2-2.8-0.9-5.5-2.1-8-1-2.2-2.4-4.4-4.2-6-0.9-0.8-1.9-1.5-3-2.1q-0.9-0.4-1.8-0.7c-2.1-1.6-5.1-2.2-7.6-2.4-3.6-0.2-7.1 0.5-10.5 1.6-3.2 1.1-6 2.6-8.5 4.9-1.1 0.9-2.1 2.1-2.8 3.4q-0.5 0.9-0.8 2c-1.6 1.4-2.9 3-3.6 5-0.5 1.4-0.6 2.9-0.1 4.3 0.5 1.4 1.5 2.4 2.9 3 0.5 0.9 1.4 1.6 2.5 1.9q0 0 0 0 0.1 0 0.2 0c0-0.1 0.1-0.1 0.1-0.2-0.1-0.4-0.3-0.8-0.5-1.1-0.3-0.8-0.5-1.6-0.5-2.4-0.2-1.3 0-2.5 0.5-3.7q0 0.1 0 0.1c0 0.9 0.3 1.8 0.7 2.7 0.4 1.1 1.6 1.9 2.8 2.3q0.5 0.1 1 0.1 0.2 0 0.4 0c-2.2-1-3-3.7-2.8-6q0.1 0.7 0.4 1.4c0.4 1 1.1 2 1.8 2.7 1.4 1.5 3.7 2.6 5.8 2.4 1.8 0.8 3.5 0.9 5.2 0.3 0.3 0.9 0.7 1.8 1.1 2.7 0.5 1.1 1.3 2.7 2.4 3.3 0.1 0 0.2-0.1 0.2-0.2 0-0.4-0.2-0.8-0.3-1.2-0.2-0.7-0.2-1.5-0.1-2.3 0.2-1.4 1.2-2.7 2.7-2.3 2.2 0.7 2 4.1 1.5 5.7-0.4 1.6-2.2 2.3-2.6 3.9-0.2 0.7-0.3 1.3-0.5 2q0 0.1 0 0.3 0.2 0 0.4-0.1 0.7-0.7 1.3-1.5c-0.2 0.6-0.5 1.2-0.3 1.7 0 0.1 0.1 0 0.2 0 0.5-0.5 0.8-1.2 1.1-1.8 0 1 0.4 2 0.6 2.9 0.2 0.8 0.5 1.7 0.9 2.5q0.1 0.3 0.3 0.5 0.2 0.2 0.4 0.3 0 0 0-0.1c0.2-0.4 0.1-1.1 0.1-1.7 0.1-0.2 0-0.6 0-0.9q0.1 0.9 0.2 1.9c0.1 0.8 0.2 1.9 0.7 2.6q0.2-0.4 0.4-0.8c0.2-0.7 0.3-1.5 0.8-2.1 0.5-0.9 1.3-1.6 2.1-2.2 0.9-0.6 1.8-1.3 2.5-2.1-0.1 0.1 0 0.2 0.1 0.2 1-0.3 1.8-1.2 2.6-1.9q0 0 0.1-0.1c2.3-1.7 4.4-4.4 4.4-7.4q0.1 0.4 0.2 0.8 0 0 0 0 0.1-0.3 0.3-0.5c0.2-1.2 0.6-2.4 0.7-3.6 0.1-1.3 0-2.7 0-4z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "cU",
    d: "m195.1 47.8c0 1.1-0.3 2.2-0.5 3.2q-0.2-0.6-0.4-1.1 0 0.5-0.2 1c0.1 1.3-0.3 2.5-1 3.7-0.6 1.2-1.5 2.1-2.4 3 0.4-0.7 0.7-1.5 0.9-2.2q-0.2 0.3-0.3 0.7c-0.4 0.8-1 1.6-1.6 2.2-0.6 0.5-1.3 1.3-2.1 1.6 0.2-0.5 0.5-1.1 0.7-1.6q-0.2 0.2-0.3 0.4-0.1 0.2-0.2 0.4-0.5 0.6-1.1 1.2-0.7 0.6-1.5 1.2c-0.7 0.5-1.4 1.1-2 1.7-1.1 1-1.4 2.3-1.7 3.7-0.3-0.7-0.4-1.6-0.5-2.3q-0.1-0.7-0.1-1.5-0.2-0.7-0.5-1.2c-0.2 0.4-0.1 1-0.1 1.4q-0.1 0.6-0.1 1.3c0 0.1 0 0.2 0 0.4-0.3-0.7-0.6-1.5-0.9-2.3-0.2-0.7-0.5-1.6-0.7-2.4q0-0.3-0.1-0.5c-0.1-0.4-0.1-0.9-0.1-1.3q-0.1 0-0.1 0.1c-0.3 0.6-0.7 1.6-1.2 2.2 0-0.7 0.5-1.6 0.6-2.3 0.1-0.2-0.2 0-0.2 0.1-0.4 0.6-0.9 1.2-1.4 1.8 0 0-0.2 0.2-0.4 0.4q0 0 0.1-0.1c0.2-0.5 0.2-1.1 0.3-1.6 0.2-1 0.7-1.6 1.4-2.2 1.4-1.6 1.7-3.4 1.5-5.4-0.3-1.7-1.9-3.3-3.6-2.2-0.6 0.4-0.9 1.3-1.1 2-0.1 0.4-0.2 0.9-0.2 1.3 0 0.5 0 1.5 0.4 1.9q0 0 0 0.1 0 0 0 0 0 0 0 0.1 0 0.1 0.1 0.2c-0.9-0.7-1.5-2.1-2-3-0.5-0.8-1-1.8-1.3-2.8q0.6-0.2 1.1-0.5 0.1-0.1 0.2-0.2-0.7 0.4-1.5 0.5 0 0 0 0c-1.8 0.5-3.6 0.4-5.4-0.6-0.9-0.5-1.6-1.2-2.3-1.9q-0.3-0.4-0.5-0.8-0.4-0.5-0.7-1c0.5 1.8 1.6 3.2 3.3 4.1-1.8-0.2-3.5-1-4.9-2.3-0.7-0.7-1.3-1.5-1.8-2.4q-0.3-0.6-0.5-1.2-0.3-0.7-0.5-1.4 0 0.2 0 0.5c-0.3 1.3-0.3 2.7 0.2 4 0.3 0.8 0.8 1.6 1.4 2.2-1-0.5-1.9-1.1-2.5-2.1-0.4-0.7-0.6-1.5-0.8-2.2q0-0.4 0-0.7-0.1-0.3-0.1-0.7 0 0.2-0.1 0.3-0.1 0.1-0.1 0.2c-0.5 0.9-0.9 1.9-0.9 3 0 0.7 0 1.4 0.2 2.1 0.1 0.4 0.2 0.8 0.3 1.2 0.1 0.1 0.6 0.9 0.6 1.2-0.9-0.3-1.6-0.9-2.1-1.6q0 0 0-0.1-0.1-0.1-0.2-0.2-0.6-1-0.8-2.2-0.4-2.2 0.6-3.9 0.2-0.6 0.6-1.1c-1.2 1.1-1.6 2.5-1.6 4.2 0 0.9 0.2 1.8 0.6 2.6-0.8-0.5-1.4-1.1-1.9-2-0.9-1.5-0.7-3.2-0.2-4.7 0.5-1.7 1.6-3.1 2.8-4.3q0.4-0.6 0.9-1.1 0 0.1-0.1 0.1 0.3-0.9 0.7-1.7c0.8-1.4 1.9-2.6 3.1-3.6 2.6-2.3 5.4-3.6 8.6-4.6 5.2-1.7 11.7-2.2 16.6 0.5q-0.8-0.2-1.6-0.4c0 0 0 0.1 0 0.1 0.8 0.3 1.5 0.5 2.3 0.7q0.7 0.4 1.3 1c0 0 0.1-0.1 0-0.1q-0.3-0.3-0.6-0.6 0.3 0.1 0.6 0.2c1.2 0.5 2.3 1.3 3.3 2.2 1.9 1.7 3.2 3.9 4.3 6.1 1.2 2.4 1.8 5 2 7.6q0.2 2.2 0 4.3z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _g230 || (_g230 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp235)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cU",
    d: "m180.1 64.9q0-0.2 0-0.3 0-0.7 0.1-1.3c0-0.4-0.1-1 0.1-1.4q0 0 0 0-0.1-0.7-0.3-1.4c-0.5 0.7-0.7 1.5-0.7 2.4 0.2 0.7 0.5 1.4 0.8 2.1q0 0 0-0.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _g231 || (_g231 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp236)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cU",
    d: "m195.1 43.5c-0.2-2.6-0.8-5.2-2-7.6-1.1-2.2-2.4-4.4-4.3-6.1-1-0.9-2.1-1.7-3.3-2.2q-0.3-0.1-0.6-0.2 0.3 0.3 0.6 0.6c0.1 0 0 0.1 0 0.1q-0.6-0.6-1.3-1c-0.8-0.2-1.5-0.4-2.3-0.7 0 0 0-0.1 0-0.1q0.8 0.2 1.6 0.4c-4.9-2.7-11.4-2.2-16.6-0.5q-0.6 0.2-1.2 0.4c1.2-0.1 2.4 0 3.4 0 0.3 0 0.3 0.4 0.1 0.5-2.3 0.7-5.2 1.4-6.5 3.6 1.9-0.9 3.4-1.9 5.5-2 2.1-0.1 4.3 0.2 6.2 1.1 3.2 1.5 6.9 4.8 6.4 8.7 0 0.2-0.3 0.3-0.4 0.2-2-1.9-3.9-3.9-6.5-4.8-1.6-0.6-3.3-0.9-5-0.8q-0.4 0-0.9-0.1c2.1 0.8 4 2.1 5.4 3.9 1.4 2 3.4 5 2.4 7.5-0.8 2.4-2.9 2.8-5.1 2.2-2.2-0.6-3.7-1.8-5.1-3.3 0.8 1.6 1.9 3.1 3.3 4.3 0.2 0.1 0 0.4-0.2 0.4-4.2-1-7.4-4.6-7.5-8.8-1.1 1.7-0.4 4.2 0.4 6 0.1 0.3-0.3 0.4-0.5 0.3-1.6-1.4-3-3.6-3-5.8q0-0.5 0-1.1c-2.2 1.9-3.3 4.1-4.3 6.8 0 0.3-0.4 0.2-0.4 0-0.2-1.4 0-2.6 0.4-3.8q-0.2 0.4-0.4 0.8-1 1.7-0.6 3.9 0.2 1.2 0.8 2.2 0 0 0 0 0.1 0.1 0.2 0.2 0 0.1 0 0.1c0.5 0.7 1.2 1.3 2.1 1.6 0-0.3-0.5-1.1-0.6-1.2-0.1-0.4-0.2-0.8-0.3-1.2-0.2-0.7-0.2-1.4-0.2-2.1 0-1.1 0.4-2.1 0.9-3q0-0.1 0.1-0.2 0.1-0.1 0.1-0.3 0 0.4 0.1 0.7 0 0.3 0 0.7c0.2 0.7 0.4 1.5 0.8 2.2 0.6 1 1.5 1.6 2.5 2.1-0.6-0.6-1.1-1.4-1.4-2.2-0.5-1.3-0.5-2.7-0.2-4q0-0.3 0-0.5 0.2 0.7 0.5 1.4 0.2 0.6 0.5 1.2c0.5 0.9 1.1 1.7 1.8 2.4 1.4 1.3 3.1 2.1 4.9 2.3-1.7-0.9-2.8-2.3-3.3-4.1q0.3 0.5 0.7 1 0.2 0.4 0.5 0.8c0.7 0.7 1.4 1.4 2.3 1.9 1.8 1 3.6 1.1 5.4 0.6q0 0 0 0 0.8-0.1 1.5-0.5-0.1 0.1-0.2 0.2-0.5 0.3-1.1 0.5c0.3 1 0.8 2 1.3 2.8 0.5 0.9 1.1 2.3 2 3q-0.1-0.1-0.1-0.2 0-0.1 0-0.1 0 0 0 0 0-0.1 0-0.1c-0.4-0.4-0.4-1.4-0.4-1.9 0-0.4 0.1-0.9 0.2-1.3 0.2-0.7 0.5-1.6 1.1-2 1-0.6 2-0.4 2.6 0.3 0.5-0.1 1 0.2 1.3 0.5 1.7 2.1 1.4 5 0.6 7.5 1-1 1.5-2.2 1.6-3.6 0-0.2 0.4-0.3 0.5 0q0 0 0 0c0.2 1.6 0 3.1-0.5 4.5 0.7-0.8 1.2-1.9 1.2-3 0-0.3 0.3-0.4 0.5-0.1 0.5 0.8 0.9 1.8 0.7 2.8-0.2 1.1-0.7 2-1.2 2.9-0.7 1.6-1.2 3.4-1 5 0.2-1.1 0.6-2.1 1.5-2.9 0.6-0.6 1.3-1.1 2-1.7q0.8-0.6 1.5-1.2 0.6-0.6 1.1-1.2 0.1-0.2 0.2-0.4 0.1-0.2 0.3-0.4c-0.2 0.5-0.5 1.1-0.7 1.6 0.8-0.3 1.5-1.1 2.1-1.6 0.6-0.6 1.2-1.4 1.6-2.2q0.1-0.4 0.3-0.7c-0.2 0.7-0.5 1.5-0.9 2.2 0.9-0.9 1.8-1.8 2.4-3 0.7-1.2 1.1-2.4 1-3.7q0.2-0.5 0.2-1 0.2 0.5 0.4 1.1c0.2-1 0.5-2.1 0.5-3.2q0.2-2.1 0-4.3z"
  })))), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "cV",
    d: "m172.7 61.8q-0.1-0.1-0.1-0.1 0 0 0-0.1l0.5-3q0-0.1 0.1-0.1 0 0 0.2 0c0.5 0 2-0.1 3.6-1.1 2-1.2 3.6-3.3 4.7-6.3q0-0.1 0.1-0.1 0 0 0.1 0l3.1 2.8q0.1 0.1 0.1 0.2c-0.1 0-3.1 7.3-12.4 7.8z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "cC",
    d: "m173.3 58.8l-0.4 2.7c4.7-0.3 7.6-2.3 9.3-4 1.6-1.6 2.4-3.2 2.6-3.5l-2.9-2.6c-1.1 2.9-2.7 5-4.8 6.3-1.8 1-3.3 1.1-3.8 1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _g232 || (_g232 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp237)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cW",
    d: "m182.9 52.3c-0.2 0.7-0.6 1.5-0.7 1.7-0.8 1.5-2 3-3.3 4-1.3 0.9-2.7 1.3-4.1 1.7-0.6 0.2-1.1 0.3-1.7 0.3l-0.2 1.5c4.7-0.3 7.6-2.3 9.3-4 1.6-1.6 2.4-3.2 2.6-3.6z"
  })))), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "cV",
    d: "m166.3 69.3q-0.1 0-0.2-0.1 0-0.1 0.1-0.2c2.8-1.3 5.9-4.7 4.8-13.3-0.7-5.1-2.6-9.7-2.6-9.7q0-0.1 0-0.2 0.1 0 0.1 0l3.6 0.2q0.1 0 0.2 0.1c0.9 2.5 1.8 8.6 1.8 8.7 1.3 11.4-2.6 12.5-2.8 12.6-2.6 1.1-5 1.8-5 1.9q0 0 0 0z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "cC",
    d: "m168.7 46c0.4 1 2 5.1 2.5 9.7 0.8 6.2-0.4 10.6-3.7 12.8 1-0.3 2.3-0.8 3.7-1.4 0.1 0 3.9-1.2 2.7-12.3 0 0-0.9-6-1.9-8.5z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _g233 || (_g233 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp238)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cW",
    d: "m173.9 54.8c0 0-0.9-6-1.9-8.5l-2.2-0.2c3.4 6.3 5 16.1 0.2 21.5q0.6-0.2 1.2-0.5c0.1 0 3.9-1.2 2.7-12.3z"
  })))), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "cX",
    d: "m189.7 59.2c-1.9 0-3.9-2.2-6-4.6-1.1-1.1-2.2-2.3-3.4-3.4-3.2-2.9-9.2-3.1-10.9-3.1q-0.6 0-0.6 0-0.1 0-0.2-0.1l-0.9-1.4-15.8-8.3q-0.1 0-0.1-0.1c0-0.1-1.4-6.4 7-12.7 3.7-2.8 9.8-4.5 16-4.4 9.5 0 17.2 4 21.1 10.9 3.3 5.8 4.3 11.3 2.9 16.4-1.7 6-6.3 9.6-7.9 10.5q-0.6 0.3-1.2 0.3z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "cW",
    d: "m169.4 47.8c1.7 0 7.8 0.3 11.1 3.2 1.2 1.1 2.3 2.3 3.4 3.5 2.1 2.2 4 4.4 5.8 4.4q0.6 0 1.1-0.3c1.6-0.8 6-4.4 7.7-10.3 1.4-5 0.5-10.5-2.8-16.2-3.9-6.7-11.5-10.7-20.9-10.8-6.1 0-12.2 1.7-15.9 4.4-4.2 3.3-5.9 6.5-6.5 8.6-0.6 2-0.4 3.5-0.3 3.8l15.7 8.3q0.1 0 0.1 0l0.9 1.4q0.2 0 0.6 0z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "cj",
    d: "m159.5 31.8c3.5-4.6 9.1-6.8 14.8-7.1 5.3-0.3 10.8 0.8 15.1 4 5.6 4.1 8.7 10.5 9.6 17.2 0.6-4.3-0.5-9-3.3-13.8-3.9-6.7-11.5-10.7-20.9-10.8-6.1 0-12.2 1.7-15.9 4.4-4.2 3.3-5.9 6.5-6.5 8.6-0.6 2-0.4 3.5-0.3 3.8l3.9 2c0.2-3 1.6-5.9 3.5-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _g234 || (_g234 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp239)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cW",
    d: "m195.7 32.1c-2.7-4.6-7-7.9-12.6-9.5 0.8 0.6 1.9 2.3 1.2 4-5.1 12.1-7.9 14.8-9.4 14.5-1.7-0.3-3.5-0.4-5.2-0.9-1.5-0.4-2.8-1-4.2-1.7-2.6-1.5-5.3-3.2-8.4-3.2-1.7 0.1-3.7 0.4-5.1 1.4 0 0.7 0.1 1.2 0.1 1.4l15.7 8.3q0.1 0 0.1 0l0.9 1.4q0.2 0 0.6 0c1.7 0 7.8 0.3 11.1 3.2 1.2 1.1 2.3 2.3 3.4 3.5 2.1 2.2 4 4.4 5.8 4.4q0.6 0 1.1-0.3c1.6-0.8 6-4.4 7.7-10.3 1.4-5 0.5-10.5-2.8-16.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _g235 || (_g235 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp240)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cW",
    d: "m195.7 32.1q-1.3-2.2-3.1-4 0.7 1.1 1.1 2.2c2.1 5 1.3 11-1 15.8-0.8 1.8-2 3.8-3.8 4.7-2 1-3.9 0.3-5.7-0.9-1.5-1-3-2.3-4.7-3-0.7-0.3-3.1-1.5-3-2.4 0.5-3-1.8-3.2-2.8-3.3-1.5-0.2-2.9 0.3-4.4-0.3-3.1-1.1-5.9-2.7-9.2-3.3-2.3-0.4-4.8-0.6-7.1 0q0.1 0.3 0.1 0.5l15.7 8.3q0.1 0 0.1 0l0.9 1.4q0.2 0 0.6 0c1.7 0 7.8 0.3 11.1 3.2 1.2 1.1 2.3 2.3 3.4 3.5 2.1 2.2 4 4.4 5.8 4.4q0.6 0 1.1-0.3c1.6-0.8 6-4.4 7.7-10.3 1.4-5 0.5-10.5-2.8-16.2z"
  })))), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "cY",
    d: "m165.3 48.6c-2.6-0.1-4.6-0.9-4.6-0.9-2.5-1.1-4.8-1.7-7.4-1.7-1.1 0-2.1 0.1-2.9 0.2q-0.8 0.1-1.4 0.1c-0.4 0-0.7-0.1-0.9-0.3q-0.3-0.3-0.2-0.8c0.1-2.4 3.8-6.9 4-7.1q0-0.1 0-0.1 1.4-0.5 3.2-0.5c3.6 0.1 7.9 1.7 11.4 3 2.4 0.9 4.5 1.7 5.6 1.7h0.1q0 0 0.1 0 1.9 0 2.5 0.8c0.4 0.6 0.1 1.3 0.1 1.3-0.7 2-2.9 2.9-6.8 3.9q-1.3 0.4-2.8 0.4z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "cW",
    d: "m153.4 45.7c2.5 0.1 4.9 0.6 7.4 1.7 0 0 2 0.9 4.5 0.9q1.4 0 2.7-0.3c3.8-1 6-1.9 6.6-3.8 0.1 0 0.3-0.6 0-1-0.4-0.5-1.1-0.8-2.3-0.8q0 0-0.1 0h-0.1c-1.2 0-3.3-0.8-5.7-1.7-3.4-1.3-7.7-2.9-11.3-2.9q-1.7 0-3.1 0.5c-0.3 0.4-3.8 4.7-3.9 7q0 0.3 0.2 0.5 0.2 0.2 0.7 0.2 0.6 0 1.4-0.1c0.8-0.1 1.8-0.2 3-0.2z"
  })), _g236 || (_g236 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp241)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cW",
    d: "m150.6 45.9c0.9-2.9 2.4-5.6 4.1-8.1q-1.5 0.1-2.7 0.5c-0.3 0.4-3.8 4.7-3.9 7q0 0.3 0.2 0.5 0.2 0.2 0.7 0.2 0.6 0 1.4-0.1 0.1 0 0.2 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _g237 || (_g237 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp242)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cW",
    d: "m174.6 43.2c-0.4-0.5-1.1-0.8-2.3-0.8q0 0-0.1 0h-0.1c-1.2 0-3.3-0.8-5.7-1.7-3.4-1.3-7.7-2.9-11.3-2.9q-1 0-1.8 0.2 1.6-0.1 3.2 0.1c1.6 0.2 3.2 0.4 4.7 1 2.3 0.9 3.4 3.3 2 5.5-0.8 1.2-2.1 1.2-3.3 1.1-2.1-0.3-3.9-1.3-6.1-1.2-1.9 0.1-3.7 0.6-5.6 1q0 0.2 0.1 0.3 0.2 0.2 0.7 0.2 0.6 0 1.4-0.1c0.8-0.1 1.8-0.2 3-0.2 2.5 0.1 4.9 0.6 7.4 1.7 0 0 2 0.9 4.5 0.9q1.4 0 2.7-0.3c3.8-1 6-1.9 6.6-3.8 0.1 0 0.3-0.6 0-1z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _g238 || (_g238 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp243)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cW",
    d: "m174.6 43.2c-0.4-0.5-1.1-0.8-2.3-0.8q0 0-0.1 0h-0.1c-0.9 0-2.2-0.4-3.8-1 0.5 1.3-0.1 2.9-0.8 4.2-1 1.5-2.8 2.3-4.7 2.4 0.7 0.2 1.6 0.3 2.5 0.3q1.4 0 2.7-0.3c3.8-1 6-1.9 6.6-3.8 0.1 0 0.3-0.6 0-1z"
  })))), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "cV",
    d: "m171.6 67.3c0 0-0.7-0.4-2.6 0.3-2 0.6-3.5 1.7-2.9 1.8 0.7 0.2 3.7-0.6 5.5-2.1z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "cC",
    d: "m171.1 67.5c0 0-0.5-0.3-2.1 0.2-1.5 0.5-2.8 1.4-2.2 1.5 0.5 0.1 2.9-0.5 4.3-1.7z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m177.7 52.7q0 0-0.1 0c0 0 0 0.1 0 0.1 0 0.1-0.1 0.1-0.1 0.2-0.1 0.3-0.2 0.6-0.3 0.8-0.1 0.3-0.4 0.5-0.5 0.6-0.1 0.1-0.3 0.2-0.4 0.2q-0.1-0.6-0.1-1.4c0.1-0.7 0.7-2.7 1.5-1.4 0 0 0.1 0 0.1-0.1-0.3-0.9-0.9-1-1.3-0.1-0.8 1.4-0.8 3.2 0 4.6 0 0.1 0.1 0 0.1-0.1q-0.1-0.6-0.2-1.2c0.3 0 0.6-0.5 0.8-0.6 0.3-0.5 0.5-1 0.5-1.6q0.1 0 0 0z"
  })), _g239 || (_g239 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp244)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cW",
    d: "m152.6 35.2c0 0 2.8-12 19.8-13.3 0 0-13.9 2.4-16.6 12.6z"
  }))), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "cZ",
    d: "m162.6 50.6c-0.8-0.2-1.5-0.4-2.4-0.3-0.4 0-1 0-1.4 0.3q0 0-0.1 0c0-0.2-0.3 0-0.3 0.1q0 0 0 0 0-0.1-0.1-0.1c0-0.1-0.2 0-0.3 0.1q0 0-0.1 0.1 0-0.1-0.1-0.1c-0.1 0-0.3 0.2-0.3 0.3q0 0.1 0 0.1 0 0 0-0.1 0 0 0-0.1 0 0-0.1-0.1c-0.1-0.1-0.2 0.1-0.2 0.2q-0.1 0.1-0.1 0.1 0 0 0-0.1-0.1 0-0.1 0 0 0.5 0.1 0.9c0.1 0.1 0.3 0.2 0.4 0.2q0.1 0 0.1 0 0 0 0 0 0.1 0 0.2-0.1c1.6-0.9 3.7-1 5.5-0.9q0.1 0 0.1 0-0.4-0.3-0.8-0.5z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "cR",
    d: "m163.4 52.8q0.1 0 0-0.1c-1.5-0.5-2.9-0.8-4.5-0.3-0.7 0.2-0.9 0.7-0.3 1.1 0 0-0.2-0.5 0.1-0.6q0.1 0 0.2-0.1c-0.2 0.3-0.2 0.6 0 0.9 0-0.7 0.2-1 1.1-1 1.1 0 2.2 0 3.3 0.1q0.1 0 0.1 0z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m163.6 53c0 0-1.8-0.8-3.7-0.6-2.5 0.3-0.4 3.8 0.3 4 0 0-0.1-0.2 0.1-0.4 0.9-0.6 3.6-2.4 3.3-3z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "cZ",
    d: "m160.5 54c0.3 0.9 0.2 1.7-0.2 1.9-0.4 0.1-0.9-0.5-1.2-1.3-0.3-0.9-0.2-1.8 0.2-2 0.4-0.1 0.9 0.5 1.2 1.4z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "d0",
    d: "m159.9 54.2c0.2 0.5 0.1 1-0.1 1.1-0.2 0.1-0.5-0.3-0.6-0.7-0.2-0.5-0.2-1 0.1-1.1 0.2-0.1 0.5 0.3 0.6 0.7z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m159.8 53.2c0.1 0.2 0.1 0.4 0.1 0.5-0.1 0-0.3-0.1-0.4-0.3-0.1-0.1-0.1-0.3 0-0.4 0.1-0.1 0.2 0 0.3 0.2z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m160.2 54.1c0 0.1 0 0.2 0 0.2-0.1 0-0.1 0-0.2-0.1 0-0.1 0-0.2 0-0.3 0.1 0 0.1 0.1 0.2 0.2z"
  })), _g240 || (_g240 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp245)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cZ",
    d: "m160.5 54c-0.2 0.5-0.7 1-1.3 1 0.3 0.6 0.8 1 1.1 0.9 0.4-0.2 0.5-1 0.2-1.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _g241 || (_g241 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp246)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m169.6 55.5c0.3-2.1 0.2-4.3 0.4-6.4 0.2-1.5 1.2-1.5 2.4-1.9q1.3-0.5 2-1.4c1.1-1.9 0.5-3.4-1-3.8 0 0-25-3.5-26-1.4-3.7 8.4-0.4 19.3-0.4 19.3 0 0 0.4 2.6 6.4 1.2 1.7-0.4 11.2-2.2 13.6-2.6 2-0.6 2.5-1.7 2.6-3z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, _g242 || (_g242 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp247)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d1",
    d: "m173.4 42c0 0-6.9-1-13.6-1.6 1.9 0.4 3.9 0.7 5.6 1.5 1.2 0.5 1.8 1.4 1.6 2.7-0.4 2.6-0.5 5-0.3 7.6 0.1 1.8 0.3 3.5-0.9 5-0.7 1-1.9 1.6-3 2.1 1.8-0.4 3.4-0.6 4.2-0.8 2-0.6 2.5-1.7 2.6-3 0.3-2.1 0.2-4.3 0.4-6.4 0.2-1.5 1.2-1.5 2.4-1.9q1.3-0.5 2-1.4c1.1-1.9 0.5-3.4-1-3.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, _g243 || (_g243 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp248)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m159.8 41.4c-0.9 0-10.9 0.3-11.8 0.4-1.2 4.3-1.5 8.8-1 13.2q1.3 0.2 2.6 0.3c0-0.7 1.5-11.3 10.2-13.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, _g244 || (_g244 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp249)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m149.7 58.7q0.1 0.1 0.3 0.1-0.1-1-0.2-2.1c-0.9 0-1.7 0-2.6 0.1q0.2 0.9 0.4 1.9c0.7 0.1 1.4 0 2.1 0z"
  })))), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "d2",
    d: "m173.5 45c-0.3 0.6-0.9 0.8-1.5 0.5-0.5-0.3-0.7-1-0.4-1.5 0.3-0.6 1-0.8 1.5-0.5 0.5 0.3 0.7 1 0.4 1.5z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "cj",
    d: "m173.4 44.9c-0.3 0.5-0.8 0.7-1.3 0.4-0.4-0.2-0.6-0.8-0.3-1.2 0.2-0.5 0.8-0.7 1.2-0.4 0.5 0.2 0.6 0.8 0.4 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, _g245 || (_g245 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp250)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m172.7 44.3c-0.1 0.1-0.4 0.2-0.5 0.1-0.2-0.1-0.3-0.3-0.2-0.5 0.1-0.2 0.3-0.2 0.5-0.1 0.2 0.1 0.2 0.3 0.2 0.5z"
  })))), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "d3",
    d: "m150.3 61.7c-3.2 0-3.5-1.7-3.5-1.8-0.1-0.1-3.3-11 0.5-19.4 0.1-0.3 0.8-0.8 4.1-0.8 7.2 0 21.9 2.1 22.1 2.1 0.7 0.2 1.2 0.7 1.5 1.3 0.3 0.8 0.2 1.8-0.4 2.8q-0.8 1-2.2 1.4-0.3 0.1-0.5 0.2c-1 0.3-1.6 0.5-1.7 1.6-0.1 1.1-0.1 2.1-0.2 3.2 0 1.1-0.1 2.2-0.2 3.2-0.1 1.1-0.5 2.5-2.8 3.2l-1.3 0.2c-3.5 0.7-10.8 2-12.3 2.3q-1.8 0.5-3.1 0.5zm1.1-21.6c-3.2 0-3.7 0.4-3.8 0.6-3.7 8.2-0.5 19-0.5 19.1 0 0.1 0.3 1.5 3.2 1.5q1.3 0 3-0.4c1.5-0.4 8.8-1.7 12.3-2.3l1.3-0.3c2.1-0.6 2.5-1.8 2.6-2.8 0.1-1.1 0.1-2.2 0.2-3.2 0-1.1 0-2.2 0.1-3.2 0.2-1.4 1-1.6 2-1.9q0.2-0.1 0.5-0.2 1.3-0.4 2-1.3c0.5-0.9 0.6-1.8 0.4-2.5-0.3-0.5-0.7-0.9-1.3-1-0.1 0-14.9-2.1-22-2.1z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "d4",
    d: "m194.1 131.8q-1.8-1-3.6-1.9c-2.7-1.2-5.5-1.7-8.5-1.9-3.1-0.3-6.2-0.3-9.3-1.2-1.5-0.4-2.9-0.8-4.3-1.1-0.7-0.2-1.3-0.3-2-0.4q-0.5 0-0.9 0c-0.4 0-0.6 0.1-0.9 0.1q0.1 0 0.1-0.1c0-0.1-0.1 0-0.1 0q0 0.1 0 0.1c-0.1 0-0.2 0.1-0.1 0.2q0 0 0 0c-0.2 0.8-1 3.3-0.5 3.4 0.7 0.1 1.4 0.3 2.1 0.5 0.9 0.3 1.9 0.4 2.8 0.5 1.8 0.4 3.5 0.9 5.2 1.1 2 0.3 4 0.4 5.9 0.8 1.9 0.3 3.6 0.9 5.3 1.6 1.6 0.7 3.1 1.7 4.8 2.3q1.2 0.3 2.5 0.5c0.6 0 1.2 0.1 1.8-0.1 0.3-0.2 0.4-0.5 0.5-0.8 0.1-0.8 0.3-1.5 0.4-2.3 0.3-0.7-0.6-1-1.2-1.3z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m194.6 135c0 0.3 0 0.8-0.4 0.9-0.3 0.2-0.8 0.1-1.1 0-1.8-0.1-3.5-0.6-5.1-1.4-2.7-1.4-5.4-2.6-8.4-3.1-1.6-0.2-3.1-0.3-4.6-0.5-1.6-0.2-3.2-0.5-4.7-0.9-1.5-0.4-3.1-0.5-4.6-0.9q-0.4-0.2-0.8-0.3-0.3-0.1-0.6-0.1-0.3-0.4-0.2-0.9c0.1-0.7 0.3-1.5 0.5-2.2 0.3 0 0.8-0.1 1.1-0.1 0.7 0.1 1.5 0.2 2.2 0.3 1.3 0.3 2.7 0.7 4 1.1 2.5 0.7 5 1.1 7.7 1.2 2.8 0.1 5.5 0.3 8.3 1.1 1.3 0.4 2.6 1 3.8 1.7 0.5 0.3 3.2 1.3 3.4 2.1q0 0 0 0-0.3 1-0.5 2z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "d3",
    d: "m194.6 135c0 0.3 0 0.8-0.4 0.9-0.3 0.2-0.8 0.1-1.1 0-1.8-0.1-3.5-0.6-5.1-1.4-2.7-1.4-5.4-2.6-8.4-3.1-1.6-0.2-3.1-0.3-4.6-0.5-1.6-0.2-3.2-0.5-4.7-0.9-1.5-0.4-3.1-0.5-4.6-0.9q-0.4-0.2-0.8-0.3-0.3-0.1-0.6-0.1-0.3-0.4-0.2-0.9c0.1-0.7 0.3-1.5 0.5-2.2 0.3 0 0.8-0.1 1.1-0.1 0.7 0.1 1.5 0.2 2.2 0.3 1.3 0.3 2.7 0.7 4 1.1 2.5 0.7 5 1.1 7.7 1.2 2.8 0.1 5.5 0.3 8.3 1.1 1.3 0.4 2.6 1 3.8 1.7 0.5 0.3 3.2 1.3 3.4 2.1q0 0 0 0-0.3 1-0.5 2z"
  })), _g246 || (_g246 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp251)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d3",
    d: "m191.7 130.9c-1.2-0.7-2.5-1.3-3.8-1.7-2.8-0.8-5.5-1-8.3-1.1-2.7-0.1-5.2-0.5-7.7-1.2-1.3-0.4-2.7-0.8-4-1.1-0.7-0.1-1.5-0.2-2.2-0.3-0.3 0-0.8 0.1-1.1 0.1q-0.1 0.5-0.2 1c0.4 1.6 1.7 2 3.2 2.3 1.6 0.4 3.2 0.7 4.9 0.9 3.1 0.3 6.2 0.2 9.3 0.8 1.7 0.3 3.3 0.7 4.8 1.2 0.9 0.3 1.8 0.5 2.6 1.1 0.6 0.4 0.6 1.3 0.4 2.3 1.1 0.4 2.3 0.7 3.5 0.7 0.3 0.1 0.8 0.2 1.1 0 0.4-0.1 0.4-0.6 0.4-0.9q0.2-1 0.5-2 0 0 0 0c-0.2-0.8-2.9-1.8-3.4-2.1z"
  }))), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m171.1 76.7q0 0 0 0-0.1-0.1-0.1-0.1l-1.3-6.7q-0.1 0 0-0.1c0 0 1.9-1.4 4.4-2.8 2.4-1.3 5.9-3 9.1-3.4q0.1 0 0.2 0.1l2.8 4.9q0.1 0 0 0.1 0 0 0 0.1l-15 7.9q0 0-0.1 0z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m169.9 70l1.3 6.4 14.7-7.8-2.7-4.7c-5.8 0.8-12.5 5.5-13.3 6.1z"
  })), _g247 || (_g247 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp252)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m170.9 73.1c-0.3-1-0.6-2-0.2-3.1q0.2-0.5 0.5-0.9c-0.6 0.4-1.1 0.8-1.3 0.9l1.3 6.4 0.1-0.1c-0.1-1.1-0.2-2.2-0.4-3.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _g248 || (_g248 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp253)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m183.2 63.9c-2.3 0.3-4.8 1.3-7 2.3 1 0.6 1.3 2.5 1.2 3.4-0.1 1.5-2.4 2.3-3.4 3-1.1 0.8-2.4 2.2-2.8 3.7v0.1l14.7-7.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _g249 || (_g249 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp254)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m180.7 64.8c0.5 1.2 1 2.5 1.3 3.7 0.1 0.1 0 0.2-0.1 0.3-2.4 0.7-4.5 2.2-5.9 4.1q-0.5 0.7-0.8 1.4l10.7-5.7-2.7-4.7q-1.4 0.2-2.7 0.6 0.1 0.1 0.2 0.3z"
  })))), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m195.2 133.7c-0.7 0-1.3-0.4-1.3-0.4-3.8-2.6-16.2-3.7-22.8-4.3q-1.6-0.1-2.6-0.2-3.1-0.3-4.2-2c-0.9-1.3-0.5-2.7-0.4-2.8 0.1-2 3.1-43 6.6-47.3 3.5-4.1 8.1-6.1 8.4-6.2 3.1-2.1 6.9-2.1 7.7-2.1q0.1 0 0.1 0c0.2 0 2.6 0.3 6 11 2 6.4 3.1 21.5 3.5 30 0.6 11.8 0.7 22.1 0.3 23.1-0.3 1-0.9 1.2-1.3 1.2z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m186.6 68.6c-0.8 0-4.5 0.1-7.6 2.1-0.1 0-4.8 2-8.3 6.2-3.5 4.2-6.6 46.7-6.6 47.1 0 0.1-0.4 1.4 0.4 2.7q1.1 1.5 4 1.8 1.1 0.1 2.6 0.2c6.7 0.7 19.1 1.8 23 4.3 0 0 0.5 0.5 1.1 0.5q0.7 0 1.1-1c0.3-1 0.3-11.5-0.3-23.1-0.5-8.5-1.5-23.6-3.5-29.9-3.5-10.7-5.8-10.9-5.8-10.9q0 0-0.1 0z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m186.6 68.6c-0.8 0-4.5 0.1-7.6 2.1-0.1 0-4.8 2-8.3 6.2-3.5 4.2-6.6 46.7-6.6 47.1 0 0.1-0.4 1.4 0.4 2.7q1.1 1.5 4 1.8 1.1 0.1 2.6 0.2c6.7 0.7 19.1 1.8 23 4.3 0 0 0.5 0.5 1.1 0.5q0.7 0 1.1-1c0.3-1 0.3-11.5-0.3-23.1-0.5-8.5-1.5-23.6-3.5-29.9-3.5-10.7-5.8-10.9-5.8-10.9q0 0-0.1 0z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m186.6 68.6c-0.8 0-4.5 0.1-7.6 2.1-0.1 0-4.8 2-8.3 6.2-3.5 4.2-6.6 46.7-6.6 47.1 0 0.1-0.4 1.4 0.4 2.7q1.1 1.5 4 1.8 1.1 0.1 2.6 0.2c6.7 0.7 19.1 1.8 23 4.3 0 0 0.5 0.5 1.1 0.5q0.7 0 1.1-1c0.3-1 0.3-11.5-0.3-23.1-0.5-8.5-1.5-23.6-3.5-29.9-3.5-10.7-5.8-10.9-5.8-10.9q0 0-0.1 0z"
  })), _g250 || (_g250 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp255)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m164.8 126.5c-0.4-2 0.1-4.1 0.4-6.2q0.4-3.2 0.9-6.3c0-0.2 3.4 7.1 6.3 9.3-1.9-4.3-5.7-7.8-6-12.8-0.1-2.8 0.3-5.6 0.5-8.4 0.2-2.9 0.5-5.7 0.9-8.5q0.5-4.1 1.3-8c0.3-1.5 0.6-2.9 0.9-4.4 0.2-1.2 0.3-2.5 0.8-3.6 0.4-1 1.1-1.9 1.8-2.7q-1 0.9-1.9 2c-3.5 4.2-6.6 46.7-6.6 47.1 0 0.1-0.4 1.4 0.4 2.7q0.2 0.3 0.6 0.6-0.2-0.4-0.3-0.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _g251 || (_g251 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp256)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m196 109.4c-0.5-8.5-1.5-23.6-3.5-29.9-3.5-10.7-5.8-10.9-5.8-10.9q0 0-0.1 0c-0.8 0-4.5 0.1-7.6 2.1 0 0-1.4 0.6-3.2 1.8q1.7-0.8 3.6-1.2c0.5-0.1 1.4-0.3 1.6 0.3 0.2 0.8-0.2 1.4-0.8 1.7-2.6 1.3-4.2 3.4-5.1 6.2-0.9 2.6-1.2 5.3-1.4 8-0.3 6.3-0.7 12.7 0.1 18.9 0.2 1 0.4 2.1 0 3.1-0.4 0.8-1.2 1-2.1 1.2-1.3 0.2-2.7 0.4-4.1 0.3q-1.2-0.1-2.4-0.4-0.1 1.4-0.2 2.6c4.5 1.1 9.3 1.3 13.8 0.3 2.4-0.5 4.7-1.2 6.6-2.8 1.5-1.3 2.7-3 3.7-4.7 0.1-0.2 0.5-0.1 0.5 0.1-0.5 7-5.9 13.6-11.5 17.6 2.3-0.3 4.2-2.6 6.3-3.4 0.1 0 0.3 0.1 0.3 0.2-0.2 2.2-1 4.4-2.8 5.7-1.9 1.3-4.1 1.6-6.3 1.6-2.9 0.1-6.6 0.2-9-1.6-1-0.7-1.8-1.5-2.5-2.4q0 0.2 0 0.2c0 0.1-0.4 1.4 0.4 2.7q1.1 1.5 4 1.8 1.1 0.1 2.6 0.2c6.7 0.7 19.1 1.8 23 4.3 0 0 0.5 0.5 1.1 0.5q0.7 0 1.1-1c0.3-1 0.3-11.5-0.3-23.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _g252 || (_g252 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp257)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m196 109.4c-0.5-8.5-1.5-23.6-3.5-29.9-3.5-10.7-5.8-10.9-5.8-10.9q0 0-0.1 0c-0.5 0-2.6 0.1-4.8 0.8 0.7 1.1 1.3 2.4 1.8 3.6 0.9 2.1 1.8 4 2.4 6.2 1.1 4.5 0.9 9.1-0.1 13.6-0.6 2.6-1.3 5.1-2.3 7.6-0.7 1.9-1.4 3.9-2.6 5.5-1.3 1.8-3 3.1-4.8 4.2-0.9 0.5-1.8 1-2.7 1.4-0.8 0.3-1.6 0.5-2.3 1 1.6 0.4 3.3 0.2 5-0.1 1.4-0.3 2.8-0.5 4.2-0.9 1.7-0.6 3.1-1.4 4.1-2.8q1.4-2 2.3-4.3c1.1-2.9 1.4-9.5 2-12.4 0.8-3.5 3.8 11.3 2.7 15-1.7 5.7-5.5 10.6-9.9 14.6 1.7-0.8 3.2-1.8 4.6-2.8 1.2-1 4.2-3.1 5.2-4.2 1-1.1 1.7 13.4 0.5 14.5-0.9 0.9-2.5 0.3-3.5-0.1-1.1-0.5-2.2-1.2-3.4-1.1-1.3 0-2.6 0.4-3.9 0.6-2.3 0.3-4.7 0.6-7.1 0.5q-0.1 0-0.1 0c6.9 0.7 16.8 1.8 20.2 4 0 0 0.5 0.5 1.1 0.5q0.7 0 1.1-1c0.3-1 0.3-11.5-0.3-23.1z"
  })))), _g253 || (_g253 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp258)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m173 99.7c0.4 0.3 0.5 0.9 0.8 1.6q0.2 0.2 0.3 0.5-0.2-0.8-0.3-1.6c0-0.2 0.2-0.3 0.4-0.2q0.3 0.2 0.6 0.4-0.3-0.3-0.7-0.5c-0.2-0.2-0.5-0.4-0.7-0.6-0.2-0.1-1.1-0.5-0.7 0.1q0.1 0.1 0.3 0.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _g254 || (_g254 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp259)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m178.3 103.6c0.9 1.5 2 2 3.6 2.1-0.4-0.4-1-0.7-1.5-1q-0.5-0.3-0.9-0.6c-0.6-0.3-1.2-0.8-1.6-1.1q0.2 0.3 0.4 0.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _g255 || (_g255 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp260)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m176.4 101.9q-0.1-0.1-0.1-0.2-0.2-0.2-0.4-0.4 0.8 1 1.7 2c-0.4-0.6-0.7-1.1-1.2-1.4z"
  })))), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m151.1 106.3q-0.6-0.6-1.6-0.7c-1-0.2-2.1-0.4-3.1-0.5-1.9-0.2-3.7-0.4-5.6-0.4-1.8 0.2-3.6 0.8-5.2 1.9-0.9 0.6-1.5 1.4-2.1 2.2-0.6 1-0.7 1.9-0.6 3 0 1.4 0.2 2.7 0.2 4 0 1.1 0.5 1.8 1.5 2.2 0 0.1 0.1 0 0.2 0 0.6 0.6 1.5 0.9 2.3 0.3 0.9 0.5 2.1 0.5 3-0.1 1 0.5 2.2 1.1 2.7-0.3 0.3-0.6 0-1.2-0.4-1.6-0.3-0.4-0.7-0.6-1-0.9-0.2-0.2-0.5-0.3-0.7-0.5-0.3-0.2-0.3-0.4-0.2-0.6 0.7-0.9 1.5-1.7 2.6-1.9 1.3-0.1 2.5 0 3.8 0 0.9 0 3.3 0.2 4.2-0.7 1-0.7 0.8-2.2 0.6-3.3q-0.2-1-0.6-2.1z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m151.3 111.1q-0.1 0.1-0.1 0.1 0 0 0 0.1-0.2 0.2-0.3 0.3h-0.1c-0.8 0.6-2.4 0.4-3.2 0.4q-1.9 0-3.7 0c-0.9 0-1.6 0.2-2.3 0.7-0.7 0.7-1.3 1.6-1.8 2.5-0.1 0.1 0 0.1 0 0q0.2-0.2 0.4-0.5c0 0.2 0.2 0.4 0.5 0.7 0.6 0.4 1.3 0.9 1.7 1.5 0.6 0.8-0.1 1.7-1 1.5-0.4-0.1-0.8-0.3-1.2-0.5-0.8-0.4-1.8-0.3-2-1.4-0.2-0.7-0.2-1.5-0.3-2.2 0-1 0.8-1.8 1.4-2.6q0.6-1 1-2.2c0.1 0 0 0 0 0-0.5 1-1.1 1.9-1.8 2.8-0.4 0.5-0.9 1.2-0.9 1.9 0 0.9 0.1 1.9 0.3 2.7 0.1 0.8 0.9 0.9 1.6 1.1q0.2 0.1 0.4 0.2-0.3 0-0.5 0.1c-0.5 0.1-0.9 0-1.4-0.1-1-0.1-1.6-1-1.8-2-0.2-1.7 0.2-3.7 0.4-5.5q0 0 0 0h-0.1c0 0-0.1 0.1 0 0.1-0.2 0-0.5 3.3-0.5 3.6-0.1 0.8-0.2 1.8 0 2.6 0.2 0.5 0.5 0.9 0.9 1.2-0.8 0.3-1.8-0.2-2.2-1-0.4-0.6-0.4-1.4-0.5-2.1 0-0.8 0.1-1.7 0.2-2.5 0.1-0.7 0.3-1.4 0.3-2.1 0 0-0.1 0-0.1 0.1-0.1 1-0.4 2-0.6 3.1-0.1 1 0 2 0.1 3q0.1 0.5 0.4 1c-1-0.6-1.2-1.4-1.2-2.6 0-1.1 0-2.1-0.1-3.1-0.1-1.5 0.1-2.6 1-3.8 0.8-1 1.8-1.6 2.9-2.2 1.4-0.6 2.9-0.9 4.3-1.1 0.6 0.1 1.1 0.2 1.5 0.2 0.9 0.1 1.8 0.1 2.7 0.2q2.6 0.2 5.1 0.9 0.2 0.4 0.4 1c0.3 1.1 0.8 2.8 0.2 3.9z"
  })), _g256 || (_g256 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp261)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m134 113.7c0.1-0.9 0.4-1.7 0.5-2.5q0-0.2 0-0.3c-0.2 0.5-0.5 0.9-0.6 1.4-0.1 0.6-0.2 1.2-0.3 1.8-0.1 0.2-0.1 0.6-0.3 0.9q0 0 0 0.1c0 1.2 0.2 2 1.2 2.6q-0.3-0.5-0.4-1c-0.1-1-0.2-2-0.1-3z"
  }))), _g257 || (_g257 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp262)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m134.4 113q0-0.1 0-0.2 0.1-0.4 0.1-0.8-0.1 0.3-0.1 0.6 0 0.2 0 0.4z"
  }))), _g258 || (_g258 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp263)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m137.9 116.9c-0.2-0.8-0.3-1.8-0.3-2.7 0-0.7 0.5-1.4 0.9-1.9q0.6-0.8 1.1-1.5 0.2-0.5 0.4-0.9-0.6 0.7-1.3 1.5c-0.9 1-1.1 2.1-1.6 3.4 0 0.2-0.4 0.3-0.4 0-0.2-0.8-0.3-1.7-0.3-2.5-0.2 1.3-0.3 2.7-0.2 3.9 0.2 1 0.8 1.9 1.8 2 0.5 0.1 0.9 0.2 1.4 0.1q0.2-0.1 0.4-0.1-0.1-0.1-0.3-0.2c-0.7-0.2-1.5-0.3-1.6-1.1z"
  }))), _g259 || (_g259 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp264)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m151.1 107.2q-0.2-0.6-0.4-1-2.5-0.7-5.1-0.9 0 0 0 0c0.6 0.2 1.1 0.6 1.5 1.2 0.7 1-0.7 2.7-1.5 3.1-0.6 0.4-1.3 0.6-2 0.9-0.8 0.2-2.1 0.5-2.8 1.1-1.1 1.2-1.2 3.1-2.2 4.4-0.1 0.1-0.4 0-0.4-0.1-0.2-1.1-0.1-2.1 0.4-3.1q0.1-0.3 0.3-0.6c-0.5 0.7-1 1.3-1 2.1 0.1 0.7 0.1 1.5 0.3 2.2 0.2 1.1 1.2 1 2 1.4 0.4 0.2 0.8 0.4 1.2 0.5 0.9 0.2 1.6-0.7 1-1.5-0.4-0.6-1.1-1.1-1.7-1.5-0.3-0.3-0.5-0.5-0.5-0.7q-0.2 0.3-0.4 0.5c0 0.1-0.1 0.1 0 0 0.5-0.9 1.1-1.8 1.8-2.5 0.7-0.5 1.4-0.7 2.3-0.7q1.8 0 3.7 0c0.8 0 2.4 0.2 3.2-0.4h0.1q0.1-0.1 0.3-0.3 0-0.1 0-0.1 0 0 0.1-0.1c0.6-1.1 0.1-2.8-0.2-3.9z"
  }))), _g260 || (_g260 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp265)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m136 117c-0.2-0.8-0.1-1.8 0-2.6 0-0.3 0.2-2.5 0.4-3.3q-0.5 1.3-0.7 2.7c0 0.3-0.1 1.2-0.5 1.4-0.6 0.3-0.9-0.4-1-0.9q0 0 0-0.1 0 0.5 0 0.9c0.1 0.7 0.1 1.6 0.5 2.1 0.4 0.8 1.4 1.3 2.2 1-0.4-0.3-0.7-0.7-0.9-1.2z"
  }))), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m187.9 78.4c-0.6-2.1-2.4-4.9-4.9-5-2.3-0.7-5 1.6-5.9 3.7q-0.5 0.8-0.8 1.6c-0.4 0.9-0.4 1.9-0.6 2.8-0.2 1.1-0.5 2.2-0.7 3.3-0.3 2.3-0.3 4.6-0.4 6.9q-0.1 1.6-0.2 3.2-0.1 0.8-0.2 1.5c0 0.4 0 1-0.1 1.4q-0.1 0-0.3 0.1c-0.2 0-0.5 0.1-0.6 0.3-0.1 0.2 0 0.5 0.1 0.7-0.3-0.1-0.6-0.2-0.8-0.1-0.1 0-0.2 0.1-0.2 0.2q0 0 0 0.1 0.2 0.2 0.3 0.3-0.1 0-0.3-0.1c-0.8-0.1-1.7 0.1-2.5 0.3-1.3 0.3-2.5 0.7-3.8 0.9-2.5 0.4-4.9 0.8-7.4 1-1.2 0.1-2.3 0.4-3.5 0.5-0.6 0.1-1.2-0.1-1.9-0.1q-0.2 0-0.4 0.1c-0.3-0.1-0.7-0.1-1 0.2-0.4 0.4-0.3 1.3-0.8 1.5q-0.2 0-0.4 0.1c-0.3 0.1-0.5 0.1-0.8 0.2-0.3 0.1-0.5 0.4-0.5 0.6-0.2 0.4-0.1 0.8-0.1 1.1q0.3 1.2 0.4 2.4c0.2 1.3 0.5 2.8 1 4.1 0.3 0.7 1.2 0.5 2 0.2q0.1 0.1 0.2 0.2c0.6 0.3 1.5 0 2.1-0.1 3.8-0.7 7.7 0.3 11.4 0.3 3.9 0 7.8 0.1 11.7-0.5 1.3-0.2 2.8-0.4 3.9-1.3 1-0.7 1.6-1.8 2-2.9 0.6-1 1.1-2.1 1.4-3.3 0.5-1.6 0.9-3.4 1.3-5.1 0.9-3.6 1.2-7.4 1.5-11.1 0.3-3.4 0.8-6.9-0.2-10.2z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m187.6 90.1c-0.3 3.2-0.6 6.3-1.3 9.5-0.3 1.6-0.8 3.3-1.2 4.9-0.5 1.7-1.2 3.1-2 4.6q-0.1 0.1 0 0.1c-0.5 0.9-1.3 1.7-2.4 2.1-1.4 0.5-3 0.7-4.8 0.9-3.4 0.2-7 0.2-10.4 0.2-3.3 0-6.6-0.6-9.9-0.3-0.6 0.1-1.3 0.3-2 0.3-0.2 0-0.6 0-0.8-0.2q-0.3-0.2-0.3-0.4c-0.3-0.7-0.1-1.8-0.1-2.3 0.1-1 0-1.9-0.3-2.8q-0.2-0.3-0.4-0.7 0.4 1 0.4 2c0.1 1-0.1 1.9-0.1 2.9 0 0.5 0.1 0.9 0.3 1.3-0.6 0.2-1.2 0.3-1.5-0.5-0.4-1-0.6-2.1-0.8-3.2-0.1-0.9-0.2-1.8-0.4-2.8-0.2-0.6-0.3-1.3 0.6-1.5q0.4-0.1 0.7-0.2 0 0 0.1 0c0.2 0 0.5-0.2 0.6-0.4q0.1-0.4 0.2-0.8c0-0.3 0.3-0.5 0.6-0.5 0.4-0.1 0.8-0.1 1.3 0.1q0-0.1 0-0.1 0.4 0.1 0.9 0.2c1.2 0 2.4-0.4 3.5-0.6 2.4-0.3 4.8-0.4 7.1-0.9 1.1-0.2 2.1-0.3 3.2-0.6 1.1-0.3 2.3-0.7 3.4-0.6 1.2 0.1 1.6 1.3 2.1 2.2 0.4 0.7 0.7 1.4 1.2 1.9q0.3 0.2 0.6 0.3c-0.9-0.9-1.4-1.9-1.9-2.9-0.3-0.7-0.4-1.3-0.8-1.7q-0.2-0.1-0.3-0.2c-0.4-0.6 0.5-0.2 0.7-0.1 0.2 0.2 0.5 0.4 0.7 0.6 1.2 0.8 2.2 1.9 3.4 2.8 0.4 0.3 3.5 2.9 4 1.8q0-0.1-0.1-0.2 0 0.1 0 0.1c-0.1 0.7-2.2-0.9-2.4-1.1-0.9-0.6-1.7-1.2-2.5-1.9-0.8-0.6-1.5-1.4-2.3-2q-0.3-0.1-0.6-0.3 0-0.2-0.1-0.4 0-0.1-0.1-0.2c0-0.2 0.1-0.2 0.2-0.3 0.2-0.1 0.4-0.2 0.6-0.3 0.3-0.1 0.5-0.2 0.6-0.4q0 0-0.1 0-0.2 0.1-0.4 0.2 0.1-0.4 0.2-0.8 0.1-1.5 0.2-3.1c0.2-2.1 0.3-4.3 0.4-6.5 0.1-2.2 0.6-4.3 0.9-6.5 0.3-2 1.1-3.8 2.4-5.4 1.3-1.1 2.9-1.8 4.7-1.8 1.1 0.2 2.1 1 2.9 1.8 1.1 1.2 1.7 2.9 2 4.5 0.6 3.3 0 6.9-0.4 10.2z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m187.6 90.1c-0.3 3.2-0.6 6.3-1.3 9.5-0.3 1.6-0.8 3.3-1.2 4.9-0.5 1.7-1.2 3.1-2 4.6q-0.1 0.1 0 0.1c-0.5 0.9-1.3 1.7-2.4 2.1-1.4 0.5-3 0.7-4.8 0.9-3.4 0.2-7 0.2-10.4 0.2-3.3 0-6.6-0.6-9.9-0.3-0.6 0.1-1.3 0.3-2 0.3-0.2 0-0.6 0-0.8-0.2q-0.3-0.2-0.3-0.4c-0.3-0.7-0.1-1.8-0.1-2.3 0.1-1 0-1.9-0.3-2.8q-0.2-0.3-0.4-0.7 0.4 1 0.4 2c0.1 1-0.1 1.9-0.1 2.9 0 0.5 0.1 0.9 0.3 1.3-0.6 0.2-1.2 0.3-1.5-0.5-0.4-1-0.6-2.1-0.8-3.2-0.1-0.9-0.2-1.8-0.4-2.8-0.2-0.6-0.3-1.3 0.6-1.5q0.4-0.1 0.7-0.2 0 0 0.1 0c0.2 0 0.5-0.2 0.6-0.4q0.1-0.4 0.2-0.8c0-0.3 0.3-0.5 0.6-0.5 0.4-0.1 0.8-0.1 1.3 0.1q0-0.1 0-0.1 0.4 0.1 0.9 0.2c1.2 0 2.4-0.4 3.5-0.6 2.4-0.3 4.8-0.4 7.1-0.9 1.1-0.2 2.1-0.3 3.2-0.6 1.1-0.3 2.3-0.7 3.4-0.6 1.2 0.1 1.6 1.3 2.1 2.2 0.4 0.7 0.7 1.4 1.2 1.9q0.3 0.2 0.6 0.3c-0.9-0.9-1.4-1.9-1.9-2.9-0.3-0.7-0.4-1.3-0.8-1.7q-0.2-0.1-0.3-0.2c-0.4-0.6 0.5-0.2 0.7-0.1 0.2 0.2 0.5 0.4 0.7 0.6 1.2 0.8 2.2 1.9 3.4 2.8 0.4 0.3 3.5 2.9 4 1.8q0-0.1-0.1-0.2 0 0.1 0 0.1c-0.1 0.7-2.2-0.9-2.4-1.1-0.9-0.6-1.7-1.2-2.5-1.9-0.8-0.6-1.5-1.4-2.3-2q-0.3-0.1-0.6-0.3 0-0.2-0.1-0.4 0-0.1-0.1-0.2c0-0.2 0.1-0.2 0.2-0.3 0.2-0.1 0.4-0.2 0.6-0.3 0.3-0.1 0.5-0.2 0.6-0.4q0 0-0.1 0-0.2 0.1-0.4 0.2 0.1-0.4 0.2-0.8 0.1-1.5 0.2-3.1c0.2-2.1 0.3-4.3 0.4-6.5 0.1-2.2 0.6-4.3 0.9-6.5 0.3-2 1.1-3.8 2.4-5.4 1.3-1.1 2.9-1.8 4.7-1.8 1.1 0.2 2.1 1 2.9 1.8 1.1 1.2 1.7 2.9 2 4.5 0.6 3.3 0 6.9-0.4 10.2z"
  })), _g261 || (_g261 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp266)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m152.1 103.9c0.2-0.3 0.6-1.1 1.1-1 0.5 0 0.9 0.3 1.4 0.3 0.7 0 1.3-0.2 1.9-0.3q4.3-1 8.6-1.8c1.9-0.3 4.3-0.4 6.1-1.3-1 0-1.9 0.4-2.8 0.6-1.1 0.3-2.1 0.4-3.2 0.6-2.3 0.5-4.7 0.6-7.1 0.9-1.1 0.2-2.3 0.6-3.5 0.6q-0.5-0.1-0.9-0.2 0 0 0 0.1c-0.5-0.2-0.9-0.2-1.3-0.1-0.3 0-0.6 0.2-0.6 0.5q-0.1 0.4-0.2 0.8c-0.1 0.2-0.4 0.4-0.6 0.4q-0.1 0-0.1 0-0.3 0.1-0.7 0.2c-0.7 0.1-0.8 0.6-0.7 1.1 0.1-0.5 0.6-0.8 1.1-0.9 0.7-0.2 1 0.2 1.2 0.7q0.1-0.6 0.3-1.2z"
  }))), _g262 || (_g262 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp267)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m173.5 98.7q0.1 0.2 0.1 0.4 0.3 0.2 0.6 0.3c0.7 0.6 1.4 1.3 2.2 1.9q-0.3-0.3-0.7-0.7c-0.5-0.4-1-0.9-1.4-1.5 0-0.1 0-0.3 0.2-0.3 0.1-0.1 1.8-0.4 1.4-0.8-0.3-0.3-0.5-0.5-0.8-0.8-0.1-0.2 0-0.6 0-0.8 0.2-0.8 0.2-1.7 0.2-2.5 0.3-3.1 0.7-6.1 0.8-9.2 0.2-2.5 0.2-5.3 1.6-7.5 0.8-1.2 1.7-2.3 2.9-3.1q-1.2 0.5-2.2 1.4c-1.3 1.5-2.1 3.3-2.4 5.3-0.3 2.2-0.8 4.3-0.9 6.5-0.1 2.2-0.2 4.4-0.4 6.5q-0.1 1.6-0.2 3.1-0.1 0.4-0.2 0.8 0.2-0.1 0.4-0.2 0.1 0 0.1 0c-0.1 0.2-0.3 0.3-0.6 0.4-0.2 0.1-0.4 0.2-0.6 0.3-0.1 0.1-0.2 0.1-0.2 0.3q0.1 0.1 0.1 0.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _g263 || (_g263 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp268)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m188 79.9c-0.3-1.6-0.9-3.3-2-4.5-0.8-0.8-1.8-1.6-2.9-1.8q-1.4 0-2.6 0.5c1.6-0.1 3 1.3 3.4 2.8 0.3 0.8 0.4 1.6 0.1 2.5-0.3 0.9-1.3 1.2-1.7 2-0.5 1.2 1.2 2.4 1.4 3.5 0.2 1-0.4 2.1-0.7 3.1-1 2.9-1.7 6-2.4 9-0.3 1.1-0.5 2.3-0.8 3.5-0.2 0.6-0.4 1-1.1 1.2-0.9 0.3-1.9-0.2-2.8-0.8q0.3 0.3 0.6 0.5c0.8 0.7 1.6 1.3 2.5 1.9 0.2 0.2 2.3 1.8 2.4 1.1q0 0 0-0.1 0.1 0.1 0.1 0.2c-0.5 1.1-3.6-1.5-4-1.8q-0.9-0.7-1.6-1.4c1.1 1.3 2.3 2.6 3.4 3.9 0.5 0.7 2 2.4 0.8 3.2-0.9 0.7-2.4-0.5-3.1-1.2-1-1-1.5-2.2-2.1-3.5q0 0 0 0c0.2 1.3 0.3 2.6 0.4 4 0.1 0.1-0.1 0.2-0.2 0.2q-4.7 0.3-9.5 0.7c-1.5 0.1-3 0.2-4.6 0-1.1-0.1-2-0.7-3.1-1-1.6-0.4-1.9 1.3-2.8 2.2-0.5 0.5-1 0.4-1.6 0.1-0.7-0.4-0.7-1.6-0.9-2.2-0.2-0.9-0.6-1.8-1.1-2.6 0.2 1.5 0.3 3.1 0.2 4.7 0 0.2-0.3 0.4-0.4 0.2-0.6-0.8-1.1-1.6-1.4-2.5q0.1 0.5 0.1 1c0.2 1.1 0.4 2.2 0.8 3.2 0.3 0.8 0.9 0.7 1.5 0.5-0.2-0.4-0.3-0.8-0.3-1.3 0-1 0.2-1.9 0.1-2.9q0-1-0.4-2 0.2 0.4 0.4 0.7c0.3 0.9 0.4 1.8 0.3 2.8 0 0.5-0.2 1.6 0.1 2.3q0 0.2 0.3 0.4c0.2 0.2 0.6 0.2 0.8 0.2 0.7 0 1.4-0.2 2-0.3 3.3-0.3 6.6 0.3 9.9 0.3 3.4 0 7 0 10.4-0.2 1.8-0.2 3.4-0.4 4.8-0.9 1.1-0.4 1.9-1.2 2.4-2.1q-0.1 0 0-0.1c0.8-1.5 1.5-2.9 2-4.6 0.4-1.6 0.9-3.3 1.2-4.9 0.7-3.2 1-6.3 1.4-9.5 0.3-3.3 0.9-6.9 0.3-10.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _g264 || (_g264 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp269)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m150.6 111.4q0.1 0.2 0.2 0.3c0.3 0.8 0.9 0.7 1.5 0.5q-0.2-0.4-0.2-0.9c-0.5 0-1 0-1.5 0.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _g265 || (_g265 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp270)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m188 79.9c-0.3-1.6-0.9-3.3-2-4.5-0.8-0.8-1.8-1.6-2.9-1.8q-0.1 0-0.3 0c1.9 0.8 3.3 2.7 3.7 4.9 0.5 2.3 0.2 4.5 0 6.8-0.3 2.5-0.7 5-1.2 7.5-0.4 2.5-1.2 5.2-1.4 7.7-0.1 0.8 0 2.7-0.9 3-1.1 0.4-2.5-0.2-3.4-0.6q-0.9-0.3-1.7-0.7c0.6 0.6 1.2 1.2 1.9 1.6 0.4 0.3 0.8 0.5 1.3 0.7 0.2 0.1 0.3 0 0.3-0.1q0 0 0-0.1 0.1 0.1 0.1 0.2-0.1 0.1-0.1 0.2 0.3 0.2 0.7 0.5c1 0.9 0.9 2.5 0.4 3.7-0.6 1.3-2.2 1.6-3.4 1.6-1.1 0-2.2-0.2-3.2-0.2-1.3 0-2.5 0.2-3.8 0.4-2.5 0.3-5 0.2-7.5 0.2-2.5 0-4.9-0.4-7.4-0.2-1.3 0.1-2.3 0.5-3.5 0.8-0.5 0.2-1 0-1.3-0.4q0 0 0 0 0 0.4 0.1 0.7 0 0.2 0.3 0.4c0.2 0.2 0.6 0.2 0.8 0.2 0.7 0 1.4-0.2 2-0.3 3.3-0.3 6.6 0.3 9.9 0.3 3.4 0 7 0 10.4-0.2 1.8-0.2 3.4-0.4 4.8-0.9 1.1-0.4 1.9-1.2 2.4-2.1q-0.1 0 0-0.1c0.8-1.5 1.5-2.9 2-4.6 0.4-1.6 0.9-3.3 1.2-4.9 0.7-3.2 1-6.3 1.3-9.5 0.4-3.3 1-6.9 0.4-10.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBike);
export default __webpack_public_path__ + "static/media/leftBike.5de9420ace31672edb033b8681c9fc2d.svg";
export { ForwardRef as ReactComponent };